"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: notification/notification-messages.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fnotification%2Fnotification-messages.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardCanceled = exports.CardInactive = exports.CustomerRecoupment = exports.CustomerTransfer = exports.DisputeCreditReversal = exports.DisputeCredit = exports.CardPurchaseRefunded = exports.CardPurchaseReversed = exports.CardPurchaseAuthorized = exports.PurchaseRollover = exports.Purchase = exports.CardActivated = exports.CardReplaced = exports.CardOrdered = exports.CardShipped = exports.RecurringTransferFailed = exports.RecurringTransferSent = exports.RecurringTransferInsufficientFunds = exports.RecurringTransferReminder = exports.RecurringTransferAccountExpired = exports.MoneySentLimitExceeded = exports.MoneySentExpired = exports.MoneyRequestedRejected = exports.MoneyRequestedExpired = exports.MoneyRequested = exports.MoneyReceivedFromNonStep = exports.MoneyReceived = exports.AchP2pFailedInsufficientFunds = exports.AchP2pFailed = exports.AchP2pCancel = exports.AchP2pSuccess = exports.WithdrawReturn = exports.CardFundingFailed = exports.CardPayoutReversal = exports.CardFundingApproved = exports.AchOutFundingReturn = exports.AchOutFundingFailedInsufficientFunds = exports.AchOutFundingFailed = exports.AchOutFundingSuccess = exports.AchInFundingSuccess = exports.ReferralInvite = exports.ReferralUser = exports.ReferralRedemptionReminder = exports.StartedRedemption = exports.ReferralBonus = exports.RedeemerRewardRewarded = exports.RedeemerReward = exports.ReferralRewardReferral = exports.ReferralReward = exports.PurchaseType = void 0;
exports.BnplPaymentSuccessful = exports.BnplAlmostDue = exports.BillPaid = exports.PaymentCycleReminder = exports.OfferWillExpire = exports.OfferRewardReceived = exports.FamilyInviteSms = exports.FlexAutoPayFailed = exports.FlexBillDue = exports.OutstandingBill = exports.SponseeAddedDebitCard = exports.ContactHasJoinedStep = exports.SavingsGoal = exports.SavingsContributionMatchDeclined = exports.SavingsContributionMatched = exports.ContributedToSavingsGoal = exports.SponsorTurnedOffSavingsMatching = exports.SponsorAcceptedSavingsMatching = exports.SponsorCreatedSavingsGoal = exports.SponseeTurnedOffSavingsMatching = exports.SponseeCreatedSavingsGoal = exports.SponseeClosedSavingsGoalWithMatching = exports.PlaidExchangeLink = exports.AccountLinkExpired = exports.CardPinBlocked = exports.AtmWithdrawalInsufficientFunds = exports.Limit = exports.AtmWithdrawalLimitExceeded = exports.AtmWithdrawalAccessDisabled = exports.OutOfNetworkAtmWithdrawalAuthorized = exports.FreeOutOfNetworkAtmWithdrawalAuthorized = exports.IssuingDisputeUpdated = exports.InNetworkAtmWithdrawalAuthorized = exports.AtmWithdrawalAuthorized = exports.AtmWithdrawal = exports.AtmAccessDisabled = exports.TestMessage = exports.KycStatusUpdate = exports.KycSuccess = exports.KycFailed = exports.KycExpired = exports.UnlockCard = exports.LockCard = exports.FamilyInviteApproved = exports.FamilyInviteDenied = exports.JoinedFamily = exports.CosponsorFamilyInvite = exports.FamilyInvite = exports.CardPurchaseInsufficientFunds = exports.PurchaseCardLocked = void 0;
exports.UnrecognizedDeviceLogin = exports.AutoReloadManualReview = exports.AutoReloadFailed = exports.AutoReloadCompleted = exports.AdhocMessage = exports.CheckReturned = exports.CheckReleased = exports.CheckCleared = exports.BlackCardShippingDelay = exports.BlackCardShippingAhead = exports.BlackCardArrived = exports.StepBlackSubscribed = exports.CardInactiveSms = exports.GiftCardOrderFailed = exports.GiftCardOrderReady = exports.DepositSwitchFailed = exports.DepositSwitchSuccess = exports.DepositAmount = exports.DowngradedFromBlackTier = exports.SubscriptionRenewalFailed = exports.BlackTierInheritedManagedUser = exports.BlackTierInherited = exports.PlusTierEnrolledManagedUser = exports.PlusTierEnrolled = exports.SavingsInterest = exports.StockGraduationTransferSuccess = exports.StockDayTradeDetected = exports.CorporateAction = exports.StockSponseeApproved = exports.StockRiskLevelUpdate = exports.StockOrderFilled = exports.StockOrderRejected = exports.StockOrderCancelled = exports.ForeignPurchaseBlocked = exports.RefereeReminder = exports.MarketingMessage = exports.SponseeLeftFamily = exports.CreditScoreChanged = exports.CtaAvailable = exports.OtpRecovery = exports.OtpVerification = exports.OtpRequested = exports.AccountOwnerUpdated = exports.AuthorizedUserUpdated = exports.CryptoRoundUpSuccess = exports.CryptoGraduationTransferSuccess = exports.CryptoDisabled = exports.CryptoEnrollmentApproval = exports.BnplPastDue = exports.BnplPaymentFailed = void 0;
exports.purchaseTypeToJSON = exports.purchaseTypeFromJSON = exports.Notification = exports.LifecycleStoreRefresh = exports.ActivityUpdatedAccountUpdate = exports.ActivityUpdated = exports.SubscriptionMerchantCardUpdated = exports.ApplicationApproved = void 0;
const device_1 = require("../auth/device");
const device_check_metadata_1 = require("../auth/device-check-metadata");
const amount_1 = require("../common/amount");
const card_details_1 = require("../common/card-details");
const date_1 = require("../common/date");
const dispute_loss_reason_1 = require("../common/dispute-loss-reason");
const dispute_reason_1 = require("../common/dispute-reason");
const external_card_1 = require("../common/external-card");
const kyc_1 = require("../common/kyc");
const legal_name_1 = require("../common/legal-name");
const timestamp_1 = require("../google/protobuf/timestamp");
const notification_user_1 = require("./notification-user");
const protobufPackage = 'com.step.notification.proto';
var PurchaseType;
(function (PurchaseType) {
    PurchaseType["INVALID"] = "INVALID";
    PurchaseType["CASH"] = "CASH";
    PurchaseType["CREDIT"] = "CREDIT";
    PurchaseType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PurchaseType || (exports.PurchaseType = PurchaseType = {}));
function createBaseReferralReward() {
    return { referral: undefined };
}
exports.ReferralReward = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.referral)) {
            message.referral = exports.ReferralRewardReferral.fromJSON(object.referral);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referral !== undefined) {
            obj.referral = exports.ReferralRewardReferral.toJSON(message.referral);
        }
        return obj;
    },
    create(base) {
        return exports.ReferralReward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralReward();
        message.referral = (object.referral !== undefined && object.referral !== null)
            ? exports.ReferralRewardReferral.fromPartial(object.referral)
            : undefined;
        return message;
    },
};
function createBaseReferralRewardReferral() {
    return { amount: undefined, referred: undefined };
}
exports.ReferralRewardReferral = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.referred)) {
            message.referred = exports.ReferralUser.fromJSON(object.referred);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.referred !== undefined) {
            obj.referred = exports.ReferralUser.toJSON(message.referred);
        }
        return obj;
    },
    create(base) {
        return exports.ReferralRewardReferral.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralRewardReferral();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.referred = (object.referred !== undefined && object.referred !== null)
            ? exports.ReferralUser.fromPartial(object.referred)
            : undefined;
        return message;
    },
};
function createBaseRedeemerReward() {
    return { rewarded: undefined };
}
exports.RedeemerReward = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.rewarded)) {
            message.rewarded = exports.RedeemerRewardRewarded.fromJSON(object.rewarded);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewarded !== undefined) {
            obj.rewarded = exports.RedeemerRewardRewarded.toJSON(message.rewarded);
        }
        return obj;
    },
    create(base) {
        return exports.RedeemerReward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemerReward();
        message.rewarded = (object.rewarded !== undefined && object.rewarded !== null)
            ? exports.RedeemerRewardRewarded.fromPartial(object.rewarded)
            : undefined;
        return message;
    },
};
function createBaseRedeemerRewardRewarded() {
    return { amount: undefined, referredBy: undefined };
}
exports.RedeemerRewardRewarded = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.referredBy)) {
            message.referredBy = exports.ReferralUser.fromJSON(object.referredBy);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.referredBy !== undefined) {
            obj.referredBy = exports.ReferralUser.toJSON(message.referredBy);
        }
        return obj;
    },
    create(base) {
        return exports.RedeemerRewardRewarded.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemerRewardRewarded();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.referredBy = (object.referredBy !== undefined && object.referredBy !== null)
            ? exports.ReferralUser.fromPartial(object.referredBy)
            : undefined;
        return message;
    },
};
function createBaseReferralBonus() {
    return { amount: undefined };
}
exports.ReferralBonus = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.ReferralBonus.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralBonus();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        return message;
    },
};
function createBaseStartedRedemption() {
    return { redeemer: exports.ReferralUser.fromPartial({}), referrerReward: undefined };
}
exports.StartedRedemption = {
    fromJSON(object) {
        const message = {
            redeemer: isSet(object.redeemer)
                ? exports.ReferralUser.fromJSON(object.redeemer)
                : exports.ReferralUser.fromPartial({}),
        };
        if (isSet(object.referrerReward)) {
            message.referrerReward = amount_1.Amount.fromJSON(object.referrerReward);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.redeemer !== undefined) {
            obj.redeemer = exports.ReferralUser.toJSON(message.redeemer);
        }
        if (message.referrerReward !== undefined) {
            obj.referrerReward = amount_1.Amount.toJSON(message.referrerReward);
        }
        return obj;
    },
    create(base) {
        return exports.StartedRedemption.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStartedRedemption();
        message.redeemer = (object.redeemer !== undefined && object.redeemer !== null)
            ? exports.ReferralUser.fromPartial(object.redeemer)
            : exports.ReferralUser.fromPartial({});
        message.referrerReward = (object.referrerReward !== undefined && object.referrerReward !== null)
            ? amount_1.Amount.fromPartial(object.referrerReward)
            : undefined;
        return message;
    },
};
function createBaseReferralRedemptionReminder() {
    return { redeemer: exports.ReferralUser.fromPartial({}), referrerReward: undefined };
}
exports.ReferralRedemptionReminder = {
    fromJSON(object) {
        const message = {
            redeemer: isSet(object.redeemer)
                ? exports.ReferralUser.fromJSON(object.redeemer)
                : exports.ReferralUser.fromPartial({}),
        };
        if (isSet(object.referrerReward)) {
            message.referrerReward = amount_1.Amount.fromJSON(object.referrerReward);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.redeemer !== undefined) {
            obj.redeemer = exports.ReferralUser.toJSON(message.redeemer);
        }
        if (message.referrerReward !== undefined) {
            obj.referrerReward = amount_1.Amount.toJSON(message.referrerReward);
        }
        return obj;
    },
    create(base) {
        return exports.ReferralRedemptionReminder.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralRedemptionReminder();
        message.redeemer = (object.redeemer !== undefined && object.redeemer !== null)
            ? exports.ReferralUser.fromPartial(object.redeemer)
            : exports.ReferralUser.fromPartial({});
        message.referrerReward = (object.referrerReward !== undefined && object.referrerReward !== null)
            ? amount_1.Amount.fromPartial(object.referrerReward)
            : undefined;
        return message;
    },
};
function createBaseReferralUser() {
    return { name: '', picture: '' };
}
exports.ReferralUser = {
    fromJSON(object) {
        const message = {
            name: isSet(object.name) ? globalThis.String(object.name) : '',
        };
        if (isSet(object.picture)) {
            message.picture = globalThis.String(object.picture);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.picture !== undefined && message.picture !== '') {
            obj.picture = message.picture;
        }
        return obj;
    },
    create(base) {
        return exports.ReferralUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralUser();
        message.name = object.name ?? '';
        message.picture = object.picture ?? '';
        return message;
    },
};
function createBaseReferralInvite() {
    return { link: '', senderName: legal_name_1.LegalName.fromPartial({}), reward: amount_1.Amount.fromPartial({}) };
}
exports.ReferralInvite = {
    fromJSON(object) {
        const message = {
            link: isSet(object.link) ? globalThis.String(object.link) : '',
            senderName: isSet(object.senderName)
                ? legal_name_1.LegalName.fromJSON(object.senderName)
                : legal_name_1.LegalName.fromPartial({}),
            reward: isSet(object.reward) ? amount_1.Amount.fromJSON(object.reward) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.link !== '') {
            obj.link = message.link;
        }
        if (message.senderName !== undefined) {
            obj.senderName = legal_name_1.LegalName.toJSON(message.senderName);
        }
        if (message.reward !== undefined) {
            obj.reward = amount_1.Amount.toJSON(message.reward);
        }
        return obj;
    },
    create(base) {
        return exports.ReferralInvite.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralInvite();
        message.link = object.link ?? '';
        message.senderName = (object.senderName !== undefined && object.senderName !== null)
            ? legal_name_1.LegalName.fromPartial(object.senderName)
            : legal_name_1.LegalName.fromPartial({});
        message.reward = (object.reward !== undefined && object.reward !== null)
            ? amount_1.Amount.fromPartial(object.reward)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseAchInFundingSuccess() {
    return {
        primaryAccountId: '',
        paymentId: '',
        amount: amount_1.Amount.fromPartial({}),
        senderName: '',
        numberOfDaysEarly: 0,
        newBalance: amount_1.Amount.fromPartial({}),
        isPayroll: false,
        customer: undefined,
    };
}
exports.AchInFundingSuccess = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            newBalance: isSet(object.newBalance)
                ? amount_1.Amount.fromJSON(object.newBalance)
                : amount_1.Amount.fromPartial({}),
            isPayroll: isSet(object.isPayroll) ? globalThis.Boolean(object.isPayroll) : false,
        };
        if (isSet(object.senderName)) {
            message.senderName = globalThis.String(object.senderName);
        }
        if (isSet(object.numberOfDaysEarly)) {
            message.numberOfDaysEarly = globalThis.Number(object.numberOfDaysEarly);
        }
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.senderName !== undefined && message.senderName !== '') {
            obj.senderName = message.senderName;
        }
        if (message.numberOfDaysEarly !== undefined && message.numberOfDaysEarly !== 0) {
            obj.numberOfDaysEarly = Math.round(message.numberOfDaysEarly);
        }
        if (message.newBalance !== undefined) {
            obj.newBalance = amount_1.Amount.toJSON(message.newBalance);
        }
        if (message.isPayroll !== false) {
            obj.isPayroll = message.isPayroll;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.AchInFundingSuccess.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchInFundingSuccess();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.senderName = object.senderName ?? '';
        message.numberOfDaysEarly = object.numberOfDaysEarly ?? 0;
        message.newBalance = (object.newBalance !== undefined && object.newBalance !== null)
            ? amount_1.Amount.fromPartial(object.newBalance)
            : amount_1.Amount.fromPartial({});
        message.isPayroll = object.isPayroll ?? false;
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseAchOutFundingSuccess() {
    return { primaryAccountId: '', paymentId: '', amount: amount_1.Amount.fromPartial({}), bankName: '' };
}
exports.AchOutFundingSuccess = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            bankName: isSet(object.bankName) ? globalThis.String(object.bankName) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.bankName !== '') {
            obj.bankName = message.bankName;
        }
        return obj;
    },
    create(base) {
        return exports.AchOutFundingSuccess.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutFundingSuccess();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.bankName = object.bankName ?? '';
        return message;
    },
};
function createBaseAchOutFundingFailed() {
    return { primaryAccountId: '', paymentId: '', bankName: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.AchOutFundingFailed = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            bankName: isSet(object.bankName) ? globalThis.String(object.bankName) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.bankName !== '') {
            obj.bankName = message.bankName;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutFundingFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutFundingFailed();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.bankName = object.bankName ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseAchOutFundingFailedInsufficientFunds() {
    return { primaryAccountId: '', paymentId: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.AchOutFundingFailedInsufficientFunds = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutFundingFailedInsufficientFunds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutFundingFailedInsufficientFunds();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseAchOutFundingReturn() {
    return { primaryAccountId: '', paymentId: '', bankName: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.AchOutFundingReturn = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            bankName: isSet(object.bankName) ? globalThis.String(object.bankName) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.bankName !== '') {
            obj.bankName = message.bankName;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutFundingReturn.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutFundingReturn();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.bankName = object.bankName ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseCardFundingApproved() {
    return { primaryAccountId: '', paymentId: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.CardFundingApproved = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.CardFundingApproved.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardFundingApproved();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseCardPayoutReversal() {
    return { primaryAccountId: '', paymentId: '', panSuffix: '' };
}
exports.CardPayoutReversal = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            panSuffix: isSet(object.panSuffix) ? globalThis.String(object.panSuffix) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.panSuffix !== '') {
            obj.panSuffix = message.panSuffix;
        }
        return obj;
    },
    create(base) {
        return exports.CardPayoutReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPayoutReversal();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.panSuffix = object.panSuffix ?? '';
        return message;
    },
};
function createBaseCardFundingFailed() {
    return { primaryAccountId: '', paymentId: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.CardFundingFailed = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.CardFundingFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardFundingFailed();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseWithdrawReturn() {
    return { primaryAccountId: '', paymentId: '', bankName: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.WithdrawReturn = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            bankName: isSet(object.bankName) ? globalThis.String(object.bankName) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.bankName !== '') {
            obj.bankName = message.bankName;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.WithdrawReturn.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWithdrawReturn();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.bankName = object.bankName ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseAchP2pSuccess() {
    return {
        primaryAccountId: '',
        paymentId: '',
        amount: amount_1.Amount.fromPartial({}),
        to: notification_user_1.NotificationUser.fromPartial({}),
    };
}
exports.AchP2pSuccess = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            to: isSet(object.to)
                ? notification_user_1.NotificationUser.fromJSON(object.to)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.to !== undefined) {
            obj.to = notification_user_1.NotificationUser.toJSON(message.to);
        }
        return obj;
    },
    create(base) {
        return exports.AchP2pSuccess.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchP2pSuccess();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.to = (object.to !== undefined && object.to !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.to)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseAchP2pCancel() {
    return { primaryAccountId: '', paymentId: '', amount: amount_1.Amount.fromPartial({}), to: undefined };
}
exports.AchP2pCancel = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.to)) {
            message.to = notification_user_1.NotificationUser.fromJSON(object.to);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.to !== undefined) {
            obj.to = notification_user_1.NotificationUser.toJSON(message.to);
        }
        return obj;
    },
    create(base) {
        return exports.AchP2pCancel.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchP2pCancel();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.to = (object.to !== undefined && object.to !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.to)
            : undefined;
        return message;
    },
};
function createBaseAchP2pFailed() {
    return {
        primaryAccountId: '',
        paymentId: '',
        bankName: '',
        amount: amount_1.Amount.fromPartial({}),
        to: undefined,
    };
}
exports.AchP2pFailed = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            bankName: isSet(object.bankName) ? globalThis.String(object.bankName) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.to)) {
            message.to = notification_user_1.NotificationUser.fromJSON(object.to);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.bankName !== '') {
            obj.bankName = message.bankName;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.to !== undefined) {
            obj.to = notification_user_1.NotificationUser.toJSON(message.to);
        }
        return obj;
    },
    create(base) {
        return exports.AchP2pFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchP2pFailed();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.bankName = object.bankName ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.to = (object.to !== undefined && object.to !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.to)
            : undefined;
        return message;
    },
};
function createBaseAchP2pFailedInsufficientFunds() {
    return { primaryAccountId: '', paymentId: '', amount: amount_1.Amount.fromPartial({}), to: undefined };
}
exports.AchP2pFailedInsufficientFunds = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.to)) {
            message.to = notification_user_1.NotificationUser.fromJSON(object.to);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.to !== undefined) {
            obj.to = notification_user_1.NotificationUser.toJSON(message.to);
        }
        return obj;
    },
    create(base) {
        return exports.AchP2pFailedInsufficientFunds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchP2pFailedInsufficientFunds();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.to = (object.to !== undefined && object.to !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.to)
            : undefined;
        return message;
    },
};
function createBaseMoneyReceived() {
    return {
        primaryAccountId: '',
        paymentId: '',
        amount: amount_1.Amount.fromPartial({}),
        newBalance: amount_1.Amount.fromPartial({}),
        from: notification_user_1.NotificationUser.fromPartial({}),
        description: '',
    };
}
exports.MoneyReceived = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            newBalance: isSet(object.newBalance)
                ? amount_1.Amount.fromJSON(object.newBalance)
                : amount_1.Amount.fromPartial({}),
            from: isSet(object.from)
                ? notification_user_1.NotificationUser.fromJSON(object.from)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.newBalance !== undefined) {
            obj.newBalance = amount_1.Amount.toJSON(message.newBalance);
        }
        if (message.from !== undefined) {
            obj.from = notification_user_1.NotificationUser.toJSON(message.from);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.MoneyReceived.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoneyReceived();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.newBalance = (object.newBalance !== undefined && object.newBalance !== null)
            ? amount_1.Amount.fromPartial(object.newBalance)
            : amount_1.Amount.fromPartial({});
        message.from = (object.from !== undefined && object.from !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.from)
            : notification_user_1.NotificationUser.fromPartial({});
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseMoneyReceivedFromNonStep() {
    return {
        primaryAccountId: '',
        paymentId: '',
        amount: amount_1.Amount.fromPartial({}),
        newBalance: amount_1.Amount.fromPartial({}),
        senderFullName: '',
    };
}
exports.MoneyReceivedFromNonStep = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            newBalance: isSet(object.newBalance)
                ? amount_1.Amount.fromJSON(object.newBalance)
                : amount_1.Amount.fromPartial({}),
            senderFullName: isSet(object.senderFullName) ? globalThis.String(object.senderFullName) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.newBalance !== undefined) {
            obj.newBalance = amount_1.Amount.toJSON(message.newBalance);
        }
        if (message.senderFullName !== '') {
            obj.senderFullName = message.senderFullName;
        }
        return obj;
    },
    create(base) {
        return exports.MoneyReceivedFromNonStep.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoneyReceivedFromNonStep();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.newBalance = (object.newBalance !== undefined && object.newBalance !== null)
            ? amount_1.Amount.fromPartial(object.newBalance)
            : amount_1.Amount.fromPartial({});
        message.senderFullName = object.senderFullName ?? '';
        return message;
    },
};
function createBaseMoneyRequested() {
    return {
        transferRequestId: '',
        amount: amount_1.Amount.fromPartial({}),
        from: notification_user_1.NotificationUser.fromPartial({}),
        description: '',
    };
}
exports.MoneyRequested = {
    fromJSON(object) {
        const message = {
            transferRequestId: isSet(object.transferRequestId)
                ? globalThis.String(object.transferRequestId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            from: isSet(object.from)
                ? notification_user_1.NotificationUser.fromJSON(object.from)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferRequestId !== '') {
            obj.transferRequestId = message.transferRequestId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.from !== undefined) {
            obj.from = notification_user_1.NotificationUser.toJSON(message.from);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.MoneyRequested.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoneyRequested();
        message.transferRequestId = object.transferRequestId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.from = (object.from !== undefined && object.from !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.from)
            : notification_user_1.NotificationUser.fromPartial({});
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseMoneyRequestedExpired() {
    return {
        transferRequestId: '',
        phoneNumber: '',
        amount: amount_1.Amount.fromPartial({}),
        description: '',
    };
}
exports.MoneyRequestedExpired = {
    fromJSON(object) {
        const message = {
            transferRequestId: isSet(object.transferRequestId)
                ? globalThis.String(object.transferRequestId)
                : '',
            phoneNumber: isSet(object.phoneNumber) ? globalThis.String(object.phoneNumber) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferRequestId !== '') {
            obj.transferRequestId = message.transferRequestId;
        }
        if (message.phoneNumber !== '') {
            obj.phoneNumber = message.phoneNumber;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.MoneyRequestedExpired.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoneyRequestedExpired();
        message.transferRequestId = object.transferRequestId ?? '';
        message.phoneNumber = object.phoneNumber ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseMoneyRequestedRejected() {
    return { transferRequestId: '', amount: amount_1.Amount.fromPartial({}), description: '' };
}
exports.MoneyRequestedRejected = {
    fromJSON(object) {
        const message = {
            transferRequestId: isSet(object.transferRequestId)
                ? globalThis.String(object.transferRequestId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferRequestId !== '') {
            obj.transferRequestId = message.transferRequestId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.MoneyRequestedRejected.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoneyRequestedRejected();
        message.transferRequestId = object.transferRequestId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseMoneySentExpired() {
    return { transferRequestId: '', paymentId: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.MoneySentExpired = {
    fromJSON(object) {
        const message = {
            transferRequestId: isSet(object.transferRequestId)
                ? globalThis.String(object.transferRequestId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferRequestId !== '') {
            obj.transferRequestId = message.transferRequestId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.MoneySentExpired.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoneySentExpired();
        message.transferRequestId = object.transferRequestId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseMoneySentLimitExceeded() {
    return { transferRequestId: '', paymentId: '', phoneNumber: '' };
}
exports.MoneySentLimitExceeded = {
    fromJSON(object) {
        const message = {
            transferRequestId: isSet(object.transferRequestId)
                ? globalThis.String(object.transferRequestId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            phoneNumber: isSet(object.phoneNumber) ? globalThis.String(object.phoneNumber) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferRequestId !== '') {
            obj.transferRequestId = message.transferRequestId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.phoneNumber !== '') {
            obj.phoneNumber = message.phoneNumber;
        }
        return obj;
    },
    create(base) {
        return exports.MoneySentLimitExceeded.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoneySentLimitExceeded();
        message.transferRequestId = object.transferRequestId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.phoneNumber = object.phoneNumber ?? '';
        return message;
    },
};
function createBaseRecurringTransferAccountExpired() {
    return { recurringTransferId: '' };
}
exports.RecurringTransferAccountExpired = {
    fromJSON(object) {
        const message = {
            recurringTransferId: isSet(object.recurringTransferId)
                ? globalThis.String(object.recurringTransferId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.recurringTransferId !== '') {
            obj.recurringTransferId = message.recurringTransferId;
        }
        return obj;
    },
    create(base) {
        return exports.RecurringTransferAccountExpired.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringTransferAccountExpired();
        message.recurringTransferId = object.recurringTransferId ?? '';
        return message;
    },
};
function createBaseRecurringTransferReminder() {
    return {
        recurringTransferId: '',
        to: undefined,
        amount: amount_1.Amount.fromPartial({}),
        scheduledInDays: 0,
        isAch: false,
        savingsGoalName: '',
    };
}
exports.RecurringTransferReminder = {
    fromJSON(object) {
        const message = {
            recurringTransferId: isSet(object.recurringTransferId)
                ? globalThis.String(object.recurringTransferId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            isAch: isSet(object.isAch) ? globalThis.Boolean(object.isAch) : false,
        };
        if (isSet(object.to)) {
            message.to = notification_user_1.NotificationUser.fromJSON(object.to);
        }
        if (isSet(object.scheduledInDays)) {
            message.scheduledInDays = globalThis.Number(object.scheduledInDays);
        }
        if (isSet(object.savingsGoalName)) {
            message.savingsGoalName = globalThis.String(object.savingsGoalName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.recurringTransferId !== '') {
            obj.recurringTransferId = message.recurringTransferId;
        }
        if (message.to !== undefined) {
            obj.to = notification_user_1.NotificationUser.toJSON(message.to);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.scheduledInDays !== undefined && message.scheduledInDays !== 0) {
            obj.scheduledInDays = Math.round(message.scheduledInDays);
        }
        if (message.isAch !== false) {
            obj.isAch = message.isAch;
        }
        if (message.savingsGoalName !== undefined && message.savingsGoalName !== '') {
            obj.savingsGoalName = message.savingsGoalName;
        }
        return obj;
    },
    create(base) {
        return exports.RecurringTransferReminder.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringTransferReminder();
        message.recurringTransferId = object.recurringTransferId ?? '';
        message.to = (object.to !== undefined && object.to !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.to)
            : undefined;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.scheduledInDays = object.scheduledInDays ?? 0;
        message.isAch = object.isAch ?? false;
        message.savingsGoalName = object.savingsGoalName ?? '';
        return message;
    },
};
function createBaseRecurringTransferInsufficientFunds() {
    return {
        recurringTransferId: '',
        to: undefined,
        transferDate: date_1.LocalDate.fromPartial({}),
        externalAccountName: '',
        savingsGoalName: '',
    };
}
exports.RecurringTransferInsufficientFunds = {
    fromJSON(object) {
        const message = {
            recurringTransferId: isSet(object.recurringTransferId)
                ? globalThis.String(object.recurringTransferId)
                : '',
            transferDate: isSet(object.transferDate)
                ? date_1.LocalDate.fromJSON(object.transferDate)
                : date_1.LocalDate.fromPartial({}),
        };
        if (isSet(object.to)) {
            message.to = notification_user_1.NotificationUser.fromJSON(object.to);
        }
        if (isSet(object.externalAccountName)) {
            message.externalAccountName = globalThis.String(object.externalAccountName);
        }
        if (isSet(object.savingsGoalName)) {
            message.savingsGoalName = globalThis.String(object.savingsGoalName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.recurringTransferId !== '') {
            obj.recurringTransferId = message.recurringTransferId;
        }
        if (message.to !== undefined) {
            obj.to = notification_user_1.NotificationUser.toJSON(message.to);
        }
        if (message.transferDate !== undefined) {
            obj.transferDate = date_1.LocalDate.toJSON(message.transferDate);
        }
        if (message.externalAccountName !== undefined && message.externalAccountName !== '') {
            obj.externalAccountName = message.externalAccountName;
        }
        if (message.savingsGoalName !== undefined && message.savingsGoalName !== '') {
            obj.savingsGoalName = message.savingsGoalName;
        }
        return obj;
    },
    create(base) {
        return exports.RecurringTransferInsufficientFunds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringTransferInsufficientFunds();
        message.recurringTransferId = object.recurringTransferId ?? '';
        message.to = (object.to !== undefined && object.to !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.to)
            : undefined;
        message.transferDate = (object.transferDate !== undefined && object.transferDate !== null)
            ? date_1.LocalDate.fromPartial(object.transferDate)
            : date_1.LocalDate.fromPartial({});
        message.externalAccountName = object.externalAccountName ?? '';
        message.savingsGoalName = object.savingsGoalName ?? '';
        return message;
    },
};
function createBaseRecurringTransferSent() {
    return {
        recurringTransferId: '',
        to: undefined,
        paymentId: '',
        amount: amount_1.Amount.fromPartial({}),
        isAch: false,
        savingsGoalName: '',
        nextTransfer: undefined,
        transferDate: undefined,
    };
}
exports.RecurringTransferSent = {
    fromJSON(object) {
        const message = {
            recurringTransferId: isSet(object.recurringTransferId)
                ? globalThis.String(object.recurringTransferId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            isAch: isSet(object.isAch) ? globalThis.Boolean(object.isAch) : false,
        };
        if (isSet(object.to)) {
            message.to = notification_user_1.NotificationUser.fromJSON(object.to);
        }
        if (isSet(object.savingsGoalName)) {
            message.savingsGoalName = globalThis.String(object.savingsGoalName);
        }
        if (isSet(object.nextTransfer)) {
            message.nextTransfer = date_1.LocalDate.fromJSON(object.nextTransfer);
        }
        if (isSet(object.transferDate)) {
            message.transferDate = date_1.LocalDate.fromJSON(object.transferDate);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.recurringTransferId !== '') {
            obj.recurringTransferId = message.recurringTransferId;
        }
        if (message.to !== undefined) {
            obj.to = notification_user_1.NotificationUser.toJSON(message.to);
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.isAch !== false) {
            obj.isAch = message.isAch;
        }
        if (message.savingsGoalName !== undefined && message.savingsGoalName !== '') {
            obj.savingsGoalName = message.savingsGoalName;
        }
        if (message.nextTransfer !== undefined) {
            obj.nextTransfer = date_1.LocalDate.toJSON(message.nextTransfer);
        }
        if (message.transferDate !== undefined) {
            obj.transferDate = date_1.LocalDate.toJSON(message.transferDate);
        }
        return obj;
    },
    create(base) {
        return exports.RecurringTransferSent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringTransferSent();
        message.recurringTransferId = object.recurringTransferId ?? '';
        message.to = (object.to !== undefined && object.to !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.to)
            : undefined;
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.isAch = object.isAch ?? false;
        message.savingsGoalName = object.savingsGoalName ?? '';
        message.nextTransfer = (object.nextTransfer !== undefined && object.nextTransfer !== null)
            ? date_1.LocalDate.fromPartial(object.nextTransfer)
            : undefined;
        message.transferDate = (object.transferDate !== undefined && object.transferDate !== null)
            ? date_1.LocalDate.fromPartial(object.transferDate)
            : undefined;
        return message;
    },
};
function createBaseRecurringTransferFailed() {
    return {
        recurringTransferId: '',
        to: undefined,
        amount: amount_1.Amount.fromPartial({}),
        paymentId: '',
        savingsGoalName: '',
    };
}
exports.RecurringTransferFailed = {
    fromJSON(object) {
        const message = {
            recurringTransferId: isSet(object.recurringTransferId)
                ? globalThis.String(object.recurringTransferId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.to)) {
            message.to = notification_user_1.NotificationUser.fromJSON(object.to);
        }
        if (isSet(object.paymentId)) {
            message.paymentId = globalThis.String(object.paymentId);
        }
        if (isSet(object.savingsGoalName)) {
            message.savingsGoalName = globalThis.String(object.savingsGoalName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.recurringTransferId !== '') {
            obj.recurringTransferId = message.recurringTransferId;
        }
        if (message.to !== undefined) {
            obj.to = notification_user_1.NotificationUser.toJSON(message.to);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.paymentId !== undefined && message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.savingsGoalName !== undefined && message.savingsGoalName !== '') {
            obj.savingsGoalName = message.savingsGoalName;
        }
        return obj;
    },
    create(base) {
        return exports.RecurringTransferFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringTransferFailed();
        message.recurringTransferId = object.recurringTransferId ?? '';
        message.to = (object.to !== undefined && object.to !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.to)
            : undefined;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.paymentId = object.paymentId ?? '';
        message.savingsGoalName = object.savingsGoalName ?? '';
        return message;
    },
};
function createBaseCardShipped() {
    return {
        cardId: '',
        eta: undefined,
        customer: undefined,
        cardProgramType: card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE,
    };
}
exports.CardShipped = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.eta)) {
            message.eta = fromJsonTimestamp(object.eta);
        }
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        if (isSet(object.cardProgramType)) {
            message.cardProgramType = (0, card_details_1.cardProgramTypeFromJSON)(object.cardProgramType);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.eta !== undefined) {
            obj.eta = fromTimestamp(message.eta).toISOString();
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        if (message.cardProgramType !== undefined &&
            message.cardProgramType !== card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE) {
            obj.cardProgramType = (0, card_details_1.cardProgramTypeToJSON)(message.cardProgramType);
        }
        return obj;
    },
    create(base) {
        return exports.CardShipped.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardShipped();
        message.cardId = object.cardId ?? '';
        message.eta = (object.eta !== undefined && object.eta !== null)
            ? timestamp_1.Timestamp.fromPartial(object.eta)
            : undefined;
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        message.cardProgramType = object.cardProgramType ?? card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE;
        return message;
    },
};
function createBaseCardOrdered() {
    return { cardId: '', eta: undefined, cardProgramType: card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE };
}
exports.CardOrdered = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.eta)) {
            message.eta = fromJsonTimestamp(object.eta);
        }
        if (isSet(object.cardProgramType)) {
            message.cardProgramType = (0, card_details_1.cardProgramTypeFromJSON)(object.cardProgramType);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.eta !== undefined) {
            obj.eta = fromTimestamp(message.eta).toISOString();
        }
        if (message.cardProgramType !== undefined &&
            message.cardProgramType !== card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE) {
            obj.cardProgramType = (0, card_details_1.cardProgramTypeToJSON)(message.cardProgramType);
        }
        return obj;
    },
    create(base) {
        return exports.CardOrdered.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardOrdered();
        message.cardId = object.cardId ?? '';
        message.eta = (object.eta !== undefined && object.eta !== null)
            ? timestamp_1.Timestamp.fromPartial(object.eta)
            : undefined;
        message.cardProgramType = object.cardProgramType ?? card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE;
        return message;
    },
};
function createBaseCardReplaced() {
    return { oldPanSuffix: '', newPanSuffix: '', customer: undefined, sponsor: undefined };
}
exports.CardReplaced = {
    fromJSON(object) {
        const message = {
            oldPanSuffix: isSet(object.oldPanSuffix) ? globalThis.String(object.oldPanSuffix) : '',
            newPanSuffix: isSet(object.newPanSuffix) ? globalThis.String(object.newPanSuffix) : '',
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        if (isSet(object.sponsor)) {
            message.sponsor = legal_name_1.LegalName.fromJSON(object.sponsor);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.oldPanSuffix !== '') {
            obj.oldPanSuffix = message.oldPanSuffix;
        }
        if (message.newPanSuffix !== '') {
            obj.newPanSuffix = message.newPanSuffix;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        if (message.sponsor !== undefined) {
            obj.sponsor = legal_name_1.LegalName.toJSON(message.sponsor);
        }
        return obj;
    },
    create(base) {
        return exports.CardReplaced.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardReplaced();
        message.oldPanSuffix = object.oldPanSuffix ?? '';
        message.newPanSuffix = object.newPanSuffix ?? '';
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        message.sponsor = (object.sponsor !== undefined && object.sponsor !== null)
            ? legal_name_1.LegalName.fromPartial(object.sponsor)
            : undefined;
        return message;
    },
};
function createBaseCardActivated() {
    return {
        panSuffix: '',
        customer: undefined,
        sponsor: undefined,
        cardProgramType: card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE,
    };
}
exports.CardActivated = {
    fromJSON(object) {
        const message = {
            panSuffix: isSet(object.panSuffix) ? globalThis.String(object.panSuffix) : '',
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        if (isSet(object.sponsor)) {
            message.sponsor = legal_name_1.LegalName.fromJSON(object.sponsor);
        }
        if (isSet(object.cardProgramType)) {
            message.cardProgramType = (0, card_details_1.cardProgramTypeFromJSON)(object.cardProgramType);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.panSuffix !== '') {
            obj.panSuffix = message.panSuffix;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        if (message.sponsor !== undefined) {
            obj.sponsor = legal_name_1.LegalName.toJSON(message.sponsor);
        }
        if (message.cardProgramType !== undefined &&
            message.cardProgramType !== card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE) {
            obj.cardProgramType = (0, card_details_1.cardProgramTypeToJSON)(message.cardProgramType);
        }
        return obj;
    },
    create(base) {
        return exports.CardActivated.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardActivated();
        message.panSuffix = object.panSuffix ?? '';
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        message.sponsor = (object.sponsor !== undefined && object.sponsor !== null)
            ? legal_name_1.LegalName.fromPartial(object.sponsor)
            : undefined;
        message.cardProgramType = object.cardProgramType ?? card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE;
        return message;
    },
};
function createBasePurchase() {
    return {
        paymentId: '',
        transactionId: '',
        primaryAccountId: '',
        merchantName: '',
        txAmount: undefined,
        newBalance: undefined,
        type: PurchaseType.INVALID,
        rollover: undefined,
    };
}
exports.Purchase = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            merchantName: isSet(object.merchantName) ? globalThis.String(object.merchantName) : '',
        };
        if (isSet(object.txAmount)) {
            message.txAmount = amount_1.Amount.fromJSON(object.txAmount);
        }
        if (isSet(object.newBalance)) {
            message.newBalance = amount_1.Amount.fromJSON(object.newBalance);
        }
        if (isSet(object.type)) {
            message.type = purchaseTypeFromJSON(object.type);
        }
        if (isSet(object.rollover)) {
            message.rollover = exports.PurchaseRollover.fromJSON(object.rollover);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.transactionId !== '') {
            obj.transactionId = message.transactionId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        if (message.txAmount !== undefined) {
            obj.txAmount = amount_1.Amount.toJSON(message.txAmount);
        }
        if (message.newBalance !== undefined) {
            obj.newBalance = amount_1.Amount.toJSON(message.newBalance);
        }
        if (message.type !== undefined && message.type !== PurchaseType.INVALID) {
            obj.type = purchaseTypeToJSON(message.type);
        }
        if (message.rollover !== undefined) {
            obj.rollover = exports.PurchaseRollover.toJSON(message.rollover);
        }
        return obj;
    },
    create(base) {
        return exports.Purchase.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchase();
        message.paymentId = object.paymentId ?? '';
        message.transactionId = object.transactionId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.merchantName = object.merchantName ?? '';
        message.txAmount = (object.txAmount !== undefined && object.txAmount !== null)
            ? amount_1.Amount.fromPartial(object.txAmount)
            : undefined;
        message.newBalance = (object.newBalance !== undefined && object.newBalance !== null)
            ? amount_1.Amount.fromPartial(object.newBalance)
            : undefined;
        message.type = object.type ?? PurchaseType.INVALID;
        message.rollover = (object.rollover !== undefined && object.rollover !== null)
            ? exports.PurchaseRollover.fromPartial(object.rollover)
            : undefined;
        return message;
    },
};
function createBasePurchaseRollover() {
    return {
        rolloverAmount: amount_1.Amount.fromPartial({}),
        cashBalance: amount_1.Amount.fromPartial({}),
        creditAvailable: amount_1.Amount.fromPartial({}),
    };
}
exports.PurchaseRollover = {
    fromJSON(object) {
        const message = {
            rolloverAmount: isSet(object.rolloverAmount)
                ? amount_1.Amount.fromJSON(object.rolloverAmount)
                : amount_1.Amount.fromPartial({}),
            cashBalance: isSet(object.cashBalance)
                ? amount_1.Amount.fromJSON(object.cashBalance)
                : amount_1.Amount.fromPartial({}),
            creditAvailable: isSet(object.creditAvailable)
                ? amount_1.Amount.fromJSON(object.creditAvailable)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rolloverAmount !== undefined) {
            obj.rolloverAmount = amount_1.Amount.toJSON(message.rolloverAmount);
        }
        if (message.cashBalance !== undefined) {
            obj.cashBalance = amount_1.Amount.toJSON(message.cashBalance);
        }
        if (message.creditAvailable !== undefined) {
            obj.creditAvailable = amount_1.Amount.toJSON(message.creditAvailable);
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseRollover.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseRollover();
        message.rolloverAmount = (object.rolloverAmount !== undefined && object.rolloverAmount !== null)
            ? amount_1.Amount.fromPartial(object.rolloverAmount)
            : amount_1.Amount.fromPartial({});
        message.cashBalance = (object.cashBalance !== undefined && object.cashBalance !== null)
            ? amount_1.Amount.fromPartial(object.cashBalance)
            : amount_1.Amount.fromPartial({});
        message.creditAvailable =
            (object.creditAvailable !== undefined && object.creditAvailable !== null)
                ? amount_1.Amount.fromPartial(object.creditAvailable)
                : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseCardPurchaseAuthorized() {
    return {
        purchase: exports.Purchase.fromPartial({}),
        customer: undefined,
        cardProgramType: card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE,
    };
}
exports.CardPurchaseAuthorized = {
    fromJSON(object) {
        const message = {
            purchase: isSet(object.purchase)
                ? exports.Purchase.fromJSON(object.purchase)
                : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        if (isSet(object.cardProgramType)) {
            message.cardProgramType = (0, card_details_1.cardProgramTypeFromJSON)(object.cardProgramType);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purchase !== undefined) {
            obj.purchase = exports.Purchase.toJSON(message.purchase);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        if (message.cardProgramType !== undefined &&
            message.cardProgramType !== card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE) {
            obj.cardProgramType = (0, card_details_1.cardProgramTypeToJSON)(message.cardProgramType);
        }
        return obj;
    },
    create(base) {
        return exports.CardPurchaseAuthorized.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPurchaseAuthorized();
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.Purchase.fromPartial(object.purchase)
            : exports.Purchase.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        message.cardProgramType = object.cardProgramType ?? card_details_1.CardProgramType.INVALID_CARD_PROGRAM_TYPE;
        return message;
    },
};
function createBaseCardPurchaseReversed() {
    return { reversal: exports.Purchase.fromPartial({}), customer: undefined };
}
exports.CardPurchaseReversed = {
    fromJSON(object) {
        const message = {
            reversal: isSet(object.reversal)
                ? exports.Purchase.fromJSON(object.reversal)
                : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reversal !== undefined) {
            obj.reversal = exports.Purchase.toJSON(message.reversal);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.CardPurchaseReversed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPurchaseReversed();
        message.reversal = (object.reversal !== undefined && object.reversal !== null)
            ? exports.Purchase.fromPartial(object.reversal)
            : exports.Purchase.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseCardPurchaseRefunded() {
    return { refund: exports.Purchase.fromPartial({}), customer: undefined };
}
exports.CardPurchaseRefunded = {
    fromJSON(object) {
        const message = {
            refund: isSet(object.refund) ? exports.Purchase.fromJSON(object.refund) : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.refund !== undefined) {
            obj.refund = exports.Purchase.toJSON(message.refund);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.CardPurchaseRefunded.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPurchaseRefunded();
        message.refund = (object.refund !== undefined && object.refund !== null)
            ? exports.Purchase.fromPartial(object.refund)
            : exports.Purchase.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseDisputeCredit() {
    return {
        credit: exports.Purchase.fromPartial({}),
        isFinal: false,
        isAdditional: false,
        cardReplaced: false,
        customer: undefined,
    };
}
exports.DisputeCredit = {
    fromJSON(object) {
        const message = {
            credit: isSet(object.credit) ? exports.Purchase.fromJSON(object.credit) : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.isFinal)) {
            message.isFinal = globalThis.Boolean(object.isFinal);
        }
        if (isSet(object.isAdditional)) {
            message.isAdditional = globalThis.Boolean(object.isAdditional);
        }
        if (isSet(object.cardReplaced)) {
            message.cardReplaced = globalThis.Boolean(object.cardReplaced);
        }
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.credit !== undefined) {
            obj.credit = exports.Purchase.toJSON(message.credit);
        }
        if (message.isFinal !== undefined && message.isFinal !== false) {
            obj.isFinal = message.isFinal;
        }
        if (message.isAdditional !== undefined && message.isAdditional !== false) {
            obj.isAdditional = message.isAdditional;
        }
        if (message.cardReplaced !== undefined && message.cardReplaced !== false) {
            obj.cardReplaced = message.cardReplaced;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.DisputeCredit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDisputeCredit();
        message.credit = (object.credit !== undefined && object.credit !== null)
            ? exports.Purchase.fromPartial(object.credit)
            : exports.Purchase.fromPartial({});
        message.isFinal = object.isFinal ?? false;
        message.isAdditional = object.isAdditional ?? false;
        message.cardReplaced = object.cardReplaced ?? false;
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseDisputeCreditReversal() {
    return { reversal: exports.Purchase.fromPartial({}), isFinal: false, customer: undefined };
}
exports.DisputeCreditReversal = {
    fromJSON(object) {
        const message = {
            reversal: isSet(object.reversal)
                ? exports.Purchase.fromJSON(object.reversal)
                : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.isFinal)) {
            message.isFinal = globalThis.Boolean(object.isFinal);
        }
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reversal !== undefined) {
            obj.reversal = exports.Purchase.toJSON(message.reversal);
        }
        if (message.isFinal !== undefined && message.isFinal !== false) {
            obj.isFinal = message.isFinal;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.DisputeCreditReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDisputeCreditReversal();
        message.reversal = (object.reversal !== undefined && object.reversal !== null)
            ? exports.Purchase.fromPartial(object.reversal)
            : exports.Purchase.fromPartial({});
        message.isFinal = object.isFinal ?? false;
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseCustomerTransfer() {
    return {
        paymentId: '',
        primaryAccountId: '',
        amount: undefined,
        newBalance: undefined,
        description: '',
        customer: undefined,
    };
}
exports.CustomerTransfer = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.newBalance)) {
            message.newBalance = amount_1.Amount.fromJSON(object.newBalance);
        }
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.newBalance !== undefined) {
            obj.newBalance = amount_1.Amount.toJSON(message.newBalance);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.CustomerTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCustomerTransfer();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.newBalance = (object.newBalance !== undefined && object.newBalance !== null)
            ? amount_1.Amount.fromPartial(object.newBalance)
            : undefined;
        message.description = object.description ?? '';
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseCustomerRecoupment() {
    return {
        paymentId: '',
        primaryAccountId: '',
        amount: amount_1.Amount.fromPartial({}),
        newBalance: amount_1.Amount.fromPartial({}),
        customer: undefined,
    };
}
exports.CustomerRecoupment = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            newBalance: isSet(object.newBalance)
                ? amount_1.Amount.fromJSON(object.newBalance)
                : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.newBalance !== undefined) {
            obj.newBalance = amount_1.Amount.toJSON(message.newBalance);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.CustomerRecoupment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCustomerRecoupment();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.newBalance = (object.newBalance !== undefined && object.newBalance !== null)
            ? amount_1.Amount.fromPartial(object.newBalance)
            : amount_1.Amount.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseCardInactive() {
    return {
        cardId: '',
        previouslyActivated: false,
        purchase: exports.Purchase.fromPartial({}),
        customer: undefined,
    };
}
exports.CardInactive = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            purchase: isSet(object.purchase)
                ? exports.Purchase.fromJSON(object.purchase)
                : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.previouslyActivated)) {
            message.previouslyActivated = globalThis.Boolean(object.previouslyActivated);
        }
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.previouslyActivated !== undefined && message.previouslyActivated !== false) {
            obj.previouslyActivated = message.previouslyActivated;
        }
        if (message.purchase !== undefined) {
            obj.purchase = exports.Purchase.toJSON(message.purchase);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.CardInactive.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardInactive();
        message.cardId = object.cardId ?? '';
        message.previouslyActivated = object.previouslyActivated ?? false;
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.Purchase.fromPartial(object.purchase)
            : exports.Purchase.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseCardCanceled() {
    return { purchase: exports.Purchase.fromPartial({}), customer: undefined };
}
exports.CardCanceled = {
    fromJSON(object) {
        const message = {
            purchase: isSet(object.purchase)
                ? exports.Purchase.fromJSON(object.purchase)
                : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purchase !== undefined) {
            obj.purchase = exports.Purchase.toJSON(message.purchase);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.CardCanceled.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardCanceled();
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.Purchase.fromPartial(object.purchase)
            : exports.Purchase.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBasePurchaseCardLocked() {
    return { cardId: '', purchase: exports.Purchase.fromPartial({}), customer: undefined };
}
exports.PurchaseCardLocked = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            purchase: isSet(object.purchase)
                ? exports.Purchase.fromJSON(object.purchase)
                : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.purchase !== undefined) {
            obj.purchase = exports.Purchase.toJSON(message.purchase);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseCardLocked.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseCardLocked();
        message.cardId = object.cardId ?? '';
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.Purchase.fromPartial(object.purchase)
            : exports.Purchase.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseCardPurchaseInsufficientFunds() {
    return { purchase: exports.Purchase.fromPartial({}), customer: undefined };
}
exports.CardPurchaseInsufficientFunds = {
    fromJSON(object) {
        const message = {
            purchase: isSet(object.purchase)
                ? exports.Purchase.fromJSON(object.purchase)
                : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purchase !== undefined) {
            obj.purchase = exports.Purchase.toJSON(message.purchase);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.CardPurchaseInsufficientFunds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPurchaseInsufficientFunds();
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.Purchase.fromPartial(object.purchase)
            : exports.Purchase.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseFamilyInvite() {
    return { familyId: '', sender: notification_user_1.NotificationUser.fromPartial({}) };
}
exports.FamilyInvite = {
    fromJSON(object) {
        const message = {
            familyId: isSet(object.familyId) ? globalThis.String(object.familyId) : '',
            sender: isSet(object.sender)
                ? notification_user_1.NotificationUser.fromJSON(object.sender)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.familyId !== '') {
            obj.familyId = message.familyId;
        }
        if (message.sender !== undefined) {
            obj.sender = notification_user_1.NotificationUser.toJSON(message.sender);
        }
        return obj;
    },
    create(base) {
        return exports.FamilyInvite.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFamilyInvite();
        message.familyId = object.familyId ?? '';
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sender)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseCosponsorFamilyInvite() {
    return { sender: notification_user_1.NotificationUser.fromPartial({}) };
}
exports.CosponsorFamilyInvite = {
    fromJSON(object) {
        const message = {
            sender: isSet(object.sender)
                ? notification_user_1.NotificationUser.fromJSON(object.sender)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sender !== undefined) {
            obj.sender = notification_user_1.NotificationUser.toJSON(message.sender);
        }
        return obj;
    },
    create(base) {
        return exports.CosponsorFamilyInvite.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCosponsorFamilyInvite();
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sender)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseJoinedFamily() {
    return { sender: notification_user_1.NotificationUser.fromPartial({}) };
}
exports.JoinedFamily = {
    fromJSON(object) {
        const message = {
            sender: isSet(object.sender)
                ? notification_user_1.NotificationUser.fromJSON(object.sender)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sender !== undefined) {
            obj.sender = notification_user_1.NotificationUser.toJSON(message.sender);
        }
        return obj;
    },
    create(base) {
        return exports.JoinedFamily.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseJoinedFamily();
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sender)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseFamilyInviteDenied() {
    return {};
}
exports.FamilyInviteDenied = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.FamilyInviteDenied.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseFamilyInviteDenied();
        return message;
    },
};
function createBaseFamilyInviteApproved() {
    return { familyId: '' };
}
exports.FamilyInviteApproved = {
    fromJSON(object) {
        const message = {
            familyId: isSet(object.familyId) ? globalThis.String(object.familyId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.familyId !== '') {
            obj.familyId = message.familyId;
        }
        return obj;
    },
    create(base) {
        return exports.FamilyInviteApproved.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFamilyInviteApproved();
        message.familyId = object.familyId ?? '';
        return message;
    },
};
function createBaseLockCard() {
    return {
        cardId: '',
        primaryAccountId: '',
        isVirtual: false,
        sponsor: notification_user_1.NotificationUser.fromPartial({}),
    };
}
exports.LockCard = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            sponsor: isSet(object.sponsor)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsor)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        if (isSet(object.isVirtual)) {
            message.isVirtual = globalThis.Boolean(object.isVirtual);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.isVirtual !== undefined && message.isVirtual !== false) {
            obj.isVirtual = message.isVirtual;
        }
        if (message.sponsor !== undefined) {
            obj.sponsor = notification_user_1.NotificationUser.toJSON(message.sponsor);
        }
        return obj;
    },
    create(base) {
        return exports.LockCard.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLockCard();
        message.cardId = object.cardId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.isVirtual = object.isVirtual ?? false;
        message.sponsor = (object.sponsor !== undefined && object.sponsor !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsor)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseUnlockCard() {
    return {
        cardId: '',
        primaryAccountId: '',
        isVirtual: false,
        sponsor: notification_user_1.NotificationUser.fromPartial({}),
    };
}
exports.UnlockCard = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            sponsor: isSet(object.sponsor)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsor)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        if (isSet(object.isVirtual)) {
            message.isVirtual = globalThis.Boolean(object.isVirtual);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.isVirtual !== undefined && message.isVirtual !== false) {
            obj.isVirtual = message.isVirtual;
        }
        if (message.sponsor !== undefined) {
            obj.sponsor = notification_user_1.NotificationUser.toJSON(message.sponsor);
        }
        return obj;
    },
    create(base) {
        return exports.UnlockCard.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnlockCard();
        message.cardId = object.cardId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.isVirtual = object.isVirtual ?? false;
        message.sponsor = (object.sponsor !== undefined && object.sponsor !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsor)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseKycExpired() {
    return {};
}
exports.KycExpired = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.KycExpired.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseKycExpired();
        return message;
    },
};
function createBaseKycFailed() {
    return {};
}
exports.KycFailed = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.KycFailed.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseKycFailed();
        return message;
    },
};
function createBaseKycSuccess() {
    return {};
}
exports.KycSuccess = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.KycSuccess.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseKycSuccess();
        return message;
    },
};
function createBaseKycStatusUpdate() {
    return { from: kyc_1.KycStatus.INVALID, to: kyc_1.KycStatus.INVALID };
}
exports.KycStatusUpdate = {
    fromJSON(object) {
        const message = {
            from: isSet(object.from) ? (0, kyc_1.kycStatusFromJSON)(object.from) : kyc_1.KycStatus.INVALID,
            to: isSet(object.to) ? (0, kyc_1.kycStatusFromJSON)(object.to) : kyc_1.KycStatus.INVALID,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.from !== kyc_1.KycStatus.INVALID) {
            obj.from = (0, kyc_1.kycStatusToJSON)(message.from);
        }
        if (message.to !== kyc_1.KycStatus.INVALID) {
            obj.to = (0, kyc_1.kycStatusToJSON)(message.to);
        }
        return obj;
    },
    create(base) {
        return exports.KycStatusUpdate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseKycStatusUpdate();
        message.from = object.from ?? kyc_1.KycStatus.INVALID;
        message.to = object.to ?? kyc_1.KycStatus.INVALID;
        return message;
    },
};
function createBaseTestMessage() {
    return { id: '' };
}
exports.TestMessage = {
    fromJSON(object) {
        const message = { id: isSet(object.id) ? globalThis.String(object.id) : '' };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.TestMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestMessage();
        message.id = object.id ?? '';
        return message;
    },
};
function createBaseAtmAccessDisabled() {
    return { cardId: '', disabledBy: notification_user_1.NotificationUser.fromPartial({}) };
}
exports.AtmAccessDisabled = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            disabledBy: isSet(object.disabledBy)
                ? notification_user_1.NotificationUser.fromJSON(object.disabledBy)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.disabledBy !== undefined) {
            obj.disabledBy = notification_user_1.NotificationUser.toJSON(message.disabledBy);
        }
        return obj;
    },
    create(base) {
        return exports.AtmAccessDisabled.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmAccessDisabled();
        message.cardId = object.cardId ?? '';
        message.disabledBy = (object.disabledBy !== undefined && object.disabledBy !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.disabledBy)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseAtmWithdrawal() {
    return {
        paymentId: '',
        primaryAccountId: '',
        amount: undefined,
        newBalance: undefined,
        fee: undefined,
        customer: undefined,
    };
}
exports.AtmWithdrawal = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.newBalance)) {
            message.newBalance = amount_1.Amount.fromJSON(object.newBalance);
        }
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.newBalance !== undefined) {
            obj.newBalance = amount_1.Amount.toJSON(message.newBalance);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.AtmWithdrawal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmWithdrawal();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.newBalance = (object.newBalance !== undefined && object.newBalance !== null)
            ? amount_1.Amount.fromPartial(object.newBalance)
            : undefined;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseAtmWithdrawalAuthorized() {
    return {
        paymentId: '',
        primaryAccountId: '',
        amount: undefined,
        newBalance: undefined,
        customer: undefined,
    };
}
exports.AtmWithdrawalAuthorized = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.newBalance)) {
            message.newBalance = amount_1.Amount.fromJSON(object.newBalance);
        }
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.newBalance !== undefined) {
            obj.newBalance = amount_1.Amount.toJSON(message.newBalance);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.AtmWithdrawalAuthorized.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmWithdrawalAuthorized();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.newBalance = (object.newBalance !== undefined && object.newBalance !== null)
            ? amount_1.Amount.fromPartial(object.newBalance)
            : undefined;
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseInNetworkAtmWithdrawalAuthorized() {
    return { withdrawal: undefined };
}
exports.InNetworkAtmWithdrawalAuthorized = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.withdrawal)) {
            message.withdrawal = exports.AtmWithdrawal.fromJSON(object.withdrawal);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.withdrawal !== undefined) {
            obj.withdrawal = exports.AtmWithdrawal.toJSON(message.withdrawal);
        }
        return obj;
    },
    create(base) {
        return exports.InNetworkAtmWithdrawalAuthorized.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInNetworkAtmWithdrawalAuthorized();
        message.withdrawal = (object.withdrawal !== undefined && object.withdrawal !== null)
            ? exports.AtmWithdrawal.fromPartial(object.withdrawal)
            : undefined;
        return message;
    },
};
function createBaseIssuingDisputeUpdated() {
    return {
        firstName: '',
        accountName: '',
        transactionDate: '',
        disputeReason: dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON,
        disputeAmount: '',
        transactionAmount: '',
        disputedBy: '',
        merchantName: '',
        isKyced: false,
        initiatedBy: '',
        issueProvisionalCredit: false,
        cardReplaced: false,
        disputeClosureReason: dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON,
        disputedDate: '',
        refundAmount: '',
        lossReason: dispute_loss_reason_1.DisputeLossReason.INVALID_DISPUTE_LOSS_REASON,
        creditDate: '',
    };
}
exports.IssuingDisputeUpdated = {
    fromJSON(object) {
        const message = {
            firstName: isSet(object.firstName) ? globalThis.String(object.firstName) : '',
            accountName: isSet(object.accountName) ? globalThis.String(object.accountName) : '',
            transactionDate: isSet(object.transactionDate)
                ? globalThis.String(object.transactionDate)
                : '',
            disputeReason: isSet(object.disputeReason)
                ? (0, dispute_reason_1.disputeReasonFromJSON)(object.disputeReason)
                : dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON,
            disputeAmount: isSet(object.disputeAmount) ? globalThis.String(object.disputeAmount) : '',
            transactionAmount: isSet(object.transactionAmount)
                ? globalThis.String(object.transactionAmount)
                : '',
            disputedBy: isSet(object.disputedBy) ? globalThis.String(object.disputedBy) : '',
            merchantName: isSet(object.merchantName) ? globalThis.String(object.merchantName) : '',
            isKyced: isSet(object.isKyced) ? globalThis.Boolean(object.isKyced) : false,
            initiatedBy: isSet(object.initiatedBy) ? globalThis.String(object.initiatedBy) : '',
            issueProvisionalCredit: isSet(object.issueProvisionalCredit)
                ? globalThis.Boolean(object.issueProvisionalCredit)
                : false,
            cardReplaced: isSet(object.cardReplaced) ? globalThis.Boolean(object.cardReplaced) : false,
        };
        if (isSet(object.disputeClosureReason)) {
            message.disputeClosureReason = (0, dispute_reason_1.disputeCloseReasonFromJSON)(object.disputeClosureReason);
        }
        if (isSet(object.disputedDate)) {
            message.disputedDate = globalThis.String(object.disputedDate);
        }
        if (isSet(object.refundAmount)) {
            message.refundAmount = globalThis.String(object.refundAmount);
        }
        if (isSet(object.lossReason)) {
            message.lossReason = (0, dispute_loss_reason_1.disputeLossReasonFromJSON)(object.lossReason);
        }
        if (isSet(object.creditDate)) {
            message.creditDate = globalThis.String(object.creditDate);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.firstName !== '') {
            obj.firstName = message.firstName;
        }
        if (message.accountName !== '') {
            obj.accountName = message.accountName;
        }
        if (message.transactionDate !== '') {
            obj.transactionDate = message.transactionDate;
        }
        if (message.disputeReason !== dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON) {
            obj.disputeReason = (0, dispute_reason_1.disputeReasonToJSON)(message.disputeReason);
        }
        if (message.disputeAmount !== '') {
            obj.disputeAmount = message.disputeAmount;
        }
        if (message.transactionAmount !== '') {
            obj.transactionAmount = message.transactionAmount;
        }
        if (message.disputedBy !== '') {
            obj.disputedBy = message.disputedBy;
        }
        if (message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        if (message.isKyced !== false) {
            obj.isKyced = message.isKyced;
        }
        if (message.initiatedBy !== '') {
            obj.initiatedBy = message.initiatedBy;
        }
        if (message.issueProvisionalCredit !== false) {
            obj.issueProvisionalCredit = message.issueProvisionalCredit;
        }
        if (message.cardReplaced !== false) {
            obj.cardReplaced = message.cardReplaced;
        }
        if (message.disputeClosureReason !== undefined &&
            message.disputeClosureReason !== dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON) {
            obj.disputeClosureReason = (0, dispute_reason_1.disputeCloseReasonToJSON)(message.disputeClosureReason);
        }
        if (message.disputedDate !== undefined && message.disputedDate !== '') {
            obj.disputedDate = message.disputedDate;
        }
        if (message.refundAmount !== undefined && message.refundAmount !== '') {
            obj.refundAmount = message.refundAmount;
        }
        if (message.lossReason !== undefined &&
            message.lossReason !== dispute_loss_reason_1.DisputeLossReason.INVALID_DISPUTE_LOSS_REASON) {
            obj.lossReason = (0, dispute_loss_reason_1.disputeLossReasonToJSON)(message.lossReason);
        }
        if (message.creditDate !== undefined && message.creditDate !== '') {
            obj.creditDate = message.creditDate;
        }
        return obj;
    },
    create(base) {
        return exports.IssuingDisputeUpdated.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIssuingDisputeUpdated();
        message.firstName = object.firstName ?? '';
        message.accountName = object.accountName ?? '';
        message.transactionDate = object.transactionDate ?? '';
        message.disputeReason = object.disputeReason ?? dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON;
        message.disputeAmount = object.disputeAmount ?? '';
        message.transactionAmount = object.transactionAmount ?? '';
        message.disputedBy = object.disputedBy ?? '';
        message.merchantName = object.merchantName ?? '';
        message.isKyced = object.isKyced ?? false;
        message.initiatedBy = object.initiatedBy ?? '';
        message.issueProvisionalCredit = object.issueProvisionalCredit ?? false;
        message.cardReplaced = object.cardReplaced ?? false;
        message.disputeClosureReason = object.disputeClosureReason ??
            dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON;
        message.disputedDate = object.disputedDate ?? '';
        message.refundAmount = object.refundAmount ?? '';
        message.lossReason = object.lossReason ?? dispute_loss_reason_1.DisputeLossReason.INVALID_DISPUTE_LOSS_REASON;
        message.creditDate = object.creditDate ?? '';
        return message;
    },
};
function createBaseFreeOutOfNetworkAtmWithdrawalAuthorized() {
    return { withdrawal: undefined, feeReimbursed: undefined, isPartial: false };
}
exports.FreeOutOfNetworkAtmWithdrawalAuthorized = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.withdrawal)) {
            message.withdrawal = exports.AtmWithdrawal.fromJSON(object.withdrawal);
        }
        if (isSet(object.feeReimbursed)) {
            message.feeReimbursed = amount_1.Amount.fromJSON(object.feeReimbursed);
        }
        if (isSet(object.isPartial)) {
            message.isPartial = globalThis.Boolean(object.isPartial);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.withdrawal !== undefined) {
            obj.withdrawal = exports.AtmWithdrawal.toJSON(message.withdrawal);
        }
        if (message.feeReimbursed !== undefined) {
            obj.feeReimbursed = amount_1.Amount.toJSON(message.feeReimbursed);
        }
        if (message.isPartial !== undefined && message.isPartial !== false) {
            obj.isPartial = message.isPartial;
        }
        return obj;
    },
    create(base) {
        return exports.FreeOutOfNetworkAtmWithdrawalAuthorized.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFreeOutOfNetworkAtmWithdrawalAuthorized();
        message.withdrawal = (object.withdrawal !== undefined && object.withdrawal !== null)
            ? exports.AtmWithdrawal.fromPartial(object.withdrawal)
            : undefined;
        message.feeReimbursed = (object.feeReimbursed !== undefined && object.feeReimbursed !== null)
            ? amount_1.Amount.fromPartial(object.feeReimbursed)
            : undefined;
        message.isPartial = object.isPartial ?? false;
        return message;
    },
};
function createBaseOutOfNetworkAtmWithdrawalAuthorized() {
    return { withdrawal: undefined };
}
exports.OutOfNetworkAtmWithdrawalAuthorized = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.withdrawal)) {
            message.withdrawal = exports.AtmWithdrawal.fromJSON(object.withdrawal);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.withdrawal !== undefined) {
            obj.withdrawal = exports.AtmWithdrawal.toJSON(message.withdrawal);
        }
        return obj;
    },
    create(base) {
        return exports.OutOfNetworkAtmWithdrawalAuthorized.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutOfNetworkAtmWithdrawalAuthorized();
        message.withdrawal = (object.withdrawal !== undefined && object.withdrawal !== null)
            ? exports.AtmWithdrawal.fromPartial(object.withdrawal)
            : undefined;
        return message;
    },
};
function createBaseAtmWithdrawalAccessDisabled() {
    return { paymentId: '', primaryAccountId: '', customer: undefined };
}
exports.AtmWithdrawalAccessDisabled = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.AtmWithdrawalAccessDisabled.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmWithdrawalAccessDisabled();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseAtmWithdrawalLimitExceeded() {
    return { paymentId: '', primaryAccountId: '', limit: exports.Limit.fromPartial({}), customer: undefined };
}
exports.AtmWithdrawalLimitExceeded = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            limit: isSet(object.limit) ? exports.Limit.fromJSON(object.limit) : exports.Limit.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.limit !== undefined) {
            obj.limit = exports.Limit.toJSON(message.limit);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.AtmWithdrawalLimitExceeded.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmWithdrawalLimitExceeded();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.limit = (object.limit !== undefined && object.limit !== null)
            ? exports.Limit.fromPartial(object.limit)
            : exports.Limit.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseLimit() {
    return { id: '', amount: undefined, count: undefined };
}
exports.Limit = {
    fromJSON(object) {
        const message = { id: isSet(object.id) ? globalThis.String(object.id) : '' };
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.count)) {
            message.count = Number(object.count);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.count !== undefined) {
            obj.count = message.count;
        }
        return obj;
    },
    create(base) {
        return exports.Limit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLimit();
        message.id = object.id ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.count = object.count ?? undefined;
        return message;
    },
};
function createBaseAtmWithdrawalInsufficientFunds() {
    return { paymentId: '', primaryAccountId: '', customer: undefined };
}
exports.AtmWithdrawalInsufficientFunds = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.AtmWithdrawalInsufficientFunds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmWithdrawalInsufficientFunds();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseCardPinBlocked() {
    return { cardId: '', customer: undefined };
}
exports.CardPinBlocked = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.CardPinBlocked.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPinBlocked();
        message.cardId = object.cardId ?? '';
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseAccountLinkExpired() {
    return { externalAccountId: '', externalAccountName: '' };
}
exports.AccountLinkExpired = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
            externalAccountName: isSet(object.externalAccountName)
                ? globalThis.String(object.externalAccountName)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        if (message.externalAccountName !== '') {
            obj.externalAccountName = message.externalAccountName;
        }
        return obj;
    },
    create(base) {
        return exports.AccountLinkExpired.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountLinkExpired();
        message.externalAccountId = object.externalAccountId ?? '';
        message.externalAccountName = object.externalAccountName ?? '';
        return message;
    },
};
function createBasePlaidExchangeLink() {
    return {};
}
exports.PlaidExchangeLink = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.PlaidExchangeLink.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlaidExchangeLink();
        return message;
    },
};
function createBaseSponseeClosedSavingsGoalWithMatching() {
    return {
        sponsee: notification_user_1.NotificationUser.fromPartial({}),
        savingsGoal: exports.SavingsGoal.fromPartial({}),
        paymentId: '',
    };
}
exports.SponseeClosedSavingsGoalWithMatching = {
    fromJSON(object) {
        const message = {
            sponsee: isSet(object.sponsee)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsee)
                : notification_user_1.NotificationUser.fromPartial({}),
            savingsGoal: isSet(object.savingsGoal)
                ? exports.SavingsGoal.fromJSON(object.savingsGoal)
                : exports.SavingsGoal.fromPartial({}),
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsee !== undefined) {
            obj.sponsee = notification_user_1.NotificationUser.toJSON(message.sponsee);
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = exports.SavingsGoal.toJSON(message.savingsGoal);
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.SponseeClosedSavingsGoalWithMatching.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSponseeClosedSavingsGoalWithMatching();
        message.sponsee = (object.sponsee !== undefined && object.sponsee !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsee)
            : notification_user_1.NotificationUser.fromPartial({});
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? exports.SavingsGoal.fromPartial(object.savingsGoal)
            : exports.SavingsGoal.fromPartial({});
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseSponseeCreatedSavingsGoal() {
    return { sponsee: notification_user_1.NotificationUser.fromPartial({}), savingsGoal: exports.SavingsGoal.fromPartial({}) };
}
exports.SponseeCreatedSavingsGoal = {
    fromJSON(object) {
        const message = {
            sponsee: isSet(object.sponsee)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsee)
                : notification_user_1.NotificationUser.fromPartial({}),
            savingsGoal: isSet(object.savingsGoal)
                ? exports.SavingsGoal.fromJSON(object.savingsGoal)
                : exports.SavingsGoal.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsee !== undefined) {
            obj.sponsee = notification_user_1.NotificationUser.toJSON(message.sponsee);
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = exports.SavingsGoal.toJSON(message.savingsGoal);
        }
        return obj;
    },
    create(base) {
        return exports.SponseeCreatedSavingsGoal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSponseeCreatedSavingsGoal();
        message.sponsee = (object.sponsee !== undefined && object.sponsee !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsee)
            : notification_user_1.NotificationUser.fromPartial({});
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? exports.SavingsGoal.fromPartial(object.savingsGoal)
            : exports.SavingsGoal.fromPartial({});
        return message;
    },
};
function createBaseSponseeTurnedOffSavingsMatching() {
    return { sponsee: notification_user_1.NotificationUser.fromPartial({}), savingsGoal: exports.SavingsGoal.fromPartial({}) };
}
exports.SponseeTurnedOffSavingsMatching = {
    fromJSON(object) {
        const message = {
            sponsee: isSet(object.sponsee)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsee)
                : notification_user_1.NotificationUser.fromPartial({}),
            savingsGoal: isSet(object.savingsGoal)
                ? exports.SavingsGoal.fromJSON(object.savingsGoal)
                : exports.SavingsGoal.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsee !== undefined) {
            obj.sponsee = notification_user_1.NotificationUser.toJSON(message.sponsee);
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = exports.SavingsGoal.toJSON(message.savingsGoal);
        }
        return obj;
    },
    create(base) {
        return exports.SponseeTurnedOffSavingsMatching.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSponseeTurnedOffSavingsMatching();
        message.sponsee = (object.sponsee !== undefined && object.sponsee !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsee)
            : notification_user_1.NotificationUser.fromPartial({});
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? exports.SavingsGoal.fromPartial(object.savingsGoal)
            : exports.SavingsGoal.fromPartial({});
        return message;
    },
};
function createBaseSponsorCreatedSavingsGoal() {
    return {
        sponsor: notification_user_1.NotificationUser.fromPartial({}),
        savingsGoal: exports.SavingsGoal.fromPartial({}),
        customer: undefined,
    };
}
exports.SponsorCreatedSavingsGoal = {
    fromJSON(object) {
        const message = {
            sponsor: isSet(object.sponsor)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsor)
                : notification_user_1.NotificationUser.fromPartial({}),
            savingsGoal: isSet(object.savingsGoal)
                ? exports.SavingsGoal.fromJSON(object.savingsGoal)
                : exports.SavingsGoal.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsor !== undefined) {
            obj.sponsor = notification_user_1.NotificationUser.toJSON(message.sponsor);
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = exports.SavingsGoal.toJSON(message.savingsGoal);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.SponsorCreatedSavingsGoal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSponsorCreatedSavingsGoal();
        message.sponsor = (object.sponsor !== undefined && object.sponsor !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsor)
            : notification_user_1.NotificationUser.fromPartial({});
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? exports.SavingsGoal.fromPartial(object.savingsGoal)
            : exports.SavingsGoal.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseSponsorAcceptedSavingsMatching() {
    return { sponsor: notification_user_1.NotificationUser.fromPartial({}), savingsGoal: exports.SavingsGoal.fromPartial({}) };
}
exports.SponsorAcceptedSavingsMatching = {
    fromJSON(object) {
        const message = {
            sponsor: isSet(object.sponsor)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsor)
                : notification_user_1.NotificationUser.fromPartial({}),
            savingsGoal: isSet(object.savingsGoal)
                ? exports.SavingsGoal.fromJSON(object.savingsGoal)
                : exports.SavingsGoal.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsor !== undefined) {
            obj.sponsor = notification_user_1.NotificationUser.toJSON(message.sponsor);
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = exports.SavingsGoal.toJSON(message.savingsGoal);
        }
        return obj;
    },
    create(base) {
        return exports.SponsorAcceptedSavingsMatching.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSponsorAcceptedSavingsMatching();
        message.sponsor = (object.sponsor !== undefined && object.sponsor !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsor)
            : notification_user_1.NotificationUser.fromPartial({});
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? exports.SavingsGoal.fromPartial(object.savingsGoal)
            : exports.SavingsGoal.fromPartial({});
        return message;
    },
};
function createBaseSponsorTurnedOffSavingsMatching() {
    return { sponsor: notification_user_1.NotificationUser.fromPartial({}), savingsGoal: exports.SavingsGoal.fromPartial({}) };
}
exports.SponsorTurnedOffSavingsMatching = {
    fromJSON(object) {
        const message = {
            sponsor: isSet(object.sponsor)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsor)
                : notification_user_1.NotificationUser.fromPartial({}),
            savingsGoal: isSet(object.savingsGoal)
                ? exports.SavingsGoal.fromJSON(object.savingsGoal)
                : exports.SavingsGoal.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsor !== undefined) {
            obj.sponsor = notification_user_1.NotificationUser.toJSON(message.sponsor);
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = exports.SavingsGoal.toJSON(message.savingsGoal);
        }
        return obj;
    },
    create(base) {
        return exports.SponsorTurnedOffSavingsMatching.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSponsorTurnedOffSavingsMatching();
        message.sponsor = (object.sponsor !== undefined && object.sponsor !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsor)
            : notification_user_1.NotificationUser.fromPartial({});
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? exports.SavingsGoal.fromPartial(object.savingsGoal)
            : exports.SavingsGoal.fromPartial({});
        return message;
    },
};
function createBaseContributedToSavingsGoal() {
    return {
        contributor: notification_user_1.NotificationUser.fromPartial({}),
        savingsGoal: exports.SavingsGoal.fromPartial({}),
        contributed: amount_1.Amount.fromPartial({}),
        balance: amount_1.Amount.fromPartial({}),
        achieved: false,
    };
}
exports.ContributedToSavingsGoal = {
    fromJSON(object) {
        const message = {
            contributor: isSet(object.contributor)
                ? notification_user_1.NotificationUser.fromJSON(object.contributor)
                : notification_user_1.NotificationUser.fromPartial({}),
            savingsGoal: isSet(object.savingsGoal)
                ? exports.SavingsGoal.fromJSON(object.savingsGoal)
                : exports.SavingsGoal.fromPartial({}),
            contributed: isSet(object.contributed)
                ? amount_1.Amount.fromJSON(object.contributed)
                : amount_1.Amount.fromPartial({}),
            balance: isSet(object.balance) ? amount_1.Amount.fromJSON(object.balance) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.achieved)) {
            message.achieved = globalThis.Boolean(object.achieved);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.contributor !== undefined) {
            obj.contributor = notification_user_1.NotificationUser.toJSON(message.contributor);
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = exports.SavingsGoal.toJSON(message.savingsGoal);
        }
        if (message.contributed !== undefined) {
            obj.contributed = amount_1.Amount.toJSON(message.contributed);
        }
        if (message.balance !== undefined) {
            obj.balance = amount_1.Amount.toJSON(message.balance);
        }
        if (message.achieved !== undefined && message.achieved !== false) {
            obj.achieved = message.achieved;
        }
        return obj;
    },
    create(base) {
        return exports.ContributedToSavingsGoal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContributedToSavingsGoal();
        message.contributor = (object.contributor !== undefined && object.contributor !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.contributor)
            : notification_user_1.NotificationUser.fromPartial({});
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? exports.SavingsGoal.fromPartial(object.savingsGoal)
            : exports.SavingsGoal.fromPartial({});
        message.contributed = (object.contributed !== undefined && object.contributed !== null)
            ? amount_1.Amount.fromPartial(object.contributed)
            : amount_1.Amount.fromPartial({});
        message.balance = (object.balance !== undefined && object.balance !== null)
            ? amount_1.Amount.fromPartial(object.balance)
            : amount_1.Amount.fromPartial({});
        message.achieved = object.achieved ?? false;
        return message;
    },
};
function createBaseSavingsContributionMatched() {
    return {
        paymentId: '',
        savingsGoal: exports.SavingsGoal.fromPartial({}),
        amount: amount_1.Amount.fromPartial({}),
        otherUser: notification_user_1.NotificationUser.fromPartial({}),
    };
}
exports.SavingsContributionMatched = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            savingsGoal: isSet(object.savingsGoal)
                ? exports.SavingsGoal.fromJSON(object.savingsGoal)
                : exports.SavingsGoal.fromPartial({}),
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            otherUser: isSet(object.otherUser)
                ? notification_user_1.NotificationUser.fromJSON(object.otherUser)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = exports.SavingsGoal.toJSON(message.savingsGoal);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.otherUser !== undefined) {
            obj.otherUser = notification_user_1.NotificationUser.toJSON(message.otherUser);
        }
        return obj;
    },
    create(base) {
        return exports.SavingsContributionMatched.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSavingsContributionMatched();
        message.paymentId = object.paymentId ?? '';
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? exports.SavingsGoal.fromPartial(object.savingsGoal)
            : exports.SavingsGoal.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.otherUser = (object.otherUser !== undefined && object.otherUser !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.otherUser)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseSavingsContributionMatchDeclined() {
    return {
        paymentId: '',
        savingsGoal: exports.SavingsGoal.fromPartial({}),
        amount: amount_1.Amount.fromPartial({}),
        sponsee: notification_user_1.NotificationUser.fromPartial({}),
    };
}
exports.SavingsContributionMatchDeclined = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            savingsGoal: isSet(object.savingsGoal)
                ? exports.SavingsGoal.fromJSON(object.savingsGoal)
                : exports.SavingsGoal.fromPartial({}),
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            sponsee: isSet(object.sponsee)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsee)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = exports.SavingsGoal.toJSON(message.savingsGoal);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.sponsee !== undefined) {
            obj.sponsee = notification_user_1.NotificationUser.toJSON(message.sponsee);
        }
        return obj;
    },
    create(base) {
        return exports.SavingsContributionMatchDeclined.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSavingsContributionMatchDeclined();
        message.paymentId = object.paymentId ?? '';
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? exports.SavingsGoal.fromPartial(object.savingsGoal)
            : exports.SavingsGoal.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.sponsee = (object.sponsee !== undefined && object.sponsee !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsee)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseSavingsGoal() {
    return { id: '', title: '' };
}
exports.SavingsGoal = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            title: isSet(object.title) ? globalThis.String(object.title) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        return obj;
    },
    create(base) {
        return exports.SavingsGoal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSavingsGoal();
        message.id = object.id ?? '';
        message.title = object.title ?? '';
        return message;
    },
};
function createBaseContactHasJoinedStep() {
    return { contact: notification_user_1.NotificationUser.fromPartial({}) };
}
exports.ContactHasJoinedStep = {
    fromJSON(object) {
        const message = {
            contact: isSet(object.contact)
                ? notification_user_1.NotificationUser.fromJSON(object.contact)
                : notification_user_1.NotificationUser.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.contact !== undefined) {
            obj.contact = notification_user_1.NotificationUser.toJSON(message.contact);
        }
        return obj;
    },
    create(base) {
        return exports.ContactHasJoinedStep.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContactHasJoinedStep();
        message.contact = (object.contact !== undefined && object.contact !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.contact)
            : notification_user_1.NotificationUser.fromPartial({});
        return message;
    },
};
function createBaseSponseeAddedDebitCard() {
    return { sponsee: notification_user_1.NotificationUser.fromPartial({}), card: external_card_1.ExternalCard.fromPartial({}) };
}
exports.SponseeAddedDebitCard = {
    fromJSON(object) {
        const message = {
            sponsee: isSet(object.sponsee)
                ? notification_user_1.NotificationUser.fromJSON(object.sponsee)
                : notification_user_1.NotificationUser.fromPartial({}),
            card: isSet(object.card) ? external_card_1.ExternalCard.fromJSON(object.card) : external_card_1.ExternalCard.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsee !== undefined) {
            obj.sponsee = notification_user_1.NotificationUser.toJSON(message.sponsee);
        }
        if (message.card !== undefined) {
            obj.card = external_card_1.ExternalCard.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.SponseeAddedDebitCard.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSponseeAddedDebitCard();
        message.sponsee = (object.sponsee !== undefined && object.sponsee !== null)
            ? notification_user_1.NotificationUser.fromPartial(object.sponsee)
            : notification_user_1.NotificationUser.fromPartial({});
        message.card = (object.card !== undefined && object.card !== null)
            ? external_card_1.ExternalCard.fromPartial(object.card)
            : external_card_1.ExternalCard.fromPartial({});
        return message;
    },
};
function createBaseOutstandingBill() {
    return {
        accountId: '',
        amountDue: amount_1.Amount.fromPartial({}),
        dueDate: timestamp_1.Timestamp.fromPartial({}),
        sponsee: undefined,
    };
}
exports.OutstandingBill = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            amountDue: isSet(object.amountDue)
                ? amount_1.Amount.fromJSON(object.amountDue)
                : amount_1.Amount.fromPartial({}),
            dueDate: isSet(object.dueDate)
                ? fromJsonTimestamp(object.dueDate)
                : timestamp_1.Timestamp.fromPartial({}),
        };
        if (isSet(object.sponsee)) {
            message.sponsee = legal_name_1.LegalName.fromJSON(object.sponsee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.amountDue !== undefined) {
            obj.amountDue = amount_1.Amount.toJSON(message.amountDue);
        }
        if (message.dueDate !== undefined) {
            obj.dueDate = fromTimestamp(message.dueDate).toISOString();
        }
        if (message.sponsee !== undefined) {
            obj.sponsee = legal_name_1.LegalName.toJSON(message.sponsee);
        }
        return obj;
    },
    create(base) {
        return exports.OutstandingBill.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutstandingBill();
        message.accountId = object.accountId ?? '';
        message.amountDue = (object.amountDue !== undefined && object.amountDue !== null)
            ? amount_1.Amount.fromPartial(object.amountDue)
            : amount_1.Amount.fromPartial({});
        message.dueDate = (object.dueDate !== undefined && object.dueDate !== null)
            ? timestamp_1.Timestamp.fromPartial(object.dueDate)
            : timestamp_1.Timestamp.fromPartial({});
        message.sponsee = (object.sponsee !== undefined && object.sponsee !== null)
            ? legal_name_1.LegalName.fromPartial(object.sponsee)
            : undefined;
        return message;
    },
};
function createBaseFlexBillDue() {
    return {
        accountId: '',
        amountDue: amount_1.Amount.fromPartial({}),
        dueDate: date_1.LocalDate.fromPartial({}),
        pastDueDate: undefined,
        delinquentDate: undefined,
        billDate: undefined,
        autoPayEnabled: false,
        autoPayType: '',
        autoPayAmount: undefined,
        autoPayDate: undefined,
        lateFeeAmount: undefined,
        paymentDeepLink: '',
    };
}
exports.FlexBillDue = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            amountDue: isSet(object.amountDue)
                ? amount_1.Amount.fromJSON(object.amountDue)
                : amount_1.Amount.fromPartial({}),
            dueDate: isSet(object.dueDate)
                ? date_1.LocalDate.fromJSON(object.dueDate)
                : date_1.LocalDate.fromPartial({}),
        };
        if (isSet(object.pastDueDate)) {
            message.pastDueDate = date_1.LocalDate.fromJSON(object.pastDueDate);
        }
        if (isSet(object.delinquentDate)) {
            message.delinquentDate = date_1.LocalDate.fromJSON(object.delinquentDate);
        }
        if (isSet(object.billDate)) {
            message.billDate = date_1.LocalDate.fromJSON(object.billDate);
        }
        if (isSet(object.autoPayEnabled)) {
            message.autoPayEnabled = globalThis.Boolean(object.autoPayEnabled);
        }
        if (isSet(object.autoPayType)) {
            message.autoPayType = globalThis.String(object.autoPayType);
        }
        if (isSet(object.autoPayAmount)) {
            message.autoPayAmount = amount_1.Amount.fromJSON(object.autoPayAmount);
        }
        if (isSet(object.autoPayDate)) {
            message.autoPayDate = date_1.LocalDate.fromJSON(object.autoPayDate);
        }
        if (isSet(object.lateFeeAmount)) {
            message.lateFeeAmount = amount_1.Amount.fromJSON(object.lateFeeAmount);
        }
        if (isSet(object.paymentDeepLink)) {
            message.paymentDeepLink = globalThis.String(object.paymentDeepLink);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.amountDue !== undefined) {
            obj.amountDue = amount_1.Amount.toJSON(message.amountDue);
        }
        if (message.dueDate !== undefined) {
            obj.dueDate = date_1.LocalDate.toJSON(message.dueDate);
        }
        if (message.pastDueDate !== undefined) {
            obj.pastDueDate = date_1.LocalDate.toJSON(message.pastDueDate);
        }
        if (message.delinquentDate !== undefined) {
            obj.delinquentDate = date_1.LocalDate.toJSON(message.delinquentDate);
        }
        if (message.billDate !== undefined) {
            obj.billDate = date_1.LocalDate.toJSON(message.billDate);
        }
        if (message.autoPayEnabled !== undefined && message.autoPayEnabled !== false) {
            obj.autoPayEnabled = message.autoPayEnabled;
        }
        if (message.autoPayType !== undefined && message.autoPayType !== '') {
            obj.autoPayType = message.autoPayType;
        }
        if (message.autoPayAmount !== undefined) {
            obj.autoPayAmount = amount_1.Amount.toJSON(message.autoPayAmount);
        }
        if (message.autoPayDate !== undefined) {
            obj.autoPayDate = date_1.LocalDate.toJSON(message.autoPayDate);
        }
        if (message.lateFeeAmount !== undefined) {
            obj.lateFeeAmount = amount_1.Amount.toJSON(message.lateFeeAmount);
        }
        if (message.paymentDeepLink !== undefined && message.paymentDeepLink !== '') {
            obj.paymentDeepLink = message.paymentDeepLink;
        }
        return obj;
    },
    create(base) {
        return exports.FlexBillDue.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFlexBillDue();
        message.accountId = object.accountId ?? '';
        message.amountDue = (object.amountDue !== undefined && object.amountDue !== null)
            ? amount_1.Amount.fromPartial(object.amountDue)
            : amount_1.Amount.fromPartial({});
        message.dueDate = (object.dueDate !== undefined && object.dueDate !== null)
            ? date_1.LocalDate.fromPartial(object.dueDate)
            : date_1.LocalDate.fromPartial({});
        message.pastDueDate = (object.pastDueDate !== undefined && object.pastDueDate !== null)
            ? date_1.LocalDate.fromPartial(object.pastDueDate)
            : undefined;
        message.delinquentDate = (object.delinquentDate !== undefined && object.delinquentDate !== null)
            ? date_1.LocalDate.fromPartial(object.delinquentDate)
            : undefined;
        message.billDate = (object.billDate !== undefined && object.billDate !== null)
            ? date_1.LocalDate.fromPartial(object.billDate)
            : undefined;
        message.autoPayEnabled = object.autoPayEnabled ?? false;
        message.autoPayType = object.autoPayType ?? '';
        message.autoPayAmount = (object.autoPayAmount !== undefined && object.autoPayAmount !== null)
            ? amount_1.Amount.fromPartial(object.autoPayAmount)
            : undefined;
        message.autoPayDate = (object.autoPayDate !== undefined && object.autoPayDate !== null)
            ? date_1.LocalDate.fromPartial(object.autoPayDate)
            : undefined;
        message.lateFeeAmount = (object.lateFeeAmount !== undefined && object.lateFeeAmount !== null)
            ? amount_1.Amount.fromPartial(object.lateFeeAmount)
            : undefined;
        message.paymentDeepLink = object.paymentDeepLink ?? '';
        return message;
    },
};
function createBaseFlexAutoPayFailed() {
    return { accountId: '', dueDate: undefined, lateFeeAmount: undefined, paymentDeepLink: '' };
}
exports.FlexAutoPayFailed = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        if (isSet(object.dueDate)) {
            message.dueDate = date_1.LocalDate.fromJSON(object.dueDate);
        }
        if (isSet(object.lateFeeAmount)) {
            message.lateFeeAmount = amount_1.Amount.fromJSON(object.lateFeeAmount);
        }
        if (isSet(object.paymentDeepLink)) {
            message.paymentDeepLink = globalThis.String(object.paymentDeepLink);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.dueDate !== undefined) {
            obj.dueDate = date_1.LocalDate.toJSON(message.dueDate);
        }
        if (message.lateFeeAmount !== undefined) {
            obj.lateFeeAmount = amount_1.Amount.toJSON(message.lateFeeAmount);
        }
        if (message.paymentDeepLink !== undefined && message.paymentDeepLink !== '') {
            obj.paymentDeepLink = message.paymentDeepLink;
        }
        return obj;
    },
    create(base) {
        return exports.FlexAutoPayFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFlexAutoPayFailed();
        message.accountId = object.accountId ?? '';
        message.dueDate = (object.dueDate !== undefined && object.dueDate !== null)
            ? date_1.LocalDate.fromPartial(object.dueDate)
            : undefined;
        message.lateFeeAmount = (object.lateFeeAmount !== undefined && object.lateFeeAmount !== null)
            ? amount_1.Amount.fromPartial(object.lateFeeAmount)
            : undefined;
        message.paymentDeepLink = object.paymentDeepLink ?? '';
        return message;
    },
};
function createBaseFamilyInviteSms() {
    return { receiverName: '', senderName: legal_name_1.LegalName.fromPartial({}), link: '' };
}
exports.FamilyInviteSms = {
    fromJSON(object) {
        const message = {
            senderName: isSet(object.senderName)
                ? legal_name_1.LegalName.fromJSON(object.senderName)
                : legal_name_1.LegalName.fromPartial({}),
            link: isSet(object.link) ? globalThis.String(object.link) : '',
        };
        if (isSet(object.receiverName)) {
            message.receiverName = globalThis.String(object.receiverName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.receiverName !== undefined && message.receiverName !== '') {
            obj.receiverName = message.receiverName;
        }
        if (message.senderName !== undefined) {
            obj.senderName = legal_name_1.LegalName.toJSON(message.senderName);
        }
        if (message.link !== '') {
            obj.link = message.link;
        }
        return obj;
    },
    create(base) {
        return exports.FamilyInviteSms.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFamilyInviteSms();
        message.receiverName = object.receiverName ?? '';
        message.senderName = (object.senderName !== undefined && object.senderName !== null)
            ? legal_name_1.LegalName.fromPartial(object.senderName)
            : legal_name_1.LegalName.fromPartial({});
        message.link = object.link ?? '';
        return message;
    },
};
function createBaseOfferRewardReceived() {
    return {
        primaryAccountId: '',
        paymentId: '',
        reward: amount_1.Amount.fromPartial({}),
        quotedAmount: undefined,
        bundleName: '',
    };
}
exports.OfferRewardReceived = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            reward: isSet(object.reward) ? amount_1.Amount.fromJSON(object.reward) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.quotedAmount)) {
            message.quotedAmount = amount_1.Amount.fromJSON(object.quotedAmount);
        }
        if (isSet(object.bundleName)) {
            message.bundleName = globalThis.String(object.bundleName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.reward !== undefined) {
            obj.reward = amount_1.Amount.toJSON(message.reward);
        }
        if (message.quotedAmount !== undefined) {
            obj.quotedAmount = amount_1.Amount.toJSON(message.quotedAmount);
        }
        if (message.bundleName !== undefined && message.bundleName !== '') {
            obj.bundleName = message.bundleName;
        }
        return obj;
    },
    create(base) {
        return exports.OfferRewardReceived.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferRewardReceived();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.reward = (object.reward !== undefined && object.reward !== null)
            ? amount_1.Amount.fromPartial(object.reward)
            : amount_1.Amount.fromPartial({});
        message.quotedAmount = (object.quotedAmount !== undefined && object.quotedAmount !== null)
            ? amount_1.Amount.fromPartial(object.quotedAmount)
            : undefined;
        message.bundleName = object.bundleName ?? '';
        return message;
    },
};
function createBaseOfferWillExpire() {
    return { offerDescription: '', offerName: '', offerId: '', numOffers: 0 };
}
exports.OfferWillExpire = {
    fromJSON(object) {
        const message = {
            offerName: isSet(object.offerName) ? globalThis.String(object.offerName) : '',
            offerId: isSet(object.offerId) ? globalThis.String(object.offerId) : '',
            numOffers: isSet(object.numOffers) ? globalThis.Number(object.numOffers) : 0,
        };
        if (isSet(object.offerDescription)) {
            message.offerDescription = globalThis.String(object.offerDescription);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.offerDescription !== undefined && message.offerDescription !== '') {
            obj.offerDescription = message.offerDescription;
        }
        if (message.offerName !== '') {
            obj.offerName = message.offerName;
        }
        if (message.offerId !== '') {
            obj.offerId = message.offerId;
        }
        if (message.numOffers !== 0) {
            obj.numOffers = Math.round(message.numOffers);
        }
        return obj;
    },
    create(base) {
        return exports.OfferWillExpire.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferWillExpire();
        message.offerDescription = object.offerDescription ?? '';
        message.offerName = object.offerName ?? '';
        message.offerId = object.offerId ?? '';
        message.numOffers = object.numOffers ?? 0;
        return message;
    },
};
function createBasePaymentCycleReminder() {
    return { amountDue: amount_1.Amount.fromPartial({}) };
}
exports.PaymentCycleReminder = {
    fromJSON(object) {
        const message = {
            amountDue: isSet(object.amountDue)
                ? amount_1.Amount.fromJSON(object.amountDue)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amountDue !== undefined) {
            obj.amountDue = amount_1.Amount.toJSON(message.amountDue);
        }
        return obj;
    },
    create(base) {
        return exports.PaymentCycleReminder.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentCycleReminder();
        message.amountDue = (object.amountDue !== undefined && object.amountDue !== null)
            ? amount_1.Amount.fromPartial(object.amountDue)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseBillPaid() {
    return { accountId: '' };
}
exports.BillPaid = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.BillPaid.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBillPaid();
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseBnplAlmostDue() {
    return {
        installmentIndex: '',
        amountDue: amount_1.Amount.fromPartial({}),
        merchantName: '',
        daysLeft: 0,
        dueDate: undefined,
        autoPay: false,
        accountId: '',
    };
}
exports.BnplAlmostDue = {
    fromJSON(object) {
        const message = {
            amountDue: isSet(object.amountDue)
                ? amount_1.Amount.fromJSON(object.amountDue)
                : amount_1.Amount.fromPartial({}),
            daysLeft: isSet(object.daysLeft) ? globalThis.Number(object.daysLeft) : 0,
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        if (isSet(object.installmentIndex)) {
            message.installmentIndex = globalThis.String(object.installmentIndex);
        }
        if (isSet(object.merchantName)) {
            message.merchantName = globalThis.String(object.merchantName);
        }
        if (isSet(object.dueDate)) {
            message.dueDate = date_1.LocalDate.fromJSON(object.dueDate);
        }
        if (isSet(object.autoPay)) {
            message.autoPay = globalThis.Boolean(object.autoPay);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.installmentIndex !== undefined && message.installmentIndex !== '') {
            obj.installmentIndex = message.installmentIndex;
        }
        if (message.amountDue !== undefined) {
            obj.amountDue = amount_1.Amount.toJSON(message.amountDue);
        }
        if (message.merchantName !== undefined && message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        if (message.daysLeft !== 0) {
            obj.daysLeft = Math.round(message.daysLeft);
        }
        if (message.dueDate !== undefined) {
            obj.dueDate = date_1.LocalDate.toJSON(message.dueDate);
        }
        if (message.autoPay !== undefined && message.autoPay !== false) {
            obj.autoPay = message.autoPay;
        }
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.BnplAlmostDue.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBnplAlmostDue();
        message.installmentIndex = object.installmentIndex ?? '';
        message.amountDue = (object.amountDue !== undefined && object.amountDue !== null)
            ? amount_1.Amount.fromPartial(object.amountDue)
            : amount_1.Amount.fromPartial({});
        message.merchantName = object.merchantName ?? '';
        message.daysLeft = object.daysLeft ?? 0;
        message.dueDate = (object.dueDate !== undefined && object.dueDate !== null)
            ? date_1.LocalDate.fromPartial(object.dueDate)
            : undefined;
        message.autoPay = object.autoPay ?? false;
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseBnplPaymentSuccessful() {
    return { amountPaid: amount_1.Amount.fromPartial({}), accountId: '' };
}
exports.BnplPaymentSuccessful = {
    fromJSON(object) {
        const message = {
            amountPaid: isSet(object.amountPaid)
                ? amount_1.Amount.fromJSON(object.amountPaid)
                : amount_1.Amount.fromPartial({}),
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amountPaid !== undefined) {
            obj.amountPaid = amount_1.Amount.toJSON(message.amountPaid);
        }
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.BnplPaymentSuccessful.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBnplPaymentSuccessful();
        message.amountPaid = (object.amountPaid !== undefined && object.amountPaid !== null)
            ? amount_1.Amount.fromPartial(object.amountPaid)
            : amount_1.Amount.fromPartial({});
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseBnplPaymentFailed() {
    return { amountAttempted: undefined, merchantName: '', accountId: '' };
}
exports.BnplPaymentFailed = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        if (isSet(object.amountAttempted)) {
            message.amountAttempted = amount_1.Amount.fromJSON(object.amountAttempted);
        }
        if (isSet(object.merchantName)) {
            message.merchantName = globalThis.String(object.merchantName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amountAttempted !== undefined) {
            obj.amountAttempted = amount_1.Amount.toJSON(message.amountAttempted);
        }
        if (message.merchantName !== undefined && message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.BnplPaymentFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBnplPaymentFailed();
        message.amountAttempted =
            (object.amountAttempted !== undefined && object.amountAttempted !== null)
                ? amount_1.Amount.fromPartial(object.amountAttempted)
                : undefined;
        message.merchantName = object.merchantName ?? '';
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseBnplPastDue() {
    return { amountDue: amount_1.Amount.fromPartial({}), accountId: '' };
}
exports.BnplPastDue = {
    fromJSON(object) {
        const message = {
            amountDue: isSet(object.amountDue)
                ? amount_1.Amount.fromJSON(object.amountDue)
                : amount_1.Amount.fromPartial({}),
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amountDue !== undefined) {
            obj.amountDue = amount_1.Amount.toJSON(message.amountDue);
        }
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.BnplPastDue.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBnplPastDue();
        message.amountDue = (object.amountDue !== undefined && object.amountDue !== null)
            ? amount_1.Amount.fromPartial(object.amountDue)
            : amount_1.Amount.fromPartial({});
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseCryptoEnrollmentApproval() {
    return { sponsor: legal_name_1.LegalName.fromPartial({}) };
}
exports.CryptoEnrollmentApproval = {
    fromJSON(object) {
        const message = {
            sponsor: isSet(object.sponsor)
                ? legal_name_1.LegalName.fromJSON(object.sponsor)
                : legal_name_1.LegalName.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsor !== undefined) {
            obj.sponsor = legal_name_1.LegalName.toJSON(message.sponsor);
        }
        return obj;
    },
    create(base) {
        return exports.CryptoEnrollmentApproval.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoEnrollmentApproval();
        message.sponsor = (object.sponsor !== undefined && object.sponsor !== null)
            ? legal_name_1.LegalName.fromPartial(object.sponsor)
            : legal_name_1.LegalName.fromPartial({});
        return message;
    },
};
function createBaseCryptoDisabled() {
    return { sponsor: legal_name_1.LegalName.fromPartial({}) };
}
exports.CryptoDisabled = {
    fromJSON(object) {
        const message = {
            sponsor: isSet(object.sponsor)
                ? legal_name_1.LegalName.fromJSON(object.sponsor)
                : legal_name_1.LegalName.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sponsor !== undefined) {
            obj.sponsor = legal_name_1.LegalName.toJSON(message.sponsor);
        }
        return obj;
    },
    create(base) {
        return exports.CryptoDisabled.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoDisabled();
        message.sponsor = (object.sponsor !== undefined && object.sponsor !== null)
            ? legal_name_1.LegalName.fromPartial(object.sponsor)
            : legal_name_1.LegalName.fromPartial({});
        return message;
    },
};
function createBaseCryptoGraduationTransferSuccess() {
    return {};
}
exports.CryptoGraduationTransferSuccess = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CryptoGraduationTransferSuccess.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCryptoGraduationTransferSuccess();
        return message;
    },
};
function createBaseCryptoRoundUpSuccess() {
    return { currency: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.CryptoRoundUpSuccess = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.CryptoRoundUpSuccess.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoRoundUpSuccess();
        message.currency = object.currency ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseAuthorizedUserUpdated() {
    return { userFirstName: '', sponseeFirstName: '', sponseeFullName: '', isSponsor: false };
}
exports.AuthorizedUserUpdated = {
    fromJSON(object) {
        const message = {
            userFirstName: isSet(object.userFirstName) ? globalThis.String(object.userFirstName) : '',
            sponseeFirstName: isSet(object.sponseeFirstName)
                ? globalThis.String(object.sponseeFirstName)
                : '',
            sponseeFullName: isSet(object.sponseeFullName)
                ? globalThis.String(object.sponseeFullName)
                : '',
        };
        if (isSet(object.isSponsor)) {
            message.isSponsor = globalThis.Boolean(object.isSponsor);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userFirstName !== '') {
            obj.userFirstName = message.userFirstName;
        }
        if (message.sponseeFirstName !== '') {
            obj.sponseeFirstName = message.sponseeFirstName;
        }
        if (message.sponseeFullName !== '') {
            obj.sponseeFullName = message.sponseeFullName;
        }
        if (message.isSponsor !== undefined && message.isSponsor !== false) {
            obj.isSponsor = message.isSponsor;
        }
        return obj;
    },
    create(base) {
        return exports.AuthorizedUserUpdated.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAuthorizedUserUpdated();
        message.userFirstName = object.userFirstName ?? '';
        message.sponseeFirstName = object.sponseeFirstName ?? '';
        message.sponseeFullName = object.sponseeFullName ?? '';
        message.isSponsor = object.isSponsor ?? false;
        return message;
    },
};
function createBaseAccountOwnerUpdated() {
    return { firstName: '' };
}
exports.AccountOwnerUpdated = {
    fromJSON(object) {
        const message = {
            firstName: isSet(object.firstName) ? globalThis.String(object.firstName) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.firstName !== '') {
            obj.firstName = message.firstName;
        }
        return obj;
    },
    create(base) {
        return exports.AccountOwnerUpdated.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountOwnerUpdated();
        message.firstName = object.firstName ?? '';
        return message;
    },
};
function createBaseOtpRequested() {
    return {};
}
exports.OtpRequested = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.OtpRequested.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseOtpRequested();
        return message;
    },
};
function createBaseOtpVerification() {
    return { code: '' };
}
exports.OtpVerification = {
    fromJSON(object) {
        const message = {
            code: isSet(object.code) ? globalThis.String(object.code) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== '') {
            obj.code = message.code;
        }
        return obj;
    },
    create(base) {
        return exports.OtpVerification.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOtpVerification();
        message.code = object.code ?? '';
        return message;
    },
};
function createBaseOtpRecovery() {
    return { code: '' };
}
exports.OtpRecovery = {
    fromJSON(object) {
        const message = { code: isSet(object.code) ? globalThis.String(object.code) : '' };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== '') {
            obj.code = message.code;
        }
        return obj;
    },
    create(base) {
        return exports.OtpRecovery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOtpRecovery();
        message.code = object.code ?? '';
        return message;
    },
};
function createBaseCtaAvailable() {
    return { ctaId: '', userFirstName: '', milestoneGroup: '' };
}
exports.CtaAvailable = {
    fromJSON(object) {
        const message = {
            ctaId: isSet(object.ctaId) ? globalThis.String(object.ctaId) : '',
            userFirstName: isSet(object.userFirstName) ? globalThis.String(object.userFirstName) : '',
            milestoneGroup: isSet(object.milestoneGroup) ? globalThis.String(object.milestoneGroup) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ctaId !== '') {
            obj.ctaId = message.ctaId;
        }
        if (message.userFirstName !== '') {
            obj.userFirstName = message.userFirstName;
        }
        if (message.milestoneGroup !== '') {
            obj.milestoneGroup = message.milestoneGroup;
        }
        return obj;
    },
    create(base) {
        return exports.CtaAvailable.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCtaAvailable();
        message.ctaId = object.ctaId ?? '';
        message.userFirstName = object.userFirstName ?? '';
        message.milestoneGroup = object.milestoneGroup ?? '';
        return message;
    },
};
function createBaseCreditScoreChanged() {
    return { legalName: legal_name_1.LegalName.fromPartial({}), deepLink: '' };
}
exports.CreditScoreChanged = {
    fromJSON(object) {
        const message = {
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
        };
        if (isSet(object.deepLink)) {
            message.deepLink = globalThis.String(object.deepLink);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        if (message.deepLink !== undefined && message.deepLink !== '') {
            obj.deepLink = message.deepLink;
        }
        return obj;
    },
    create(base) {
        return exports.CreditScoreChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditScoreChanged();
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        message.deepLink = object.deepLink ?? '';
        return message;
    },
};
function createBaseSponseeLeftFamily() {
    return {};
}
exports.SponseeLeftFamily = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SponseeLeftFamily.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSponseeLeftFamily();
        return message;
    },
};
function createBaseMarketingMessage() {
    return { value: '' };
}
exports.MarketingMessage = {
    fromJSON(object) {
        const message = {
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.MarketingMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMarketingMessage();
        message.value = object.value ?? '';
        return message;
    },
};
function createBaseRefereeReminder() {
    return { title: '', message: '' };
}
exports.RefereeReminder = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            message: isSet(object.message) ? globalThis.String(object.message) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.message !== '') {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return exports.RefereeReminder.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRefereeReminder();
        message.title = object.title ?? '';
        message.message = object.message ?? '';
        return message;
    },
};
function createBaseForeignPurchaseBlocked() {
    return { purchase: exports.Purchase.fromPartial({}), customer: undefined, memberId: '' };
}
exports.ForeignPurchaseBlocked = {
    fromJSON(object) {
        const message = {
            purchase: isSet(object.purchase)
                ? exports.Purchase.fromJSON(object.purchase)
                : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        if (isSet(object.memberId)) {
            message.memberId = globalThis.String(object.memberId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purchase !== undefined) {
            obj.purchase = exports.Purchase.toJSON(message.purchase);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        if (message.memberId !== undefined && message.memberId !== '') {
            obj.memberId = message.memberId;
        }
        return obj;
    },
    create(base) {
        return exports.ForeignPurchaseBlocked.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseForeignPurchaseBlocked();
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.Purchase.fromPartial(object.purchase)
            : exports.Purchase.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        message.memberId = object.memberId ?? '';
        return message;
    },
};
function createBaseStockOrderCancelled() {
    return { paymentId: '', symbol: '', isBuy: false, isUserInitiated: false };
}
exports.StockOrderCancelled = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            isBuy: isSet(object.isBuy) ? globalThis.Boolean(object.isBuy) : false,
            isUserInitiated: isSet(object.isUserInitiated)
                ? globalThis.Boolean(object.isUserInitiated)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.isBuy !== false) {
            obj.isBuy = message.isBuy;
        }
        if (message.isUserInitiated !== false) {
            obj.isUserInitiated = message.isUserInitiated;
        }
        return obj;
    },
    create(base) {
        return exports.StockOrderCancelled.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockOrderCancelled();
        message.paymentId = object.paymentId ?? '';
        message.symbol = object.symbol ?? '';
        message.isBuy = object.isBuy ?? false;
        message.isUserInitiated = object.isUserInitiated ?? false;
        return message;
    },
};
function createBaseStockOrderRejected() {
    return { paymentId: '', symbol: '', isBuy: false };
}
exports.StockOrderRejected = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            isBuy: isSet(object.isBuy) ? globalThis.Boolean(object.isBuy) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.isBuy !== false) {
            obj.isBuy = message.isBuy;
        }
        return obj;
    },
    create(base) {
        return exports.StockOrderRejected.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockOrderRejected();
        message.paymentId = object.paymentId ?? '';
        message.symbol = object.symbol ?? '';
        message.isBuy = object.isBuy ?? false;
        return message;
    },
};
function createBaseStockOrderFilled() {
    return {
        stockPaymentId: '',
        total: amount_1.Amount.fromPartial({}),
        symbol: '',
        isBuy: false,
        isRoundUp: false,
    };
}
exports.StockOrderFilled = {
    fromJSON(object) {
        const message = {
            stockPaymentId: isSet(object.stockPaymentId) ? globalThis.String(object.stockPaymentId) : '',
            total: isSet(object.total) ? amount_1.Amount.fromJSON(object.total) : amount_1.Amount.fromPartial({}),
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            isBuy: isSet(object.isBuy) ? globalThis.Boolean(object.isBuy) : false,
            isRoundUp: isSet(object.isRoundUp) ? globalThis.Boolean(object.isRoundUp) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.stockPaymentId !== '') {
            obj.stockPaymentId = message.stockPaymentId;
        }
        if (message.total !== undefined) {
            obj.total = amount_1.Amount.toJSON(message.total);
        }
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.isBuy !== false) {
            obj.isBuy = message.isBuy;
        }
        if (message.isRoundUp !== false) {
            obj.isRoundUp = message.isRoundUp;
        }
        return obj;
    },
    create(base) {
        return exports.StockOrderFilled.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockOrderFilled();
        message.stockPaymentId = object.stockPaymentId ?? '';
        message.total = (object.total !== undefined && object.total !== null)
            ? amount_1.Amount.fromPartial(object.total)
            : amount_1.Amount.fromPartial({});
        message.symbol = object.symbol ?? '';
        message.isBuy = object.isBuy ?? false;
        message.isRoundUp = object.isRoundUp ?? false;
        return message;
    },
};
function createBaseStockRiskLevelUpdate() {
    return { riskLevel: '' };
}
exports.StockRiskLevelUpdate = {
    fromJSON(object) {
        const message = {
            riskLevel: isSet(object.riskLevel) ? globalThis.String(object.riskLevel) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.riskLevel !== '') {
            obj.riskLevel = message.riskLevel;
        }
        return obj;
    },
    create(base) {
        return exports.StockRiskLevelUpdate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockRiskLevelUpdate();
        message.riskLevel = object.riskLevel ?? '';
        return message;
    },
};
function createBaseStockSponseeApproved() {
    return {};
}
exports.StockSponseeApproved = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockSponseeApproved.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockSponseeApproved();
        return message;
    },
};
function createBaseCorporateAction() {
    return { paymentId: '', isDividend: false, companyName: '' };
}
exports.CorporateAction = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            isDividend: isSet(object.isDividend) ? globalThis.Boolean(object.isDividend) : false,
            companyName: isSet(object.companyName) ? globalThis.String(object.companyName) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.isDividend !== false) {
            obj.isDividend = message.isDividend;
        }
        if (message.companyName !== '') {
            obj.companyName = message.companyName;
        }
        return obj;
    },
    create(base) {
        return exports.CorporateAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCorporateAction();
        message.paymentId = object.paymentId ?? '';
        message.isDividend = object.isDividend ?? false;
        message.companyName = object.companyName ?? '';
        return message;
    },
};
function createBaseStockDayTradeDetected() {
    return {};
}
exports.StockDayTradeDetected = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockDayTradeDetected.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockDayTradeDetected();
        return message;
    },
};
function createBaseStockGraduationTransferSuccess() {
    return {};
}
exports.StockGraduationTransferSuccess = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockGraduationTransferSuccess.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockGraduationTransferSuccess();
        return message;
    },
};
function createBaseSavingsInterest() {
    return { earned: amount_1.Amount.fromPartial({}), goalCount: 0, goalTitle: '', goalId: '' };
}
exports.SavingsInterest = {
    fromJSON(object) {
        const message = {
            earned: isSet(object.earned) ? amount_1.Amount.fromJSON(object.earned) : amount_1.Amount.fromPartial({}),
            goalCount: isSet(object.goalCount) ? globalThis.Number(object.goalCount) : 0,
        };
        if (isSet(object.goalTitle)) {
            message.goalTitle = globalThis.String(object.goalTitle);
        }
        if (isSet(object.goalId)) {
            message.goalId = globalThis.String(object.goalId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.earned !== undefined) {
            obj.earned = amount_1.Amount.toJSON(message.earned);
        }
        if (message.goalCount !== 0) {
            obj.goalCount = Math.round(message.goalCount);
        }
        if (message.goalTitle !== undefined && message.goalTitle !== '') {
            obj.goalTitle = message.goalTitle;
        }
        if (message.goalId !== undefined && message.goalId !== '') {
            obj.goalId = message.goalId;
        }
        return obj;
    },
    create(base) {
        return exports.SavingsInterest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSavingsInterest();
        message.earned = (object.earned !== undefined && object.earned !== null)
            ? amount_1.Amount.fromPartial(object.earned)
            : amount_1.Amount.fromPartial({});
        message.goalCount = object.goalCount ?? 0;
        message.goalTitle = object.goalTitle ?? '';
        message.goalId = object.goalId ?? '';
        return message;
    },
};
function createBasePlusTierEnrolled() {
    return { savingsApyRate: 0, legalName: legal_name_1.LegalName.fromPartial({}) };
}
exports.PlusTierEnrolled = {
    fromJSON(object) {
        const message = {
            savingsApyRate: isSet(object.savingsApyRate) ? globalThis.Number(object.savingsApyRate) : 0,
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.savingsApyRate !== 0) {
            obj.savingsApyRate = message.savingsApyRate;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        return obj;
    },
    create(base) {
        return exports.PlusTierEnrolled.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlusTierEnrolled();
        message.savingsApyRate = object.savingsApyRate ?? 0;
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        return message;
    },
};
function createBasePlusTierEnrolledManagedUser() {
    return { savingsApyRate: 0, managedUserLegalName: legal_name_1.LegalName.fromPartial({}) };
}
exports.PlusTierEnrolledManagedUser = {
    fromJSON(object) {
        const message = {
            savingsApyRate: isSet(object.savingsApyRate) ? globalThis.Number(object.savingsApyRate) : 0,
            managedUserLegalName: isSet(object.managedUserLegalName)
                ? legal_name_1.LegalName.fromJSON(object.managedUserLegalName)
                : legal_name_1.LegalName.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.savingsApyRate !== 0) {
            obj.savingsApyRate = message.savingsApyRate;
        }
        if (message.managedUserLegalName !== undefined) {
            obj.managedUserLegalName = legal_name_1.LegalName.toJSON(message.managedUserLegalName);
        }
        return obj;
    },
    create(base) {
        return exports.PlusTierEnrolledManagedUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlusTierEnrolledManagedUser();
        message.savingsApyRate = object.savingsApyRate ?? 0;
        message.managedUserLegalName =
            (object.managedUserLegalName !== undefined && object.managedUserLegalName !== null)
                ? legal_name_1.LegalName.fromPartial(object.managedUserLegalName)
                : legal_name_1.LegalName.fromPartial({});
        return message;
    },
};
function createBaseBlackTierInherited() {
    return { savingsApyRate: 0, legalName: legal_name_1.LegalName.fromPartial({}) };
}
exports.BlackTierInherited = {
    fromJSON(object) {
        const message = {
            savingsApyRate: isSet(object.savingsApyRate) ? globalThis.Number(object.savingsApyRate) : 0,
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.savingsApyRate !== 0) {
            obj.savingsApyRate = message.savingsApyRate;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        return obj;
    },
    create(base) {
        return exports.BlackTierInherited.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlackTierInherited();
        message.savingsApyRate = object.savingsApyRate ?? 0;
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        return message;
    },
};
function createBaseBlackTierInheritedManagedUser() {
    return { savingsApyRate: 0, managedUserLegalName: legal_name_1.LegalName.fromPartial({}) };
}
exports.BlackTierInheritedManagedUser = {
    fromJSON(object) {
        const message = {
            savingsApyRate: isSet(object.savingsApyRate) ? globalThis.Number(object.savingsApyRate) : 0,
            managedUserLegalName: isSet(object.managedUserLegalName)
                ? legal_name_1.LegalName.fromJSON(object.managedUserLegalName)
                : legal_name_1.LegalName.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.savingsApyRate !== 0) {
            obj.savingsApyRate = message.savingsApyRate;
        }
        if (message.managedUserLegalName !== undefined) {
            obj.managedUserLegalName = legal_name_1.LegalName.toJSON(message.managedUserLegalName);
        }
        return obj;
    },
    create(base) {
        return exports.BlackTierInheritedManagedUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlackTierInheritedManagedUser();
        message.savingsApyRate = object.savingsApyRate ?? 0;
        message.managedUserLegalName =
            (object.managedUserLegalName !== undefined && object.managedUserLegalName !== null)
                ? legal_name_1.LegalName.fromPartial(object.managedUserLegalName)
                : legal_name_1.LegalName.fromPartial({});
        return message;
    },
};
function createBaseSubscriptionRenewalFailed() {
    return { tierExpirationDate: timestamp_1.Timestamp.fromPartial({}) };
}
exports.SubscriptionRenewalFailed = {
    fromJSON(object) {
        const message = {
            tierExpirationDate: isSet(object.tierExpirationDate)
                ? fromJsonTimestamp(object.tierExpirationDate)
                : timestamp_1.Timestamp.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tierExpirationDate !== undefined) {
            obj.tierExpirationDate = fromTimestamp(message.tierExpirationDate).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.SubscriptionRenewalFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionRenewalFailed();
        message.tierExpirationDate =
            (object.tierExpirationDate !== undefined && object.tierExpirationDate !== null)
                ? timestamp_1.Timestamp.fromPartial(object.tierExpirationDate)
                : timestamp_1.Timestamp.fromPartial({});
        return message;
    },
};
function createBaseDowngradedFromBlackTier() {
    return { legalName: legal_name_1.LegalName.fromPartial({}) };
}
exports.DowngradedFromBlackTier = {
    fromJSON(object) {
        const message = {
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        return obj;
    },
    create(base) {
        return exports.DowngradedFromBlackTier.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDowngradedFromBlackTier();
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        return message;
    },
};
function createBaseDepositAmount() {
    return { entireAmount: undefined, percentAmount: undefined, fixedAmount: undefined };
}
exports.DepositAmount = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.entireAmount)) {
            message.entireAmount = globalThis.Boolean(object.entireAmount);
        }
        if (isSet(object.percentAmount)) {
            message.percentAmount = globalThis.String(object.percentAmount);
        }
        if (isSet(object.fixedAmount)) {
            message.fixedAmount = amount_1.Amount.fromJSON(object.fixedAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.entireAmount !== undefined) {
            obj.entireAmount = message.entireAmount;
        }
        if (message.percentAmount !== undefined) {
            obj.percentAmount = message.percentAmount;
        }
        if (message.fixedAmount !== undefined) {
            obj.fixedAmount = amount_1.Amount.toJSON(message.fixedAmount);
        }
        return obj;
    },
    create(base) {
        return exports.DepositAmount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDepositAmount();
        message.entireAmount = object.entireAmount ?? undefined;
        message.percentAmount = object.percentAmount ?? undefined;
        message.fixedAmount = (object.fixedAmount !== undefined && object.fixedAmount !== null)
            ? amount_1.Amount.fromPartial(object.fixedAmount)
            : undefined;
        return message;
    },
};
function createBaseDepositSwitchSuccess() {
    return { depositAmount: exports.DepositAmount.fromPartial({}), employer: '' };
}
exports.DepositSwitchSuccess = {
    fromJSON(object) {
        const message = {
            depositAmount: isSet(object.depositAmount)
                ? exports.DepositAmount.fromJSON(object.depositAmount)
                : exports.DepositAmount.fromPartial({}),
        };
        if (isSet(object.employer)) {
            message.employer = globalThis.String(object.employer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.depositAmount !== undefined) {
            obj.depositAmount = exports.DepositAmount.toJSON(message.depositAmount);
        }
        if (message.employer !== undefined && message.employer !== '') {
            obj.employer = message.employer;
        }
        return obj;
    },
    create(base) {
        return exports.DepositSwitchSuccess.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDepositSwitchSuccess();
        message.depositAmount = (object.depositAmount !== undefined && object.depositAmount !== null)
            ? exports.DepositAmount.fromPartial(object.depositAmount)
            : exports.DepositAmount.fromPartial({});
        message.employer = object.employer ?? '';
        return message;
    },
};
function createBaseDepositSwitchFailed() {
    return { employer: '' };
}
exports.DepositSwitchFailed = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.employer)) {
            message.employer = globalThis.String(object.employer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.employer !== undefined && message.employer !== '') {
            obj.employer = message.employer;
        }
        return obj;
    },
    create(base) {
        return exports.DepositSwitchFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDepositSwitchFailed();
        message.employer = object.employer ?? '';
        return message;
    },
};
function createBaseGiftCardOrderReady() {
    return { giftCardOrderId: '', productName: '' };
}
exports.GiftCardOrderReady = {
    fromJSON(object) {
        const message = {
            giftCardOrderId: isSet(object.giftCardOrderId)
                ? globalThis.String(object.giftCardOrderId)
                : '',
            productName: isSet(object.productName) ? globalThis.String(object.productName) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.giftCardOrderId !== '') {
            obj.giftCardOrderId = message.giftCardOrderId;
        }
        if (message.productName !== '') {
            obj.productName = message.productName;
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardOrderReady.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardOrderReady();
        message.giftCardOrderId = object.giftCardOrderId ?? '';
        message.productName = object.productName ?? '';
        return message;
    },
};
function createBaseGiftCardOrderFailed() {
    return { giftCardOrderId: '', productName: '' };
}
exports.GiftCardOrderFailed = {
    fromJSON(object) {
        const message = {
            giftCardOrderId: isSet(object.giftCardOrderId)
                ? globalThis.String(object.giftCardOrderId)
                : '',
            productName: isSet(object.productName) ? globalThis.String(object.productName) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.giftCardOrderId !== '') {
            obj.giftCardOrderId = message.giftCardOrderId;
        }
        if (message.productName !== '') {
            obj.productName = message.productName;
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardOrderFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardOrderFailed();
        message.giftCardOrderId = object.giftCardOrderId ?? '';
        message.productName = object.productName ?? '';
        return message;
    },
};
function createBaseCardInactiveSms() {
    return { purchase: exports.Purchase.fromPartial({}), customer: undefined, memberId: '' };
}
exports.CardInactiveSms = {
    fromJSON(object) {
        const message = {
            purchase: isSet(object.purchase)
                ? exports.Purchase.fromJSON(object.purchase)
                : exports.Purchase.fromPartial({}),
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        if (isSet(object.memberId)) {
            message.memberId = globalThis.String(object.memberId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purchase !== undefined) {
            obj.purchase = exports.Purchase.toJSON(message.purchase);
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        if (message.memberId !== undefined && message.memberId !== '') {
            obj.memberId = message.memberId;
        }
        return obj;
    },
    create(base) {
        return exports.CardInactiveSms.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardInactiveSms();
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.Purchase.fromPartial(object.purchase)
            : exports.Purchase.fromPartial({});
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        message.memberId = object.memberId ?? '';
        return message;
    },
};
function createBaseStepBlackSubscribed() {
    return {};
}
exports.StepBlackSubscribed = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StepBlackSubscribed.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStepBlackSubscribed();
        return message;
    },
};
function createBaseBlackCardArrived() {
    return { cardId: '', customer: undefined };
}
exports.BlackCardArrived = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.BlackCardArrived.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlackCardArrived();
        message.cardId = object.cardId ?? '';
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseBlackCardShippingAhead() {
    return { cardId: '', customer: undefined };
}
exports.BlackCardShippingAhead = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.BlackCardShippingAhead.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlackCardShippingAhead();
        message.cardId = object.cardId ?? '';
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseBlackCardShippingDelay() {
    return { cardId: '', customer: undefined };
}
exports.BlackCardShippingDelay = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.customer)) {
            message.customer = legal_name_1.LegalName.fromJSON(object.customer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.customer !== undefined) {
            obj.customer = legal_name_1.LegalName.toJSON(message.customer);
        }
        return obj;
    },
    create(base) {
        return exports.BlackCardShippingDelay.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBlackCardShippingDelay();
        message.cardId = object.cardId ?? '';
        message.customer = (object.customer !== undefined && object.customer !== null)
            ? legal_name_1.LegalName.fromPartial(object.customer)
            : undefined;
        return message;
    },
};
function createBaseCheckCleared() {
    return {
        paymentId: '',
        primaryAccountId: '',
        amount: amount_1.Amount.fromPartial({}),
        fundsAvailableDate: timestamp_1.Timestamp.fromPartial({}),
    };
}
exports.CheckCleared = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            fundsAvailableDate: isSet(object.fundsAvailableDate)
                ? fromJsonTimestamp(object.fundsAvailableDate)
                : timestamp_1.Timestamp.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.fundsAvailableDate !== undefined) {
            obj.fundsAvailableDate = fromTimestamp(message.fundsAvailableDate).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.CheckCleared.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckCleared();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.fundsAvailableDate =
            (object.fundsAvailableDate !== undefined && object.fundsAvailableDate !== null)
                ? timestamp_1.Timestamp.fromPartial(object.fundsAvailableDate)
                : timestamp_1.Timestamp.fromPartial({});
        return message;
    },
};
function createBaseCheckReleased() {
    return { paymentId: '', primaryAccountId: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.CheckReleased = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.CheckReleased.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckReleased();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseCheckReturned() {
    return { paymentId: '', primaryAccountId: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.CheckReturned = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.CheckReturned.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckReturned();
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseAdhocMessage() {
    return { customParams: '' };
}
exports.AdhocMessage = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.customParams)) {
            message.customParams = globalThis.String(object.customParams);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.customParams !== undefined && message.customParams !== '') {
            obj.customParams = message.customParams;
        }
        return obj;
    },
    create(base) {
        return exports.AdhocMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAdhocMessage();
        message.customParams = object.customParams ?? '';
        return message;
    },
};
function createBaseAutoReloadCompleted() {
    return {
        paymentId: '',
        reload: amount_1.Amount.fromPartial({}),
        minBalance: amount_1.Amount.fromPartial({}),
        isAch: false,
    };
}
exports.AutoReloadCompleted = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            reload: isSet(object.reload) ? amount_1.Amount.fromJSON(object.reload) : amount_1.Amount.fromPartial({}),
            minBalance: isSet(object.minBalance)
                ? amount_1.Amount.fromJSON(object.minBalance)
                : amount_1.Amount.fromPartial({}),
            isAch: isSet(object.isAch) ? globalThis.Boolean(object.isAch) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.reload !== undefined) {
            obj.reload = amount_1.Amount.toJSON(message.reload);
        }
        if (message.minBalance !== undefined) {
            obj.minBalance = amount_1.Amount.toJSON(message.minBalance);
        }
        if (message.isAch !== false) {
            obj.isAch = message.isAch;
        }
        return obj;
    },
    create(base) {
        return exports.AutoReloadCompleted.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAutoReloadCompleted();
        message.paymentId = object.paymentId ?? '';
        message.reload = (object.reload !== undefined && object.reload !== null)
            ? amount_1.Amount.fromPartial(object.reload)
            : amount_1.Amount.fromPartial({});
        message.minBalance = (object.minBalance !== undefined && object.minBalance !== null)
            ? amount_1.Amount.fromPartial(object.minBalance)
            : amount_1.Amount.fromPartial({});
        message.isAch = object.isAch ?? false;
        return message;
    },
};
function createBaseAutoReloadFailed() {
    return { reload: amount_1.Amount.fromPartial({}) };
}
exports.AutoReloadFailed = {
    fromJSON(object) {
        const message = {
            reload: isSet(object.reload) ? amount_1.Amount.fromJSON(object.reload) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reload !== undefined) {
            obj.reload = amount_1.Amount.toJSON(message.reload);
        }
        return obj;
    },
    create(base) {
        return exports.AutoReloadFailed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAutoReloadFailed();
        message.reload = (object.reload !== undefined && object.reload !== null)
            ? amount_1.Amount.fromPartial(object.reload)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseAutoReloadManualReview() {
    return { paymentId: '', reload: amount_1.Amount.fromPartial({}) };
}
exports.AutoReloadManualReview = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            reload: isSet(object.reload) ? amount_1.Amount.fromJSON(object.reload) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.reload !== undefined) {
            obj.reload = amount_1.Amount.toJSON(message.reload);
        }
        return obj;
    },
    create(base) {
        return exports.AutoReloadManualReview.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAutoReloadManualReview();
        message.paymentId = object.paymentId ?? '';
        message.reload = (object.reload !== undefined && object.reload !== null)
            ? amount_1.Amount.fromPartial(object.reload)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseUnrecognizedDeviceLogin() {
    return { location: undefined, device: undefined, ip: '', loginAt: '', blockLink: '' };
}
exports.UnrecognizedDeviceLogin = {
    fromJSON(object) {
        const message = {
            loginAt: isSet(object.loginAt) ? globalThis.String(object.loginAt) : '',
            blockLink: isSet(object.blockLink) ? globalThis.String(object.blockLink) : '',
        };
        if (isSet(object.location)) {
            message.location = device_check_metadata_1.GeneralLocation.fromJSON(object.location);
        }
        if (isSet(object.device)) {
            message.device = device_1.Device.fromJSON(object.device);
        }
        if (isSet(object.ip)) {
            message.ip = globalThis.String(object.ip);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.location !== undefined) {
            obj.location = device_check_metadata_1.GeneralLocation.toJSON(message.location);
        }
        if (message.device !== undefined) {
            obj.device = device_1.Device.toJSON(message.device);
        }
        if (message.ip !== undefined && message.ip !== '') {
            obj.ip = message.ip;
        }
        if (message.loginAt !== '') {
            obj.loginAt = message.loginAt;
        }
        if (message.blockLink !== '') {
            obj.blockLink = message.blockLink;
        }
        return obj;
    },
    create(base) {
        return exports.UnrecognizedDeviceLogin.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnrecognizedDeviceLogin();
        message.location = (object.location !== undefined && object.location !== null)
            ? device_check_metadata_1.GeneralLocation.fromPartial(object.location)
            : undefined;
        message.device = (object.device !== undefined && object.device !== null)
            ? device_1.Device.fromPartial(object.device)
            : undefined;
        message.ip = object.ip ?? '';
        message.loginAt = object.loginAt ?? '';
        message.blockLink = object.blockLink ?? '';
        return message;
    },
};
function createBaseApplicationApproved() {
    return { deepLink: '' };
}
exports.ApplicationApproved = {
    fromJSON(object) {
        const message = {
            deepLink: isSet(object.deepLink) ? globalThis.String(object.deepLink) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.deepLink !== '') {
            obj.deepLink = message.deepLink;
        }
        return obj;
    },
    create(base) {
        return exports.ApplicationApproved.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApplicationApproved();
        message.deepLink = object.deepLink ?? '';
        return message;
    },
};
function createBaseSubscriptionMerchantCardUpdated() {
    return { merchantName: '', merchantId: '' };
}
exports.SubscriptionMerchantCardUpdated = {
    fromJSON(object) {
        const message = {
            merchantName: isSet(object.merchantName) ? globalThis.String(object.merchantName) : '',
            merchantId: isSet(object.merchantId) ? globalThis.String(object.merchantId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        if (message.merchantId !== '') {
            obj.merchantId = message.merchantId;
        }
        return obj;
    },
    create(base) {
        return exports.SubscriptionMerchantCardUpdated.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionMerchantCardUpdated();
        message.merchantName = object.merchantName ?? '';
        message.merchantId = object.merchantId ?? '';
        return message;
    },
};
function createBaseActivityUpdated() {
    return { updates: [] };
}
exports.ActivityUpdated = {
    fromJSON(object) {
        const message = {
            updates: globalThis.Array.isArray(object?.updates)
                ? object.updates.map((e) => exports.ActivityUpdatedAccountUpdate.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.updates?.length) {
            obj.updates = message.updates.map((e) => exports.ActivityUpdatedAccountUpdate.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ActivityUpdated.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityUpdated();
        message.updates = object.updates?.map((e) => exports.ActivityUpdatedAccountUpdate.fromPartial(e)) || [];
        return message;
    },
};
function createBaseActivityUpdatedAccountUpdate() {
    return { primaryAccountId: '', accountId: [] };
}
exports.ActivityUpdatedAccountUpdate = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (globalThis.Array.isArray(object?.accountId)) {
            message.accountId = object.accountId.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.accountId?.length) {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.ActivityUpdatedAccountUpdate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityUpdatedAccountUpdate();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.accountId = object.accountId?.map((e) => e) || [];
        return message;
    },
};
function createBaseLifecycleStoreRefresh() {
    return {};
}
exports.LifecycleStoreRefresh = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.LifecycleStoreRefresh.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseLifecycleStoreRefresh();
        return message;
    },
};
function createBaseNotification() {
    return {
        qualifier: '',
        accountLinkExpired: undefined,
        accountOwnerUpdated: undefined,
        achInFundingSuccess: undefined,
        achOutFundingFailed: undefined,
        achOutFundingFailedInsufficientFunds: undefined,
        achOutFundingReturn: undefined,
        achOutFundingSuccess: undefined,
        achP2pCancel: undefined,
        achP2pFailed: undefined,
        achP2pFailedInsufficientFunds: undefined,
        achP2pSuccess: undefined,
        activityUpdated: undefined,
        adhocMessage: undefined,
        applicationApproved: undefined,
        atmAccessDisabled: undefined,
        atmWithdrawalAccessDisabled: undefined,
        atmWithdrawalAuthorized: undefined,
        atmWithdrawalInsufficientFunds: undefined,
        atmWithdrawalLimitExceeded: undefined,
        authorizedUserUpdated: undefined,
        autoReloadCompleted: undefined,
        autoReloadFailed: undefined,
        autoReloadManualReview: undefined,
        billPaid: undefined,
        blackCardArrived: undefined,
        blackCardShippingAhead: undefined,
        blackCardShippingDelay: undefined,
        blackTierInherited: undefined,
        blackTierInheritedManagedUser: undefined,
        bnplAlmostDue: undefined,
        bnplPastDue: undefined,
        bnplPaymentFailed: undefined,
        bnplPaymentSuccessful: undefined,
        cardActivated: undefined,
        cardCanceled: undefined,
        cardFundingApproved: undefined,
        cardFundingFailed: undefined,
        cardInactive: undefined,
        cardInactiveSms: undefined,
        cardOrdered: undefined,
        cardPayoutReversal: undefined,
        cardPinBlocked: undefined,
        cardPurchaseAuthorized: undefined,
        cardPurchaseInsufficientFunds: undefined,
        cardPurchaseRefunded: undefined,
        cardPurchaseReversed: undefined,
        cardReplaced: undefined,
        cardShipped: undefined,
        checkCleared: undefined,
        checkReleased: undefined,
        checkReturned: undefined,
        contactHasJoinedStep: undefined,
        contributedToSavingsGoal: undefined,
        corporateAction: undefined,
        cosponsorFamilyInvite: undefined,
        creditScoreChanged: undefined,
        cryptoDisabled: undefined,
        cryptoEnrollmentApproval: undefined,
        cryptoGraduationTransferSuccess: undefined,
        cryptoRoundUpSuccess: undefined,
        ctaAvailable: undefined,
        customerRecoupment: undefined,
        customerTransfer: undefined,
        depositSwitchFailed: undefined,
        depositSwitchSuccess: undefined,
        disputeCredit: undefined,
        disputeCreditReversal: undefined,
        downgradedFromBlackTier: undefined,
        familyInvite: undefined,
        familyInviteApproved: undefined,
        familyInviteDenied: undefined,
        familyInviteSms: undefined,
        flexAutoPayFailed: undefined,
        flexBillDue: undefined,
        foreignPurchaseBlocked: undefined,
        freeOutOfNetworkAtmWithdrawalAuthorized: undefined,
        giftCardOrderReady: undefined,
        giftCardOrderFailed: undefined,
        inNetworkAtmWithdrawalAuthorized: undefined,
        issuingDisputeUpdated: undefined,
        joinedFamily: undefined,
        kycExpired: undefined,
        kycFailed: undefined,
        kycSuccess: undefined,
        kycStatusUpdate: undefined,
        lifecycleStoreRefresh: undefined,
        lockCard: undefined,
        marketingMessage: undefined,
        moneyReceived: undefined,
        moneyReceivedFromNonStep: undefined,
        moneyRequested: undefined,
        moneyRequestedExpired: undefined,
        moneyRequestedRejected: undefined,
        moneySentExpired: undefined,
        moneySentLimitExceeded: undefined,
        offerRewardReceived: undefined,
        offerWillExpire: undefined,
        otpRecovery: undefined,
        otpRequested: undefined,
        otpVerification: undefined,
        outOfNetworkAtmWithdrawalAuthorized: undefined,
        outstandingBill: undefined,
        paymentCycleReminder: undefined,
        plaidExchangeLink: undefined,
        plusTierEnrolled: undefined,
        plusTierEnrolledManagedUser: undefined,
        purchaseCardLocked: undefined,
        recurringTransferAccountExpired: undefined,
        recurringTransferReminder: undefined,
        recurringTransferFailed: undefined,
        recurringTransferInsufficientFunds: undefined,
        recurringTransferSent: undefined,
        redeemerReward: undefined,
        refereeReminder: undefined,
        referralBonus: undefined,
        referralInvite: undefined,
        referralRedemptionReminder: undefined,
        referralReward: undefined,
        savingsInterest: undefined,
        savingsContributionMatched: undefined,
        savingsContributionMatchDeclined: undefined,
        sponseeAddedDebitCard: undefined,
        sponseeClosedSavingsGoalWithMatching: undefined,
        sponseeCreatedSavingsGoal: undefined,
        sponseeLeftFamily: undefined,
        sponseeTurnedOffSavingsMatching: undefined,
        sponsorAcceptedSavingsMatching: undefined,
        sponsorCreatedSavingsGoal: undefined,
        sponsorTurnedOffSavingsMatching: undefined,
        startedRedemption: undefined,
        stepBlackSubscribed: undefined,
        stockDayTradeDetected: undefined,
        stockGraduationTransferSuccess: undefined,
        stockOrderCancelled: undefined,
        stockOrderFilled: undefined,
        stockOrderRejected: undefined,
        stockRiskLevelUpdate: undefined,
        stockSponseeApproved: undefined,
        subscriptionMerchantCardUpdated: undefined,
        subscriptionRenewalFailed: undefined,
        unlockCard: undefined,
        unrecognizedDeviceLogin: undefined,
        withdrawReturn: undefined,
        testMessage: undefined,
    };
}
exports.Notification = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.qualifier)) {
            message.qualifier = globalThis.String(object.qualifier);
        }
        if (isSet(object.accountLinkExpired)) {
            message.accountLinkExpired = exports.AccountLinkExpired.fromJSON(object.accountLinkExpired);
        }
        if (isSet(object.accountOwnerUpdated)) {
            message.accountOwnerUpdated = exports.AccountOwnerUpdated.fromJSON(object.accountOwnerUpdated);
        }
        if (isSet(object.achInFundingSuccess)) {
            message.achInFundingSuccess = exports.AchInFundingSuccess.fromJSON(object.achInFundingSuccess);
        }
        if (isSet(object.achOutFundingFailed)) {
            message.achOutFundingFailed = exports.AchOutFundingFailed.fromJSON(object.achOutFundingFailed);
        }
        if (isSet(object.achOutFundingFailedInsufficientFunds)) {
            message.achOutFundingFailedInsufficientFunds = exports.AchOutFundingFailedInsufficientFunds.fromJSON(object.achOutFundingFailedInsufficientFunds);
        }
        if (isSet(object.achOutFundingReturn)) {
            message.achOutFundingReturn = exports.AchOutFundingReturn.fromJSON(object.achOutFundingReturn);
        }
        if (isSet(object.achOutFundingSuccess)) {
            message.achOutFundingSuccess = exports.AchOutFundingSuccess.fromJSON(object.achOutFundingSuccess);
        }
        if (isSet(object.achP2pCancel)) {
            message.achP2pCancel = exports.AchP2pCancel.fromJSON(object.achP2pCancel);
        }
        if (isSet(object.achP2pFailed)) {
            message.achP2pFailed = exports.AchP2pFailed.fromJSON(object.achP2pFailed);
        }
        if (isSet(object.achP2pFailedInsufficientFunds)) {
            message.achP2pFailedInsufficientFunds = exports.AchP2pFailedInsufficientFunds.fromJSON(object.achP2pFailedInsufficientFunds);
        }
        if (isSet(object.achP2pSuccess)) {
            message.achP2pSuccess = exports.AchP2pSuccess.fromJSON(object.achP2pSuccess);
        }
        if (isSet(object.activityUpdated)) {
            message.activityUpdated = exports.ActivityUpdated.fromJSON(object.activityUpdated);
        }
        if (isSet(object.adhocMessage)) {
            message.adhocMessage = exports.AdhocMessage.fromJSON(object.adhocMessage);
        }
        if (isSet(object.applicationApproved)) {
            message.applicationApproved = exports.ApplicationApproved.fromJSON(object.applicationApproved);
        }
        if (isSet(object.atmAccessDisabled)) {
            message.atmAccessDisabled = exports.AtmAccessDisabled.fromJSON(object.atmAccessDisabled);
        }
        if (isSet(object.atmWithdrawalAccessDisabled)) {
            message.atmWithdrawalAccessDisabled = exports.AtmWithdrawalAccessDisabled.fromJSON(object.atmWithdrawalAccessDisabled);
        }
        if (isSet(object.atmWithdrawalAuthorized)) {
            message.atmWithdrawalAuthorized = exports.AtmWithdrawalAuthorized.fromJSON(object.atmWithdrawalAuthorized);
        }
        if (isSet(object.atmWithdrawalInsufficientFunds)) {
            message.atmWithdrawalInsufficientFunds = exports.AtmWithdrawalInsufficientFunds.fromJSON(object.atmWithdrawalInsufficientFunds);
        }
        if (isSet(object.atmWithdrawalLimitExceeded)) {
            message.atmWithdrawalLimitExceeded = exports.AtmWithdrawalLimitExceeded.fromJSON(object.atmWithdrawalLimitExceeded);
        }
        if (isSet(object.authorizedUserUpdated)) {
            message.authorizedUserUpdated = exports.AuthorizedUserUpdated.fromJSON(object.authorizedUserUpdated);
        }
        if (isSet(object.autoReloadCompleted)) {
            message.autoReloadCompleted = exports.AutoReloadCompleted.fromJSON(object.autoReloadCompleted);
        }
        if (isSet(object.autoReloadFailed)) {
            message.autoReloadFailed = exports.AutoReloadFailed.fromJSON(object.autoReloadFailed);
        }
        if (isSet(object.autoReloadManualReview)) {
            message.autoReloadManualReview = exports.AutoReloadManualReview.fromJSON(object.autoReloadManualReview);
        }
        if (isSet(object.billPaid)) {
            message.billPaid = exports.BillPaid.fromJSON(object.billPaid);
        }
        if (isSet(object.blackCardArrived)) {
            message.blackCardArrived = exports.BlackCardArrived.fromJSON(object.blackCardArrived);
        }
        if (isSet(object.blackCardShippingAhead)) {
            message.blackCardShippingAhead = exports.BlackCardShippingAhead.fromJSON(object.blackCardShippingAhead);
        }
        if (isSet(object.blackCardShippingDelay)) {
            message.blackCardShippingDelay = exports.BlackCardShippingDelay.fromJSON(object.blackCardShippingDelay);
        }
        if (isSet(object.blackTierInherited)) {
            message.blackTierInherited = exports.BlackTierInherited.fromJSON(object.blackTierInherited);
        }
        if (isSet(object.blackTierInheritedManagedUser)) {
            message.blackTierInheritedManagedUser = exports.BlackTierInheritedManagedUser.fromJSON(object.blackTierInheritedManagedUser);
        }
        if (isSet(object.bnplAlmostDue)) {
            message.bnplAlmostDue = exports.BnplAlmostDue.fromJSON(object.bnplAlmostDue);
        }
        if (isSet(object.bnplPastDue)) {
            message.bnplPastDue = exports.BnplPastDue.fromJSON(object.bnplPastDue);
        }
        if (isSet(object.bnplPaymentFailed)) {
            message.bnplPaymentFailed = exports.BnplPaymentFailed.fromJSON(object.bnplPaymentFailed);
        }
        if (isSet(object.bnplPaymentSuccessful)) {
            message.bnplPaymentSuccessful = exports.BnplPaymentSuccessful.fromJSON(object.bnplPaymentSuccessful);
        }
        if (isSet(object.cardActivated)) {
            message.cardActivated = exports.CardActivated.fromJSON(object.cardActivated);
        }
        if (isSet(object.cardCanceled)) {
            message.cardCanceled = exports.CardCanceled.fromJSON(object.cardCanceled);
        }
        if (isSet(object.cardFundingApproved)) {
            message.cardFundingApproved = exports.CardFundingApproved.fromJSON(object.cardFundingApproved);
        }
        if (isSet(object.cardFundingFailed)) {
            message.cardFundingFailed = exports.CardFundingFailed.fromJSON(object.cardFundingFailed);
        }
        if (isSet(object.cardInactive)) {
            message.cardInactive = exports.CardInactive.fromJSON(object.cardInactive);
        }
        if (isSet(object.cardInactiveSms)) {
            message.cardInactiveSms = exports.CardInactiveSms.fromJSON(object.cardInactiveSms);
        }
        if (isSet(object.cardOrdered)) {
            message.cardOrdered = exports.CardOrdered.fromJSON(object.cardOrdered);
        }
        if (isSet(object.cardPayoutReversal)) {
            message.cardPayoutReversal = exports.CardPayoutReversal.fromJSON(object.cardPayoutReversal);
        }
        if (isSet(object.cardPinBlocked)) {
            message.cardPinBlocked = exports.CardPinBlocked.fromJSON(object.cardPinBlocked);
        }
        if (isSet(object.cardPurchaseAuthorized)) {
            message.cardPurchaseAuthorized = exports.CardPurchaseAuthorized.fromJSON(object.cardPurchaseAuthorized);
        }
        if (isSet(object.cardPurchaseInsufficientFunds)) {
            message.cardPurchaseInsufficientFunds = exports.CardPurchaseInsufficientFunds.fromJSON(object.cardPurchaseInsufficientFunds);
        }
        if (isSet(object.cardPurchaseRefunded)) {
            message.cardPurchaseRefunded = exports.CardPurchaseRefunded.fromJSON(object.cardPurchaseRefunded);
        }
        if (isSet(object.cardPurchaseReversed)) {
            message.cardPurchaseReversed = exports.CardPurchaseReversed.fromJSON(object.cardPurchaseReversed);
        }
        if (isSet(object.cardReplaced)) {
            message.cardReplaced = exports.CardReplaced.fromJSON(object.cardReplaced);
        }
        if (isSet(object.cardShipped)) {
            message.cardShipped = exports.CardShipped.fromJSON(object.cardShipped);
        }
        if (isSet(object.checkCleared)) {
            message.checkCleared = exports.CheckCleared.fromJSON(object.checkCleared);
        }
        if (isSet(object.checkReleased)) {
            message.checkReleased = exports.CheckReleased.fromJSON(object.checkReleased);
        }
        if (isSet(object.checkReturned)) {
            message.checkReturned = exports.CheckReturned.fromJSON(object.checkReturned);
        }
        if (isSet(object.contactHasJoinedStep)) {
            message.contactHasJoinedStep = exports.ContactHasJoinedStep.fromJSON(object.contactHasJoinedStep);
        }
        if (isSet(object.contributedToSavingsGoal)) {
            message.contributedToSavingsGoal = exports.ContributedToSavingsGoal.fromJSON(object.contributedToSavingsGoal);
        }
        if (isSet(object.corporateAction)) {
            message.corporateAction = exports.CorporateAction.fromJSON(object.corporateAction);
        }
        if (isSet(object.cosponsorFamilyInvite)) {
            message.cosponsorFamilyInvite = exports.CosponsorFamilyInvite.fromJSON(object.cosponsorFamilyInvite);
        }
        if (isSet(object.creditScoreChanged)) {
            message.creditScoreChanged = exports.CreditScoreChanged.fromJSON(object.creditScoreChanged);
        }
        if (isSet(object.cryptoDisabled)) {
            message.cryptoDisabled = exports.CryptoDisabled.fromJSON(object.cryptoDisabled);
        }
        if (isSet(object.cryptoEnrollmentApproval)) {
            message.cryptoEnrollmentApproval = exports.CryptoEnrollmentApproval.fromJSON(object.cryptoEnrollmentApproval);
        }
        if (isSet(object.cryptoGraduationTransferSuccess)) {
            message.cryptoGraduationTransferSuccess = exports.CryptoGraduationTransferSuccess.fromJSON(object.cryptoGraduationTransferSuccess);
        }
        if (isSet(object.cryptoRoundUpSuccess)) {
            message.cryptoRoundUpSuccess = exports.CryptoRoundUpSuccess.fromJSON(object.cryptoRoundUpSuccess);
        }
        if (isSet(object.ctaAvailable)) {
            message.ctaAvailable = exports.CtaAvailable.fromJSON(object.ctaAvailable);
        }
        if (isSet(object.customerRecoupment)) {
            message.customerRecoupment = exports.CustomerRecoupment.fromJSON(object.customerRecoupment);
        }
        if (isSet(object.customerTransfer)) {
            message.customerTransfer = exports.CustomerTransfer.fromJSON(object.customerTransfer);
        }
        if (isSet(object.depositSwitchFailed)) {
            message.depositSwitchFailed = exports.DepositSwitchFailed.fromJSON(object.depositSwitchFailed);
        }
        if (isSet(object.depositSwitchSuccess)) {
            message.depositSwitchSuccess = exports.DepositSwitchSuccess.fromJSON(object.depositSwitchSuccess);
        }
        if (isSet(object.disputeCredit)) {
            message.disputeCredit = exports.DisputeCredit.fromJSON(object.disputeCredit);
        }
        if (isSet(object.disputeCreditReversal)) {
            message.disputeCreditReversal = exports.DisputeCreditReversal.fromJSON(object.disputeCreditReversal);
        }
        if (isSet(object.downgradedFromBlackTier)) {
            message.downgradedFromBlackTier = exports.DowngradedFromBlackTier.fromJSON(object.downgradedFromBlackTier);
        }
        if (isSet(object.familyInvite)) {
            message.familyInvite = exports.FamilyInvite.fromJSON(object.familyInvite);
        }
        if (isSet(object.familyInviteApproved)) {
            message.familyInviteApproved = exports.FamilyInviteApproved.fromJSON(object.familyInviteApproved);
        }
        if (isSet(object.familyInviteDenied)) {
            message.familyInviteDenied = exports.FamilyInviteDenied.fromJSON(object.familyInviteDenied);
        }
        if (isSet(object.familyInviteSms)) {
            message.familyInviteSms = exports.FamilyInviteSms.fromJSON(object.familyInviteSms);
        }
        if (isSet(object.flexAutoPayFailed)) {
            message.flexAutoPayFailed = exports.FlexAutoPayFailed.fromJSON(object.flexAutoPayFailed);
        }
        if (isSet(object.flexBillDue)) {
            message.flexBillDue = exports.FlexBillDue.fromJSON(object.flexBillDue);
        }
        if (isSet(object.foreignPurchaseBlocked)) {
            message.foreignPurchaseBlocked = exports.ForeignPurchaseBlocked.fromJSON(object.foreignPurchaseBlocked);
        }
        if (isSet(object.freeOutOfNetworkAtmWithdrawalAuthorized)) {
            message.freeOutOfNetworkAtmWithdrawalAuthorized = exports.FreeOutOfNetworkAtmWithdrawalAuthorized
                .fromJSON(object.freeOutOfNetworkAtmWithdrawalAuthorized);
        }
        if (isSet(object.giftCardOrderReady)) {
            message.giftCardOrderReady = exports.GiftCardOrderReady.fromJSON(object.giftCardOrderReady);
        }
        if (isSet(object.giftCardOrderFailed)) {
            message.giftCardOrderFailed = exports.GiftCardOrderFailed.fromJSON(object.giftCardOrderFailed);
        }
        if (isSet(object.inNetworkAtmWithdrawalAuthorized)) {
            message.inNetworkAtmWithdrawalAuthorized = exports.InNetworkAtmWithdrawalAuthorized.fromJSON(object.inNetworkAtmWithdrawalAuthorized);
        }
        if (isSet(object.issuingDisputeUpdated)) {
            message.issuingDisputeUpdated = exports.IssuingDisputeUpdated.fromJSON(object.issuingDisputeUpdated);
        }
        if (isSet(object.joinedFamily)) {
            message.joinedFamily = exports.JoinedFamily.fromJSON(object.joinedFamily);
        }
        if (isSet(object.kycExpired)) {
            message.kycExpired = exports.KycExpired.fromJSON(object.kycExpired);
        }
        if (isSet(object.kycFailed)) {
            message.kycFailed = exports.KycFailed.fromJSON(object.kycFailed);
        }
        if (isSet(object.kycSuccess)) {
            message.kycSuccess = exports.KycSuccess.fromJSON(object.kycSuccess);
        }
        if (isSet(object.kycStatusUpdate)) {
            message.kycStatusUpdate = exports.KycStatusUpdate.fromJSON(object.kycStatusUpdate);
        }
        if (isSet(object.lifecycleStoreRefresh)) {
            message.lifecycleStoreRefresh = exports.LifecycleStoreRefresh.fromJSON(object.lifecycleStoreRefresh);
        }
        if (isSet(object.lockCard)) {
            message.lockCard = exports.LockCard.fromJSON(object.lockCard);
        }
        if (isSet(object.marketingMessage)) {
            message.marketingMessage = exports.MarketingMessage.fromJSON(object.marketingMessage);
        }
        if (isSet(object.moneyReceived)) {
            message.moneyReceived = exports.MoneyReceived.fromJSON(object.moneyReceived);
        }
        if (isSet(object.moneyReceivedFromNonStep)) {
            message.moneyReceivedFromNonStep = exports.MoneyReceivedFromNonStep.fromJSON(object.moneyReceivedFromNonStep);
        }
        if (isSet(object.moneyRequested)) {
            message.moneyRequested = exports.MoneyRequested.fromJSON(object.moneyRequested);
        }
        if (isSet(object.moneyRequestedExpired)) {
            message.moneyRequestedExpired = exports.MoneyRequestedExpired.fromJSON(object.moneyRequestedExpired);
        }
        if (isSet(object.moneyRequestedRejected)) {
            message.moneyRequestedRejected = exports.MoneyRequestedRejected.fromJSON(object.moneyRequestedRejected);
        }
        if (isSet(object.moneySentExpired)) {
            message.moneySentExpired = exports.MoneySentExpired.fromJSON(object.moneySentExpired);
        }
        if (isSet(object.moneySentLimitExceeded)) {
            message.moneySentLimitExceeded = exports.MoneySentLimitExceeded.fromJSON(object.moneySentLimitExceeded);
        }
        if (isSet(object.offerRewardReceived)) {
            message.offerRewardReceived = exports.OfferRewardReceived.fromJSON(object.offerRewardReceived);
        }
        if (isSet(object.offerWillExpire)) {
            message.offerWillExpire = exports.OfferWillExpire.fromJSON(object.offerWillExpire);
        }
        if (isSet(object.otpRecovery)) {
            message.otpRecovery = exports.OtpRecovery.fromJSON(object.otpRecovery);
        }
        if (isSet(object.otpRequested)) {
            message.otpRequested = exports.OtpRequested.fromJSON(object.otpRequested);
        }
        if (isSet(object.otpVerification)) {
            message.otpVerification = exports.OtpVerification.fromJSON(object.otpVerification);
        }
        if (isSet(object.outOfNetworkAtmWithdrawalAuthorized)) {
            message.outOfNetworkAtmWithdrawalAuthorized = exports.OutOfNetworkAtmWithdrawalAuthorized.fromJSON(object.outOfNetworkAtmWithdrawalAuthorized);
        }
        if (isSet(object.outstandingBill)) {
            message.outstandingBill = exports.OutstandingBill.fromJSON(object.outstandingBill);
        }
        if (isSet(object.paymentCycleReminder)) {
            message.paymentCycleReminder = exports.PaymentCycleReminder.fromJSON(object.paymentCycleReminder);
        }
        if (isSet(object.plaidExchangeLink)) {
            message.plaidExchangeLink = exports.PlaidExchangeLink.fromJSON(object.plaidExchangeLink);
        }
        if (isSet(object.plusTierEnrolled)) {
            message.plusTierEnrolled = exports.PlusTierEnrolled.fromJSON(object.plusTierEnrolled);
        }
        if (isSet(object.plusTierEnrolledManagedUser)) {
            message.plusTierEnrolledManagedUser = exports.PlusTierEnrolledManagedUser.fromJSON(object.plusTierEnrolledManagedUser);
        }
        if (isSet(object.purchaseCardLocked)) {
            message.purchaseCardLocked = exports.PurchaseCardLocked.fromJSON(object.purchaseCardLocked);
        }
        if (isSet(object.recurringTransferAccountExpired)) {
            message.recurringTransferAccountExpired = exports.RecurringTransferAccountExpired.fromJSON(object.recurringTransferAccountExpired);
        }
        if (isSet(object.recurringTransferReminder)) {
            message.recurringTransferReminder = exports.RecurringTransferReminder.fromJSON(object.recurringTransferReminder);
        }
        if (isSet(object.recurringTransferFailed)) {
            message.recurringTransferFailed = exports.RecurringTransferFailed.fromJSON(object.recurringTransferFailed);
        }
        if (isSet(object.recurringTransferInsufficientFunds)) {
            message.recurringTransferInsufficientFunds = exports.RecurringTransferInsufficientFunds.fromJSON(object.recurringTransferInsufficientFunds);
        }
        if (isSet(object.recurringTransferSent)) {
            message.recurringTransferSent = exports.RecurringTransferSent.fromJSON(object.recurringTransferSent);
        }
        if (isSet(object.redeemerReward)) {
            message.redeemerReward = exports.RedeemerReward.fromJSON(object.redeemerReward);
        }
        if (isSet(object.refereeReminder)) {
            message.refereeReminder = exports.RefereeReminder.fromJSON(object.refereeReminder);
        }
        if (isSet(object.referralBonus)) {
            message.referralBonus = exports.ReferralBonus.fromJSON(object.referralBonus);
        }
        if (isSet(object.referralInvite)) {
            message.referralInvite = exports.ReferralInvite.fromJSON(object.referralInvite);
        }
        if (isSet(object.referralRedemptionReminder)) {
            message.referralRedemptionReminder = exports.ReferralRedemptionReminder.fromJSON(object.referralRedemptionReminder);
        }
        if (isSet(object.referralReward)) {
            message.referralReward = exports.ReferralReward.fromJSON(object.referralReward);
        }
        if (isSet(object.savingsInterest)) {
            message.savingsInterest = exports.SavingsInterest.fromJSON(object.savingsInterest);
        }
        if (isSet(object.savingsContributionMatched)) {
            message.savingsContributionMatched = exports.SavingsContributionMatched.fromJSON(object.savingsContributionMatched);
        }
        if (isSet(object.savingsContributionMatchDeclined)) {
            message.savingsContributionMatchDeclined = exports.SavingsContributionMatchDeclined.fromJSON(object.savingsContributionMatchDeclined);
        }
        if (isSet(object.sponseeAddedDebitCard)) {
            message.sponseeAddedDebitCard = exports.SponseeAddedDebitCard.fromJSON(object.sponseeAddedDebitCard);
        }
        if (isSet(object.sponseeClosedSavingsGoalWithMatching)) {
            message.sponseeClosedSavingsGoalWithMatching = exports.SponseeClosedSavingsGoalWithMatching.fromJSON(object.sponseeClosedSavingsGoalWithMatching);
        }
        if (isSet(object.sponseeCreatedSavingsGoal)) {
            message.sponseeCreatedSavingsGoal = exports.SponseeCreatedSavingsGoal.fromJSON(object.sponseeCreatedSavingsGoal);
        }
        if (isSet(object.sponseeLeftFamily)) {
            message.sponseeLeftFamily = exports.SponseeLeftFamily.fromJSON(object.sponseeLeftFamily);
        }
        if (isSet(object.sponseeTurnedOffSavingsMatching)) {
            message.sponseeTurnedOffSavingsMatching = exports.SponseeTurnedOffSavingsMatching.fromJSON(object.sponseeTurnedOffSavingsMatching);
        }
        if (isSet(object.sponsorAcceptedSavingsMatching)) {
            message.sponsorAcceptedSavingsMatching = exports.SponsorAcceptedSavingsMatching.fromJSON(object.sponsorAcceptedSavingsMatching);
        }
        if (isSet(object.sponsorCreatedSavingsGoal)) {
            message.sponsorCreatedSavingsGoal = exports.SponsorCreatedSavingsGoal.fromJSON(object.sponsorCreatedSavingsGoal);
        }
        if (isSet(object.sponsorTurnedOffSavingsMatching)) {
            message.sponsorTurnedOffSavingsMatching = exports.SponsorTurnedOffSavingsMatching.fromJSON(object.sponsorTurnedOffSavingsMatching);
        }
        if (isSet(object.startedRedemption)) {
            message.startedRedemption = exports.StartedRedemption.fromJSON(object.startedRedemption);
        }
        if (isSet(object.stepBlackSubscribed)) {
            message.stepBlackSubscribed = exports.StepBlackSubscribed.fromJSON(object.stepBlackSubscribed);
        }
        if (isSet(object.stockDayTradeDetected)) {
            message.stockDayTradeDetected = exports.StockDayTradeDetected.fromJSON(object.stockDayTradeDetected);
        }
        if (isSet(object.stockGraduationTransferSuccess)) {
            message.stockGraduationTransferSuccess = exports.StockGraduationTransferSuccess.fromJSON(object.stockGraduationTransferSuccess);
        }
        if (isSet(object.stockOrderCancelled)) {
            message.stockOrderCancelled = exports.StockOrderCancelled.fromJSON(object.stockOrderCancelled);
        }
        if (isSet(object.stockOrderFilled)) {
            message.stockOrderFilled = exports.StockOrderFilled.fromJSON(object.stockOrderFilled);
        }
        if (isSet(object.stockOrderRejected)) {
            message.stockOrderRejected = exports.StockOrderRejected.fromJSON(object.stockOrderRejected);
        }
        if (isSet(object.stockRiskLevelUpdate)) {
            message.stockRiskLevelUpdate = exports.StockRiskLevelUpdate.fromJSON(object.stockRiskLevelUpdate);
        }
        if (isSet(object.stockSponseeApproved)) {
            message.stockSponseeApproved = exports.StockSponseeApproved.fromJSON(object.stockSponseeApproved);
        }
        if (isSet(object.subscriptionMerchantCardUpdated)) {
            message.subscriptionMerchantCardUpdated = exports.SubscriptionMerchantCardUpdated.fromJSON(object.subscriptionMerchantCardUpdated);
        }
        if (isSet(object.subscriptionRenewalFailed)) {
            message.subscriptionRenewalFailed = exports.SubscriptionRenewalFailed.fromJSON(object.subscriptionRenewalFailed);
        }
        if (isSet(object.unlockCard)) {
            message.unlockCard = exports.UnlockCard.fromJSON(object.unlockCard);
        }
        if (isSet(object.unrecognizedDeviceLogin)) {
            message.unrecognizedDeviceLogin = exports.UnrecognizedDeviceLogin.fromJSON(object.unrecognizedDeviceLogin);
        }
        if (isSet(object.withdrawReturn)) {
            message.withdrawReturn = exports.WithdrawReturn.fromJSON(object.withdrawReturn);
        }
        if (isSet(object.testMessage)) {
            message.testMessage = exports.TestMessage.fromJSON(object.testMessage);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.qualifier !== undefined && message.qualifier !== '') {
            obj.qualifier = message.qualifier;
        }
        if (message.accountLinkExpired !== undefined) {
            obj.accountLinkExpired = exports.AccountLinkExpired.toJSON(message.accountLinkExpired);
        }
        if (message.accountOwnerUpdated !== undefined) {
            obj.accountOwnerUpdated = exports.AccountOwnerUpdated.toJSON(message.accountOwnerUpdated);
        }
        if (message.achInFundingSuccess !== undefined) {
            obj.achInFundingSuccess = exports.AchInFundingSuccess.toJSON(message.achInFundingSuccess);
        }
        if (message.achOutFundingFailed !== undefined) {
            obj.achOutFundingFailed = exports.AchOutFundingFailed.toJSON(message.achOutFundingFailed);
        }
        if (message.achOutFundingFailedInsufficientFunds !== undefined) {
            obj.achOutFundingFailedInsufficientFunds = exports.AchOutFundingFailedInsufficientFunds.toJSON(message.achOutFundingFailedInsufficientFunds);
        }
        if (message.achOutFundingReturn !== undefined) {
            obj.achOutFundingReturn = exports.AchOutFundingReturn.toJSON(message.achOutFundingReturn);
        }
        if (message.achOutFundingSuccess !== undefined) {
            obj.achOutFundingSuccess = exports.AchOutFundingSuccess.toJSON(message.achOutFundingSuccess);
        }
        if (message.achP2pCancel !== undefined) {
            obj.achP2pCancel = exports.AchP2pCancel.toJSON(message.achP2pCancel);
        }
        if (message.achP2pFailed !== undefined) {
            obj.achP2pFailed = exports.AchP2pFailed.toJSON(message.achP2pFailed);
        }
        if (message.achP2pFailedInsufficientFunds !== undefined) {
            obj.achP2pFailedInsufficientFunds = exports.AchP2pFailedInsufficientFunds.toJSON(message.achP2pFailedInsufficientFunds);
        }
        if (message.achP2pSuccess !== undefined) {
            obj.achP2pSuccess = exports.AchP2pSuccess.toJSON(message.achP2pSuccess);
        }
        if (message.activityUpdated !== undefined) {
            obj.activityUpdated = exports.ActivityUpdated.toJSON(message.activityUpdated);
        }
        if (message.adhocMessage !== undefined) {
            obj.adhocMessage = exports.AdhocMessage.toJSON(message.adhocMessage);
        }
        if (message.applicationApproved !== undefined) {
            obj.applicationApproved = exports.ApplicationApproved.toJSON(message.applicationApproved);
        }
        if (message.atmAccessDisabled !== undefined) {
            obj.atmAccessDisabled = exports.AtmAccessDisabled.toJSON(message.atmAccessDisabled);
        }
        if (message.atmWithdrawalAccessDisabled !== undefined) {
            obj.atmWithdrawalAccessDisabled = exports.AtmWithdrawalAccessDisabled.toJSON(message.atmWithdrawalAccessDisabled);
        }
        if (message.atmWithdrawalAuthorized !== undefined) {
            obj.atmWithdrawalAuthorized = exports.AtmWithdrawalAuthorized.toJSON(message.atmWithdrawalAuthorized);
        }
        if (message.atmWithdrawalInsufficientFunds !== undefined) {
            obj.atmWithdrawalInsufficientFunds = exports.AtmWithdrawalInsufficientFunds.toJSON(message.atmWithdrawalInsufficientFunds);
        }
        if (message.atmWithdrawalLimitExceeded !== undefined) {
            obj.atmWithdrawalLimitExceeded = exports.AtmWithdrawalLimitExceeded.toJSON(message.atmWithdrawalLimitExceeded);
        }
        if (message.authorizedUserUpdated !== undefined) {
            obj.authorizedUserUpdated = exports.AuthorizedUserUpdated.toJSON(message.authorizedUserUpdated);
        }
        if (message.autoReloadCompleted !== undefined) {
            obj.autoReloadCompleted = exports.AutoReloadCompleted.toJSON(message.autoReloadCompleted);
        }
        if (message.autoReloadFailed !== undefined) {
            obj.autoReloadFailed = exports.AutoReloadFailed.toJSON(message.autoReloadFailed);
        }
        if (message.autoReloadManualReview !== undefined) {
            obj.autoReloadManualReview = exports.AutoReloadManualReview.toJSON(message.autoReloadManualReview);
        }
        if (message.billPaid !== undefined) {
            obj.billPaid = exports.BillPaid.toJSON(message.billPaid);
        }
        if (message.blackCardArrived !== undefined) {
            obj.blackCardArrived = exports.BlackCardArrived.toJSON(message.blackCardArrived);
        }
        if (message.blackCardShippingAhead !== undefined) {
            obj.blackCardShippingAhead = exports.BlackCardShippingAhead.toJSON(message.blackCardShippingAhead);
        }
        if (message.blackCardShippingDelay !== undefined) {
            obj.blackCardShippingDelay = exports.BlackCardShippingDelay.toJSON(message.blackCardShippingDelay);
        }
        if (message.blackTierInherited !== undefined) {
            obj.blackTierInherited = exports.BlackTierInherited.toJSON(message.blackTierInherited);
        }
        if (message.blackTierInheritedManagedUser !== undefined) {
            obj.blackTierInheritedManagedUser = exports.BlackTierInheritedManagedUser.toJSON(message.blackTierInheritedManagedUser);
        }
        if (message.bnplAlmostDue !== undefined) {
            obj.bnplAlmostDue = exports.BnplAlmostDue.toJSON(message.bnplAlmostDue);
        }
        if (message.bnplPastDue !== undefined) {
            obj.bnplPastDue = exports.BnplPastDue.toJSON(message.bnplPastDue);
        }
        if (message.bnplPaymentFailed !== undefined) {
            obj.bnplPaymentFailed = exports.BnplPaymentFailed.toJSON(message.bnplPaymentFailed);
        }
        if (message.bnplPaymentSuccessful !== undefined) {
            obj.bnplPaymentSuccessful = exports.BnplPaymentSuccessful.toJSON(message.bnplPaymentSuccessful);
        }
        if (message.cardActivated !== undefined) {
            obj.cardActivated = exports.CardActivated.toJSON(message.cardActivated);
        }
        if (message.cardCanceled !== undefined) {
            obj.cardCanceled = exports.CardCanceled.toJSON(message.cardCanceled);
        }
        if (message.cardFundingApproved !== undefined) {
            obj.cardFundingApproved = exports.CardFundingApproved.toJSON(message.cardFundingApproved);
        }
        if (message.cardFundingFailed !== undefined) {
            obj.cardFundingFailed = exports.CardFundingFailed.toJSON(message.cardFundingFailed);
        }
        if (message.cardInactive !== undefined) {
            obj.cardInactive = exports.CardInactive.toJSON(message.cardInactive);
        }
        if (message.cardInactiveSms !== undefined) {
            obj.cardInactiveSms = exports.CardInactiveSms.toJSON(message.cardInactiveSms);
        }
        if (message.cardOrdered !== undefined) {
            obj.cardOrdered = exports.CardOrdered.toJSON(message.cardOrdered);
        }
        if (message.cardPayoutReversal !== undefined) {
            obj.cardPayoutReversal = exports.CardPayoutReversal.toJSON(message.cardPayoutReversal);
        }
        if (message.cardPinBlocked !== undefined) {
            obj.cardPinBlocked = exports.CardPinBlocked.toJSON(message.cardPinBlocked);
        }
        if (message.cardPurchaseAuthorized !== undefined) {
            obj.cardPurchaseAuthorized = exports.CardPurchaseAuthorized.toJSON(message.cardPurchaseAuthorized);
        }
        if (message.cardPurchaseInsufficientFunds !== undefined) {
            obj.cardPurchaseInsufficientFunds = exports.CardPurchaseInsufficientFunds.toJSON(message.cardPurchaseInsufficientFunds);
        }
        if (message.cardPurchaseRefunded !== undefined) {
            obj.cardPurchaseRefunded = exports.CardPurchaseRefunded.toJSON(message.cardPurchaseRefunded);
        }
        if (message.cardPurchaseReversed !== undefined) {
            obj.cardPurchaseReversed = exports.CardPurchaseReversed.toJSON(message.cardPurchaseReversed);
        }
        if (message.cardReplaced !== undefined) {
            obj.cardReplaced = exports.CardReplaced.toJSON(message.cardReplaced);
        }
        if (message.cardShipped !== undefined) {
            obj.cardShipped = exports.CardShipped.toJSON(message.cardShipped);
        }
        if (message.checkCleared !== undefined) {
            obj.checkCleared = exports.CheckCleared.toJSON(message.checkCleared);
        }
        if (message.checkReleased !== undefined) {
            obj.checkReleased = exports.CheckReleased.toJSON(message.checkReleased);
        }
        if (message.checkReturned !== undefined) {
            obj.checkReturned = exports.CheckReturned.toJSON(message.checkReturned);
        }
        if (message.contactHasJoinedStep !== undefined) {
            obj.contactHasJoinedStep = exports.ContactHasJoinedStep.toJSON(message.contactHasJoinedStep);
        }
        if (message.contributedToSavingsGoal !== undefined) {
            obj.contributedToSavingsGoal = exports.ContributedToSavingsGoal.toJSON(message.contributedToSavingsGoal);
        }
        if (message.corporateAction !== undefined) {
            obj.corporateAction = exports.CorporateAction.toJSON(message.corporateAction);
        }
        if (message.cosponsorFamilyInvite !== undefined) {
            obj.cosponsorFamilyInvite = exports.CosponsorFamilyInvite.toJSON(message.cosponsorFamilyInvite);
        }
        if (message.creditScoreChanged !== undefined) {
            obj.creditScoreChanged = exports.CreditScoreChanged.toJSON(message.creditScoreChanged);
        }
        if (message.cryptoDisabled !== undefined) {
            obj.cryptoDisabled = exports.CryptoDisabled.toJSON(message.cryptoDisabled);
        }
        if (message.cryptoEnrollmentApproval !== undefined) {
            obj.cryptoEnrollmentApproval = exports.CryptoEnrollmentApproval.toJSON(message.cryptoEnrollmentApproval);
        }
        if (message.cryptoGraduationTransferSuccess !== undefined) {
            obj.cryptoGraduationTransferSuccess = exports.CryptoGraduationTransferSuccess.toJSON(message.cryptoGraduationTransferSuccess);
        }
        if (message.cryptoRoundUpSuccess !== undefined) {
            obj.cryptoRoundUpSuccess = exports.CryptoRoundUpSuccess.toJSON(message.cryptoRoundUpSuccess);
        }
        if (message.ctaAvailable !== undefined) {
            obj.ctaAvailable = exports.CtaAvailable.toJSON(message.ctaAvailable);
        }
        if (message.customerRecoupment !== undefined) {
            obj.customerRecoupment = exports.CustomerRecoupment.toJSON(message.customerRecoupment);
        }
        if (message.customerTransfer !== undefined) {
            obj.customerTransfer = exports.CustomerTransfer.toJSON(message.customerTransfer);
        }
        if (message.depositSwitchFailed !== undefined) {
            obj.depositSwitchFailed = exports.DepositSwitchFailed.toJSON(message.depositSwitchFailed);
        }
        if (message.depositSwitchSuccess !== undefined) {
            obj.depositSwitchSuccess = exports.DepositSwitchSuccess.toJSON(message.depositSwitchSuccess);
        }
        if (message.disputeCredit !== undefined) {
            obj.disputeCredit = exports.DisputeCredit.toJSON(message.disputeCredit);
        }
        if (message.disputeCreditReversal !== undefined) {
            obj.disputeCreditReversal = exports.DisputeCreditReversal.toJSON(message.disputeCreditReversal);
        }
        if (message.downgradedFromBlackTier !== undefined) {
            obj.downgradedFromBlackTier = exports.DowngradedFromBlackTier.toJSON(message.downgradedFromBlackTier);
        }
        if (message.familyInvite !== undefined) {
            obj.familyInvite = exports.FamilyInvite.toJSON(message.familyInvite);
        }
        if (message.familyInviteApproved !== undefined) {
            obj.familyInviteApproved = exports.FamilyInviteApproved.toJSON(message.familyInviteApproved);
        }
        if (message.familyInviteDenied !== undefined) {
            obj.familyInviteDenied = exports.FamilyInviteDenied.toJSON(message.familyInviteDenied);
        }
        if (message.familyInviteSms !== undefined) {
            obj.familyInviteSms = exports.FamilyInviteSms.toJSON(message.familyInviteSms);
        }
        if (message.flexAutoPayFailed !== undefined) {
            obj.flexAutoPayFailed = exports.FlexAutoPayFailed.toJSON(message.flexAutoPayFailed);
        }
        if (message.flexBillDue !== undefined) {
            obj.flexBillDue = exports.FlexBillDue.toJSON(message.flexBillDue);
        }
        if (message.foreignPurchaseBlocked !== undefined) {
            obj.foreignPurchaseBlocked = exports.ForeignPurchaseBlocked.toJSON(message.foreignPurchaseBlocked);
        }
        if (message.freeOutOfNetworkAtmWithdrawalAuthorized !== undefined) {
            obj.freeOutOfNetworkAtmWithdrawalAuthorized = exports.FreeOutOfNetworkAtmWithdrawalAuthorized.toJSON(message.freeOutOfNetworkAtmWithdrawalAuthorized);
        }
        if (message.giftCardOrderReady !== undefined) {
            obj.giftCardOrderReady = exports.GiftCardOrderReady.toJSON(message.giftCardOrderReady);
        }
        if (message.giftCardOrderFailed !== undefined) {
            obj.giftCardOrderFailed = exports.GiftCardOrderFailed.toJSON(message.giftCardOrderFailed);
        }
        if (message.inNetworkAtmWithdrawalAuthorized !== undefined) {
            obj.inNetworkAtmWithdrawalAuthorized = exports.InNetworkAtmWithdrawalAuthorized.toJSON(message.inNetworkAtmWithdrawalAuthorized);
        }
        if (message.issuingDisputeUpdated !== undefined) {
            obj.issuingDisputeUpdated = exports.IssuingDisputeUpdated.toJSON(message.issuingDisputeUpdated);
        }
        if (message.joinedFamily !== undefined) {
            obj.joinedFamily = exports.JoinedFamily.toJSON(message.joinedFamily);
        }
        if (message.kycExpired !== undefined) {
            obj.kycExpired = exports.KycExpired.toJSON(message.kycExpired);
        }
        if (message.kycFailed !== undefined) {
            obj.kycFailed = exports.KycFailed.toJSON(message.kycFailed);
        }
        if (message.kycSuccess !== undefined) {
            obj.kycSuccess = exports.KycSuccess.toJSON(message.kycSuccess);
        }
        if (message.kycStatusUpdate !== undefined) {
            obj.kycStatusUpdate = exports.KycStatusUpdate.toJSON(message.kycStatusUpdate);
        }
        if (message.lifecycleStoreRefresh !== undefined) {
            obj.lifecycleStoreRefresh = exports.LifecycleStoreRefresh.toJSON(message.lifecycleStoreRefresh);
        }
        if (message.lockCard !== undefined) {
            obj.lockCard = exports.LockCard.toJSON(message.lockCard);
        }
        if (message.marketingMessage !== undefined) {
            obj.marketingMessage = exports.MarketingMessage.toJSON(message.marketingMessage);
        }
        if (message.moneyReceived !== undefined) {
            obj.moneyReceived = exports.MoneyReceived.toJSON(message.moneyReceived);
        }
        if (message.moneyReceivedFromNonStep !== undefined) {
            obj.moneyReceivedFromNonStep = exports.MoneyReceivedFromNonStep.toJSON(message.moneyReceivedFromNonStep);
        }
        if (message.moneyRequested !== undefined) {
            obj.moneyRequested = exports.MoneyRequested.toJSON(message.moneyRequested);
        }
        if (message.moneyRequestedExpired !== undefined) {
            obj.moneyRequestedExpired = exports.MoneyRequestedExpired.toJSON(message.moneyRequestedExpired);
        }
        if (message.moneyRequestedRejected !== undefined) {
            obj.moneyRequestedRejected = exports.MoneyRequestedRejected.toJSON(message.moneyRequestedRejected);
        }
        if (message.moneySentExpired !== undefined) {
            obj.moneySentExpired = exports.MoneySentExpired.toJSON(message.moneySentExpired);
        }
        if (message.moneySentLimitExceeded !== undefined) {
            obj.moneySentLimitExceeded = exports.MoneySentLimitExceeded.toJSON(message.moneySentLimitExceeded);
        }
        if (message.offerRewardReceived !== undefined) {
            obj.offerRewardReceived = exports.OfferRewardReceived.toJSON(message.offerRewardReceived);
        }
        if (message.offerWillExpire !== undefined) {
            obj.offerWillExpire = exports.OfferWillExpire.toJSON(message.offerWillExpire);
        }
        if (message.otpRecovery !== undefined) {
            obj.otpRecovery = exports.OtpRecovery.toJSON(message.otpRecovery);
        }
        if (message.otpRequested !== undefined) {
            obj.otpRequested = exports.OtpRequested.toJSON(message.otpRequested);
        }
        if (message.otpVerification !== undefined) {
            obj.otpVerification = exports.OtpVerification.toJSON(message.otpVerification);
        }
        if (message.outOfNetworkAtmWithdrawalAuthorized !== undefined) {
            obj.outOfNetworkAtmWithdrawalAuthorized = exports.OutOfNetworkAtmWithdrawalAuthorized.toJSON(message.outOfNetworkAtmWithdrawalAuthorized);
        }
        if (message.outstandingBill !== undefined) {
            obj.outstandingBill = exports.OutstandingBill.toJSON(message.outstandingBill);
        }
        if (message.paymentCycleReminder !== undefined) {
            obj.paymentCycleReminder = exports.PaymentCycleReminder.toJSON(message.paymentCycleReminder);
        }
        if (message.plaidExchangeLink !== undefined) {
            obj.plaidExchangeLink = exports.PlaidExchangeLink.toJSON(message.plaidExchangeLink);
        }
        if (message.plusTierEnrolled !== undefined) {
            obj.plusTierEnrolled = exports.PlusTierEnrolled.toJSON(message.plusTierEnrolled);
        }
        if (message.plusTierEnrolledManagedUser !== undefined) {
            obj.plusTierEnrolledManagedUser = exports.PlusTierEnrolledManagedUser.toJSON(message.plusTierEnrolledManagedUser);
        }
        if (message.purchaseCardLocked !== undefined) {
            obj.purchaseCardLocked = exports.PurchaseCardLocked.toJSON(message.purchaseCardLocked);
        }
        if (message.recurringTransferAccountExpired !== undefined) {
            obj.recurringTransferAccountExpired = exports.RecurringTransferAccountExpired.toJSON(message.recurringTransferAccountExpired);
        }
        if (message.recurringTransferReminder !== undefined) {
            obj.recurringTransferReminder = exports.RecurringTransferReminder.toJSON(message.recurringTransferReminder);
        }
        if (message.recurringTransferFailed !== undefined) {
            obj.recurringTransferFailed = exports.RecurringTransferFailed.toJSON(message.recurringTransferFailed);
        }
        if (message.recurringTransferInsufficientFunds !== undefined) {
            obj.recurringTransferInsufficientFunds = exports.RecurringTransferInsufficientFunds.toJSON(message.recurringTransferInsufficientFunds);
        }
        if (message.recurringTransferSent !== undefined) {
            obj.recurringTransferSent = exports.RecurringTransferSent.toJSON(message.recurringTransferSent);
        }
        if (message.redeemerReward !== undefined) {
            obj.redeemerReward = exports.RedeemerReward.toJSON(message.redeemerReward);
        }
        if (message.refereeReminder !== undefined) {
            obj.refereeReminder = exports.RefereeReminder.toJSON(message.refereeReminder);
        }
        if (message.referralBonus !== undefined) {
            obj.referralBonus = exports.ReferralBonus.toJSON(message.referralBonus);
        }
        if (message.referralInvite !== undefined) {
            obj.referralInvite = exports.ReferralInvite.toJSON(message.referralInvite);
        }
        if (message.referralRedemptionReminder !== undefined) {
            obj.referralRedemptionReminder = exports.ReferralRedemptionReminder.toJSON(message.referralRedemptionReminder);
        }
        if (message.referralReward !== undefined) {
            obj.referralReward = exports.ReferralReward.toJSON(message.referralReward);
        }
        if (message.savingsInterest !== undefined) {
            obj.savingsInterest = exports.SavingsInterest.toJSON(message.savingsInterest);
        }
        if (message.savingsContributionMatched !== undefined) {
            obj.savingsContributionMatched = exports.SavingsContributionMatched.toJSON(message.savingsContributionMatched);
        }
        if (message.savingsContributionMatchDeclined !== undefined) {
            obj.savingsContributionMatchDeclined = exports.SavingsContributionMatchDeclined.toJSON(message.savingsContributionMatchDeclined);
        }
        if (message.sponseeAddedDebitCard !== undefined) {
            obj.sponseeAddedDebitCard = exports.SponseeAddedDebitCard.toJSON(message.sponseeAddedDebitCard);
        }
        if (message.sponseeClosedSavingsGoalWithMatching !== undefined) {
            obj.sponseeClosedSavingsGoalWithMatching = exports.SponseeClosedSavingsGoalWithMatching.toJSON(message.sponseeClosedSavingsGoalWithMatching);
        }
        if (message.sponseeCreatedSavingsGoal !== undefined) {
            obj.sponseeCreatedSavingsGoal = exports.SponseeCreatedSavingsGoal.toJSON(message.sponseeCreatedSavingsGoal);
        }
        if (message.sponseeLeftFamily !== undefined) {
            obj.sponseeLeftFamily = exports.SponseeLeftFamily.toJSON(message.sponseeLeftFamily);
        }
        if (message.sponseeTurnedOffSavingsMatching !== undefined) {
            obj.sponseeTurnedOffSavingsMatching = exports.SponseeTurnedOffSavingsMatching.toJSON(message.sponseeTurnedOffSavingsMatching);
        }
        if (message.sponsorAcceptedSavingsMatching !== undefined) {
            obj.sponsorAcceptedSavingsMatching = exports.SponsorAcceptedSavingsMatching.toJSON(message.sponsorAcceptedSavingsMatching);
        }
        if (message.sponsorCreatedSavingsGoal !== undefined) {
            obj.sponsorCreatedSavingsGoal = exports.SponsorCreatedSavingsGoal.toJSON(message.sponsorCreatedSavingsGoal);
        }
        if (message.sponsorTurnedOffSavingsMatching !== undefined) {
            obj.sponsorTurnedOffSavingsMatching = exports.SponsorTurnedOffSavingsMatching.toJSON(message.sponsorTurnedOffSavingsMatching);
        }
        if (message.startedRedemption !== undefined) {
            obj.startedRedemption = exports.StartedRedemption.toJSON(message.startedRedemption);
        }
        if (message.stepBlackSubscribed !== undefined) {
            obj.stepBlackSubscribed = exports.StepBlackSubscribed.toJSON(message.stepBlackSubscribed);
        }
        if (message.stockDayTradeDetected !== undefined) {
            obj.stockDayTradeDetected = exports.StockDayTradeDetected.toJSON(message.stockDayTradeDetected);
        }
        if (message.stockGraduationTransferSuccess !== undefined) {
            obj.stockGraduationTransferSuccess = exports.StockGraduationTransferSuccess.toJSON(message.stockGraduationTransferSuccess);
        }
        if (message.stockOrderCancelled !== undefined) {
            obj.stockOrderCancelled = exports.StockOrderCancelled.toJSON(message.stockOrderCancelled);
        }
        if (message.stockOrderFilled !== undefined) {
            obj.stockOrderFilled = exports.StockOrderFilled.toJSON(message.stockOrderFilled);
        }
        if (message.stockOrderRejected !== undefined) {
            obj.stockOrderRejected = exports.StockOrderRejected.toJSON(message.stockOrderRejected);
        }
        if (message.stockRiskLevelUpdate !== undefined) {
            obj.stockRiskLevelUpdate = exports.StockRiskLevelUpdate.toJSON(message.stockRiskLevelUpdate);
        }
        if (message.stockSponseeApproved !== undefined) {
            obj.stockSponseeApproved = exports.StockSponseeApproved.toJSON(message.stockSponseeApproved);
        }
        if (message.subscriptionMerchantCardUpdated !== undefined) {
            obj.subscriptionMerchantCardUpdated = exports.SubscriptionMerchantCardUpdated.toJSON(message.subscriptionMerchantCardUpdated);
        }
        if (message.subscriptionRenewalFailed !== undefined) {
            obj.subscriptionRenewalFailed = exports.SubscriptionRenewalFailed.toJSON(message.subscriptionRenewalFailed);
        }
        if (message.unlockCard !== undefined) {
            obj.unlockCard = exports.UnlockCard.toJSON(message.unlockCard);
        }
        if (message.unrecognizedDeviceLogin !== undefined) {
            obj.unrecognizedDeviceLogin = exports.UnrecognizedDeviceLogin.toJSON(message.unrecognizedDeviceLogin);
        }
        if (message.withdrawReturn !== undefined) {
            obj.withdrawReturn = exports.WithdrawReturn.toJSON(message.withdrawReturn);
        }
        if (message.testMessage !== undefined) {
            obj.testMessage = exports.TestMessage.toJSON(message.testMessage);
        }
        return obj;
    },
    create(base) {
        return exports.Notification.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNotification();
        message.qualifier = object.qualifier ?? '';
        message.accountLinkExpired =
            (object.accountLinkExpired !== undefined && object.accountLinkExpired !== null)
                ? exports.AccountLinkExpired.fromPartial(object.accountLinkExpired)
                : undefined;
        message.accountOwnerUpdated =
            (object.accountOwnerUpdated !== undefined && object.accountOwnerUpdated !== null)
                ? exports.AccountOwnerUpdated.fromPartial(object.accountOwnerUpdated)
                : undefined;
        message.achInFundingSuccess =
            (object.achInFundingSuccess !== undefined && object.achInFundingSuccess !== null)
                ? exports.AchInFundingSuccess.fromPartial(object.achInFundingSuccess)
                : undefined;
        message.achOutFundingFailed =
            (object.achOutFundingFailed !== undefined && object.achOutFundingFailed !== null)
                ? exports.AchOutFundingFailed.fromPartial(object.achOutFundingFailed)
                : undefined;
        message.achOutFundingFailedInsufficientFunds =
            (object.achOutFundingFailedInsufficientFunds !== undefined &&
                object.achOutFundingFailedInsufficientFunds !== null)
                ? exports.AchOutFundingFailedInsufficientFunds.fromPartial(object.achOutFundingFailedInsufficientFunds)
                : undefined;
        message.achOutFundingReturn =
            (object.achOutFundingReturn !== undefined && object.achOutFundingReturn !== null)
                ? exports.AchOutFundingReturn.fromPartial(object.achOutFundingReturn)
                : undefined;
        message.achOutFundingSuccess =
            (object.achOutFundingSuccess !== undefined && object.achOutFundingSuccess !== null)
                ? exports.AchOutFundingSuccess.fromPartial(object.achOutFundingSuccess)
                : undefined;
        message.achP2pCancel = (object.achP2pCancel !== undefined && object.achP2pCancel !== null)
            ? exports.AchP2pCancel.fromPartial(object.achP2pCancel)
            : undefined;
        message.achP2pFailed = (object.achP2pFailed !== undefined && object.achP2pFailed !== null)
            ? exports.AchP2pFailed.fromPartial(object.achP2pFailed)
            : undefined;
        message.achP2pFailedInsufficientFunds =
            (object.achP2pFailedInsufficientFunds !== undefined &&
                object.achP2pFailedInsufficientFunds !== null)
                ? exports.AchP2pFailedInsufficientFunds.fromPartial(object.achP2pFailedInsufficientFunds)
                : undefined;
        message.achP2pSuccess = (object.achP2pSuccess !== undefined && object.achP2pSuccess !== null)
            ? exports.AchP2pSuccess.fromPartial(object.achP2pSuccess)
            : undefined;
        message.activityUpdated =
            (object.activityUpdated !== undefined && object.activityUpdated !== null)
                ? exports.ActivityUpdated.fromPartial(object.activityUpdated)
                : undefined;
        message.adhocMessage = (object.adhocMessage !== undefined && object.adhocMessage !== null)
            ? exports.AdhocMessage.fromPartial(object.adhocMessage)
            : undefined;
        message.applicationApproved =
            (object.applicationApproved !== undefined && object.applicationApproved !== null)
                ? exports.ApplicationApproved.fromPartial(object.applicationApproved)
                : undefined;
        message.atmAccessDisabled =
            (object.atmAccessDisabled !== undefined && object.atmAccessDisabled !== null)
                ? exports.AtmAccessDisabled.fromPartial(object.atmAccessDisabled)
                : undefined;
        message.atmWithdrawalAccessDisabled =
            (object.atmWithdrawalAccessDisabled !== undefined &&
                object.atmWithdrawalAccessDisabled !== null)
                ? exports.AtmWithdrawalAccessDisabled.fromPartial(object.atmWithdrawalAccessDisabled)
                : undefined;
        message.atmWithdrawalAuthorized =
            (object.atmWithdrawalAuthorized !== undefined && object.atmWithdrawalAuthorized !== null)
                ? exports.AtmWithdrawalAuthorized.fromPartial(object.atmWithdrawalAuthorized)
                : undefined;
        message.atmWithdrawalInsufficientFunds =
            (object.atmWithdrawalInsufficientFunds !== undefined &&
                object.atmWithdrawalInsufficientFunds !== null)
                ? exports.AtmWithdrawalInsufficientFunds.fromPartial(object.atmWithdrawalInsufficientFunds)
                : undefined;
        message.atmWithdrawalLimitExceeded =
            (object.atmWithdrawalLimitExceeded !== undefined &&
                object.atmWithdrawalLimitExceeded !== null)
                ? exports.AtmWithdrawalLimitExceeded.fromPartial(object.atmWithdrawalLimitExceeded)
                : undefined;
        message.authorizedUserUpdated =
            (object.authorizedUserUpdated !== undefined && object.authorizedUserUpdated !== null)
                ? exports.AuthorizedUserUpdated.fromPartial(object.authorizedUserUpdated)
                : undefined;
        message.autoReloadCompleted =
            (object.autoReloadCompleted !== undefined && object.autoReloadCompleted !== null)
                ? exports.AutoReloadCompleted.fromPartial(object.autoReloadCompleted)
                : undefined;
        message.autoReloadFailed =
            (object.autoReloadFailed !== undefined && object.autoReloadFailed !== null)
                ? exports.AutoReloadFailed.fromPartial(object.autoReloadFailed)
                : undefined;
        message.autoReloadManualReview =
            (object.autoReloadManualReview !== undefined && object.autoReloadManualReview !== null)
                ? exports.AutoReloadManualReview.fromPartial(object.autoReloadManualReview)
                : undefined;
        message.billPaid = (object.billPaid !== undefined && object.billPaid !== null)
            ? exports.BillPaid.fromPartial(object.billPaid)
            : undefined;
        message.blackCardArrived =
            (object.blackCardArrived !== undefined && object.blackCardArrived !== null)
                ? exports.BlackCardArrived.fromPartial(object.blackCardArrived)
                : undefined;
        message.blackCardShippingAhead =
            (object.blackCardShippingAhead !== undefined && object.blackCardShippingAhead !== null)
                ? exports.BlackCardShippingAhead.fromPartial(object.blackCardShippingAhead)
                : undefined;
        message.blackCardShippingDelay =
            (object.blackCardShippingDelay !== undefined && object.blackCardShippingDelay !== null)
                ? exports.BlackCardShippingDelay.fromPartial(object.blackCardShippingDelay)
                : undefined;
        message.blackTierInherited =
            (object.blackTierInherited !== undefined && object.blackTierInherited !== null)
                ? exports.BlackTierInherited.fromPartial(object.blackTierInherited)
                : undefined;
        message.blackTierInheritedManagedUser =
            (object.blackTierInheritedManagedUser !== undefined &&
                object.blackTierInheritedManagedUser !== null)
                ? exports.BlackTierInheritedManagedUser.fromPartial(object.blackTierInheritedManagedUser)
                : undefined;
        message.bnplAlmostDue = (object.bnplAlmostDue !== undefined && object.bnplAlmostDue !== null)
            ? exports.BnplAlmostDue.fromPartial(object.bnplAlmostDue)
            : undefined;
        message.bnplPastDue = (object.bnplPastDue !== undefined && object.bnplPastDue !== null)
            ? exports.BnplPastDue.fromPartial(object.bnplPastDue)
            : undefined;
        message.bnplPaymentFailed =
            (object.bnplPaymentFailed !== undefined && object.bnplPaymentFailed !== null)
                ? exports.BnplPaymentFailed.fromPartial(object.bnplPaymentFailed)
                : undefined;
        message.bnplPaymentSuccessful =
            (object.bnplPaymentSuccessful !== undefined && object.bnplPaymentSuccessful !== null)
                ? exports.BnplPaymentSuccessful.fromPartial(object.bnplPaymentSuccessful)
                : undefined;
        message.cardActivated = (object.cardActivated !== undefined && object.cardActivated !== null)
            ? exports.CardActivated.fromPartial(object.cardActivated)
            : undefined;
        message.cardCanceled = (object.cardCanceled !== undefined && object.cardCanceled !== null)
            ? exports.CardCanceled.fromPartial(object.cardCanceled)
            : undefined;
        message.cardFundingApproved =
            (object.cardFundingApproved !== undefined && object.cardFundingApproved !== null)
                ? exports.CardFundingApproved.fromPartial(object.cardFundingApproved)
                : undefined;
        message.cardFundingFailed =
            (object.cardFundingFailed !== undefined && object.cardFundingFailed !== null)
                ? exports.CardFundingFailed.fromPartial(object.cardFundingFailed)
                : undefined;
        message.cardInactive = (object.cardInactive !== undefined && object.cardInactive !== null)
            ? exports.CardInactive.fromPartial(object.cardInactive)
            : undefined;
        message.cardInactiveSms =
            (object.cardInactiveSms !== undefined && object.cardInactiveSms !== null)
                ? exports.CardInactiveSms.fromPartial(object.cardInactiveSms)
                : undefined;
        message.cardOrdered = (object.cardOrdered !== undefined && object.cardOrdered !== null)
            ? exports.CardOrdered.fromPartial(object.cardOrdered)
            : undefined;
        message.cardPayoutReversal =
            (object.cardPayoutReversal !== undefined && object.cardPayoutReversal !== null)
                ? exports.CardPayoutReversal.fromPartial(object.cardPayoutReversal)
                : undefined;
        message.cardPinBlocked = (object.cardPinBlocked !== undefined && object.cardPinBlocked !== null)
            ? exports.CardPinBlocked.fromPartial(object.cardPinBlocked)
            : undefined;
        message.cardPurchaseAuthorized =
            (object.cardPurchaseAuthorized !== undefined && object.cardPurchaseAuthorized !== null)
                ? exports.CardPurchaseAuthorized.fromPartial(object.cardPurchaseAuthorized)
                : undefined;
        message.cardPurchaseInsufficientFunds =
            (object.cardPurchaseInsufficientFunds !== undefined &&
                object.cardPurchaseInsufficientFunds !== null)
                ? exports.CardPurchaseInsufficientFunds.fromPartial(object.cardPurchaseInsufficientFunds)
                : undefined;
        message.cardPurchaseRefunded =
            (object.cardPurchaseRefunded !== undefined && object.cardPurchaseRefunded !== null)
                ? exports.CardPurchaseRefunded.fromPartial(object.cardPurchaseRefunded)
                : undefined;
        message.cardPurchaseReversed =
            (object.cardPurchaseReversed !== undefined && object.cardPurchaseReversed !== null)
                ? exports.CardPurchaseReversed.fromPartial(object.cardPurchaseReversed)
                : undefined;
        message.cardReplaced = (object.cardReplaced !== undefined && object.cardReplaced !== null)
            ? exports.CardReplaced.fromPartial(object.cardReplaced)
            : undefined;
        message.cardShipped = (object.cardShipped !== undefined && object.cardShipped !== null)
            ? exports.CardShipped.fromPartial(object.cardShipped)
            : undefined;
        message.checkCleared = (object.checkCleared !== undefined && object.checkCleared !== null)
            ? exports.CheckCleared.fromPartial(object.checkCleared)
            : undefined;
        message.checkReleased = (object.checkReleased !== undefined && object.checkReleased !== null)
            ? exports.CheckReleased.fromPartial(object.checkReleased)
            : undefined;
        message.checkReturned = (object.checkReturned !== undefined && object.checkReturned !== null)
            ? exports.CheckReturned.fromPartial(object.checkReturned)
            : undefined;
        message.contactHasJoinedStep =
            (object.contactHasJoinedStep !== undefined && object.contactHasJoinedStep !== null)
                ? exports.ContactHasJoinedStep.fromPartial(object.contactHasJoinedStep)
                : undefined;
        message.contributedToSavingsGoal =
            (object.contributedToSavingsGoal !== undefined && object.contributedToSavingsGoal !== null)
                ? exports.ContributedToSavingsGoal.fromPartial(object.contributedToSavingsGoal)
                : undefined;
        message.corporateAction =
            (object.corporateAction !== undefined && object.corporateAction !== null)
                ? exports.CorporateAction.fromPartial(object.corporateAction)
                : undefined;
        message.cosponsorFamilyInvite =
            (object.cosponsorFamilyInvite !== undefined && object.cosponsorFamilyInvite !== null)
                ? exports.CosponsorFamilyInvite.fromPartial(object.cosponsorFamilyInvite)
                : undefined;
        message.creditScoreChanged =
            (object.creditScoreChanged !== undefined && object.creditScoreChanged !== null)
                ? exports.CreditScoreChanged.fromPartial(object.creditScoreChanged)
                : undefined;
        message.cryptoDisabled = (object.cryptoDisabled !== undefined && object.cryptoDisabled !== null)
            ? exports.CryptoDisabled.fromPartial(object.cryptoDisabled)
            : undefined;
        message.cryptoEnrollmentApproval =
            (object.cryptoEnrollmentApproval !== undefined && object.cryptoEnrollmentApproval !== null)
                ? exports.CryptoEnrollmentApproval.fromPartial(object.cryptoEnrollmentApproval)
                : undefined;
        message.cryptoGraduationTransferSuccess =
            (object.cryptoGraduationTransferSuccess !== undefined &&
                object.cryptoGraduationTransferSuccess !== null)
                ? exports.CryptoGraduationTransferSuccess.fromPartial(object.cryptoGraduationTransferSuccess)
                : undefined;
        message.cryptoRoundUpSuccess =
            (object.cryptoRoundUpSuccess !== undefined && object.cryptoRoundUpSuccess !== null)
                ? exports.CryptoRoundUpSuccess.fromPartial(object.cryptoRoundUpSuccess)
                : undefined;
        message.ctaAvailable = (object.ctaAvailable !== undefined && object.ctaAvailable !== null)
            ? exports.CtaAvailable.fromPartial(object.ctaAvailable)
            : undefined;
        message.customerRecoupment =
            (object.customerRecoupment !== undefined && object.customerRecoupment !== null)
                ? exports.CustomerRecoupment.fromPartial(object.customerRecoupment)
                : undefined;
        message.customerTransfer =
            (object.customerTransfer !== undefined && object.customerTransfer !== null)
                ? exports.CustomerTransfer.fromPartial(object.customerTransfer)
                : undefined;
        message.depositSwitchFailed =
            (object.depositSwitchFailed !== undefined && object.depositSwitchFailed !== null)
                ? exports.DepositSwitchFailed.fromPartial(object.depositSwitchFailed)
                : undefined;
        message.depositSwitchSuccess =
            (object.depositSwitchSuccess !== undefined && object.depositSwitchSuccess !== null)
                ? exports.DepositSwitchSuccess.fromPartial(object.depositSwitchSuccess)
                : undefined;
        message.disputeCredit = (object.disputeCredit !== undefined && object.disputeCredit !== null)
            ? exports.DisputeCredit.fromPartial(object.disputeCredit)
            : undefined;
        message.disputeCreditReversal =
            (object.disputeCreditReversal !== undefined && object.disputeCreditReversal !== null)
                ? exports.DisputeCreditReversal.fromPartial(object.disputeCreditReversal)
                : undefined;
        message.downgradedFromBlackTier =
            (object.downgradedFromBlackTier !== undefined && object.downgradedFromBlackTier !== null)
                ? exports.DowngradedFromBlackTier.fromPartial(object.downgradedFromBlackTier)
                : undefined;
        message.familyInvite = (object.familyInvite !== undefined && object.familyInvite !== null)
            ? exports.FamilyInvite.fromPartial(object.familyInvite)
            : undefined;
        message.familyInviteApproved =
            (object.familyInviteApproved !== undefined && object.familyInviteApproved !== null)
                ? exports.FamilyInviteApproved.fromPartial(object.familyInviteApproved)
                : undefined;
        message.familyInviteDenied =
            (object.familyInviteDenied !== undefined && object.familyInviteDenied !== null)
                ? exports.FamilyInviteDenied.fromPartial(object.familyInviteDenied)
                : undefined;
        message.familyInviteSms =
            (object.familyInviteSms !== undefined && object.familyInviteSms !== null)
                ? exports.FamilyInviteSms.fromPartial(object.familyInviteSms)
                : undefined;
        message.flexAutoPayFailed =
            (object.flexAutoPayFailed !== undefined && object.flexAutoPayFailed !== null)
                ? exports.FlexAutoPayFailed.fromPartial(object.flexAutoPayFailed)
                : undefined;
        message.flexBillDue = (object.flexBillDue !== undefined && object.flexBillDue !== null)
            ? exports.FlexBillDue.fromPartial(object.flexBillDue)
            : undefined;
        message.foreignPurchaseBlocked =
            (object.foreignPurchaseBlocked !== undefined && object.foreignPurchaseBlocked !== null)
                ? exports.ForeignPurchaseBlocked.fromPartial(object.foreignPurchaseBlocked)
                : undefined;
        message.freeOutOfNetworkAtmWithdrawalAuthorized =
            (object.freeOutOfNetworkAtmWithdrawalAuthorized !== undefined &&
                object.freeOutOfNetworkAtmWithdrawalAuthorized !== null)
                ? exports.FreeOutOfNetworkAtmWithdrawalAuthorized.fromPartial(object.freeOutOfNetworkAtmWithdrawalAuthorized)
                : undefined;
        message.giftCardOrderReady =
            (object.giftCardOrderReady !== undefined && object.giftCardOrderReady !== null)
                ? exports.GiftCardOrderReady.fromPartial(object.giftCardOrderReady)
                : undefined;
        message.giftCardOrderFailed =
            (object.giftCardOrderFailed !== undefined && object.giftCardOrderFailed !== null)
                ? exports.GiftCardOrderFailed.fromPartial(object.giftCardOrderFailed)
                : undefined;
        message.inNetworkAtmWithdrawalAuthorized =
            (object.inNetworkAtmWithdrawalAuthorized !== undefined &&
                object.inNetworkAtmWithdrawalAuthorized !== null)
                ? exports.InNetworkAtmWithdrawalAuthorized.fromPartial(object.inNetworkAtmWithdrawalAuthorized)
                : undefined;
        message.issuingDisputeUpdated =
            (object.issuingDisputeUpdated !== undefined && object.issuingDisputeUpdated !== null)
                ? exports.IssuingDisputeUpdated.fromPartial(object.issuingDisputeUpdated)
                : undefined;
        message.joinedFamily = (object.joinedFamily !== undefined && object.joinedFamily !== null)
            ? exports.JoinedFamily.fromPartial(object.joinedFamily)
            : undefined;
        message.kycExpired = (object.kycExpired !== undefined && object.kycExpired !== null)
            ? exports.KycExpired.fromPartial(object.kycExpired)
            : undefined;
        message.kycFailed = (object.kycFailed !== undefined && object.kycFailed !== null)
            ? exports.KycFailed.fromPartial(object.kycFailed)
            : undefined;
        message.kycSuccess = (object.kycSuccess !== undefined && object.kycSuccess !== null)
            ? exports.KycSuccess.fromPartial(object.kycSuccess)
            : undefined;
        message.kycStatusUpdate =
            (object.kycStatusUpdate !== undefined && object.kycStatusUpdate !== null)
                ? exports.KycStatusUpdate.fromPartial(object.kycStatusUpdate)
                : undefined;
        message.lifecycleStoreRefresh =
            (object.lifecycleStoreRefresh !== undefined && object.lifecycleStoreRefresh !== null)
                ? exports.LifecycleStoreRefresh.fromPartial(object.lifecycleStoreRefresh)
                : undefined;
        message.lockCard = (object.lockCard !== undefined && object.lockCard !== null)
            ? exports.LockCard.fromPartial(object.lockCard)
            : undefined;
        message.marketingMessage =
            (object.marketingMessage !== undefined && object.marketingMessage !== null)
                ? exports.MarketingMessage.fromPartial(object.marketingMessage)
                : undefined;
        message.moneyReceived = (object.moneyReceived !== undefined && object.moneyReceived !== null)
            ? exports.MoneyReceived.fromPartial(object.moneyReceived)
            : undefined;
        message.moneyReceivedFromNonStep =
            (object.moneyReceivedFromNonStep !== undefined && object.moneyReceivedFromNonStep !== null)
                ? exports.MoneyReceivedFromNonStep.fromPartial(object.moneyReceivedFromNonStep)
                : undefined;
        message.moneyRequested = (object.moneyRequested !== undefined && object.moneyRequested !== null)
            ? exports.MoneyRequested.fromPartial(object.moneyRequested)
            : undefined;
        message.moneyRequestedExpired =
            (object.moneyRequestedExpired !== undefined && object.moneyRequestedExpired !== null)
                ? exports.MoneyRequestedExpired.fromPartial(object.moneyRequestedExpired)
                : undefined;
        message.moneyRequestedRejected =
            (object.moneyRequestedRejected !== undefined && object.moneyRequestedRejected !== null)
                ? exports.MoneyRequestedRejected.fromPartial(object.moneyRequestedRejected)
                : undefined;
        message.moneySentExpired =
            (object.moneySentExpired !== undefined && object.moneySentExpired !== null)
                ? exports.MoneySentExpired.fromPartial(object.moneySentExpired)
                : undefined;
        message.moneySentLimitExceeded =
            (object.moneySentLimitExceeded !== undefined && object.moneySentLimitExceeded !== null)
                ? exports.MoneySentLimitExceeded.fromPartial(object.moneySentLimitExceeded)
                : undefined;
        message.offerRewardReceived =
            (object.offerRewardReceived !== undefined && object.offerRewardReceived !== null)
                ? exports.OfferRewardReceived.fromPartial(object.offerRewardReceived)
                : undefined;
        message.offerWillExpire =
            (object.offerWillExpire !== undefined && object.offerWillExpire !== null)
                ? exports.OfferWillExpire.fromPartial(object.offerWillExpire)
                : undefined;
        message.otpRecovery = (object.otpRecovery !== undefined && object.otpRecovery !== null)
            ? exports.OtpRecovery.fromPartial(object.otpRecovery)
            : undefined;
        message.otpRequested = (object.otpRequested !== undefined && object.otpRequested !== null)
            ? exports.OtpRequested.fromPartial(object.otpRequested)
            : undefined;
        message.otpVerification =
            (object.otpVerification !== undefined && object.otpVerification !== null)
                ? exports.OtpVerification.fromPartial(object.otpVerification)
                : undefined;
        message.outOfNetworkAtmWithdrawalAuthorized =
            (object.outOfNetworkAtmWithdrawalAuthorized !== undefined &&
                object.outOfNetworkAtmWithdrawalAuthorized !== null)
                ? exports.OutOfNetworkAtmWithdrawalAuthorized.fromPartial(object.outOfNetworkAtmWithdrawalAuthorized)
                : undefined;
        message.outstandingBill =
            (object.outstandingBill !== undefined && object.outstandingBill !== null)
                ? exports.OutstandingBill.fromPartial(object.outstandingBill)
                : undefined;
        message.paymentCycleReminder =
            (object.paymentCycleReminder !== undefined && object.paymentCycleReminder !== null)
                ? exports.PaymentCycleReminder.fromPartial(object.paymentCycleReminder)
                : undefined;
        message.plaidExchangeLink =
            (object.plaidExchangeLink !== undefined && object.plaidExchangeLink !== null)
                ? exports.PlaidExchangeLink.fromPartial(object.plaidExchangeLink)
                : undefined;
        message.plusTierEnrolled =
            (object.plusTierEnrolled !== undefined && object.plusTierEnrolled !== null)
                ? exports.PlusTierEnrolled.fromPartial(object.plusTierEnrolled)
                : undefined;
        message.plusTierEnrolledManagedUser =
            (object.plusTierEnrolledManagedUser !== undefined &&
                object.plusTierEnrolledManagedUser !== null)
                ? exports.PlusTierEnrolledManagedUser.fromPartial(object.plusTierEnrolledManagedUser)
                : undefined;
        message.purchaseCardLocked =
            (object.purchaseCardLocked !== undefined && object.purchaseCardLocked !== null)
                ? exports.PurchaseCardLocked.fromPartial(object.purchaseCardLocked)
                : undefined;
        message.recurringTransferAccountExpired =
            (object.recurringTransferAccountExpired !== undefined &&
                object.recurringTransferAccountExpired !== null)
                ? exports.RecurringTransferAccountExpired.fromPartial(object.recurringTransferAccountExpired)
                : undefined;
        message.recurringTransferReminder =
            (object.recurringTransferReminder !== undefined && object.recurringTransferReminder !== null)
                ? exports.RecurringTransferReminder.fromPartial(object.recurringTransferReminder)
                : undefined;
        message.recurringTransferFailed =
            (object.recurringTransferFailed !== undefined && object.recurringTransferFailed !== null)
                ? exports.RecurringTransferFailed.fromPartial(object.recurringTransferFailed)
                : undefined;
        message.recurringTransferInsufficientFunds =
            (object.recurringTransferInsufficientFunds !== undefined &&
                object.recurringTransferInsufficientFunds !== null)
                ? exports.RecurringTransferInsufficientFunds.fromPartial(object.recurringTransferInsufficientFunds)
                : undefined;
        message.recurringTransferSent =
            (object.recurringTransferSent !== undefined && object.recurringTransferSent !== null)
                ? exports.RecurringTransferSent.fromPartial(object.recurringTransferSent)
                : undefined;
        message.redeemerReward = (object.redeemerReward !== undefined && object.redeemerReward !== null)
            ? exports.RedeemerReward.fromPartial(object.redeemerReward)
            : undefined;
        message.refereeReminder =
            (object.refereeReminder !== undefined && object.refereeReminder !== null)
                ? exports.RefereeReminder.fromPartial(object.refereeReminder)
                : undefined;
        message.referralBonus = (object.referralBonus !== undefined && object.referralBonus !== null)
            ? exports.ReferralBonus.fromPartial(object.referralBonus)
            : undefined;
        message.referralInvite = (object.referralInvite !== undefined && object.referralInvite !== null)
            ? exports.ReferralInvite.fromPartial(object.referralInvite)
            : undefined;
        message.referralRedemptionReminder =
            (object.referralRedemptionReminder !== undefined &&
                object.referralRedemptionReminder !== null)
                ? exports.ReferralRedemptionReminder.fromPartial(object.referralRedemptionReminder)
                : undefined;
        message.referralReward = (object.referralReward !== undefined && object.referralReward !== null)
            ? exports.ReferralReward.fromPartial(object.referralReward)
            : undefined;
        message.savingsInterest =
            (object.savingsInterest !== undefined && object.savingsInterest !== null)
                ? exports.SavingsInterest.fromPartial(object.savingsInterest)
                : undefined;
        message.savingsContributionMatched =
            (object.savingsContributionMatched !== undefined &&
                object.savingsContributionMatched !== null)
                ? exports.SavingsContributionMatched.fromPartial(object.savingsContributionMatched)
                : undefined;
        message.savingsContributionMatchDeclined =
            (object.savingsContributionMatchDeclined !== undefined &&
                object.savingsContributionMatchDeclined !== null)
                ? exports.SavingsContributionMatchDeclined.fromPartial(object.savingsContributionMatchDeclined)
                : undefined;
        message.sponseeAddedDebitCard =
            (object.sponseeAddedDebitCard !== undefined && object.sponseeAddedDebitCard !== null)
                ? exports.SponseeAddedDebitCard.fromPartial(object.sponseeAddedDebitCard)
                : undefined;
        message.sponseeClosedSavingsGoalWithMatching =
            (object.sponseeClosedSavingsGoalWithMatching !== undefined &&
                object.sponseeClosedSavingsGoalWithMatching !== null)
                ? exports.SponseeClosedSavingsGoalWithMatching.fromPartial(object.sponseeClosedSavingsGoalWithMatching)
                : undefined;
        message.sponseeCreatedSavingsGoal =
            (object.sponseeCreatedSavingsGoal !== undefined && object.sponseeCreatedSavingsGoal !== null)
                ? exports.SponseeCreatedSavingsGoal.fromPartial(object.sponseeCreatedSavingsGoal)
                : undefined;
        message.sponseeLeftFamily =
            (object.sponseeLeftFamily !== undefined && object.sponseeLeftFamily !== null)
                ? exports.SponseeLeftFamily.fromPartial(object.sponseeLeftFamily)
                : undefined;
        message.sponseeTurnedOffSavingsMatching =
            (object.sponseeTurnedOffSavingsMatching !== undefined &&
                object.sponseeTurnedOffSavingsMatching !== null)
                ? exports.SponseeTurnedOffSavingsMatching.fromPartial(object.sponseeTurnedOffSavingsMatching)
                : undefined;
        message.sponsorAcceptedSavingsMatching =
            (object.sponsorAcceptedSavingsMatching !== undefined &&
                object.sponsorAcceptedSavingsMatching !== null)
                ? exports.SponsorAcceptedSavingsMatching.fromPartial(object.sponsorAcceptedSavingsMatching)
                : undefined;
        message.sponsorCreatedSavingsGoal =
            (object.sponsorCreatedSavingsGoal !== undefined && object.sponsorCreatedSavingsGoal !== null)
                ? exports.SponsorCreatedSavingsGoal.fromPartial(object.sponsorCreatedSavingsGoal)
                : undefined;
        message.sponsorTurnedOffSavingsMatching =
            (object.sponsorTurnedOffSavingsMatching !== undefined &&
                object.sponsorTurnedOffSavingsMatching !== null)
                ? exports.SponsorTurnedOffSavingsMatching.fromPartial(object.sponsorTurnedOffSavingsMatching)
                : undefined;
        message.startedRedemption =
            (object.startedRedemption !== undefined && object.startedRedemption !== null)
                ? exports.StartedRedemption.fromPartial(object.startedRedemption)
                : undefined;
        message.stepBlackSubscribed =
            (object.stepBlackSubscribed !== undefined && object.stepBlackSubscribed !== null)
                ? exports.StepBlackSubscribed.fromPartial(object.stepBlackSubscribed)
                : undefined;
        message.stockDayTradeDetected =
            (object.stockDayTradeDetected !== undefined && object.stockDayTradeDetected !== null)
                ? exports.StockDayTradeDetected.fromPartial(object.stockDayTradeDetected)
                : undefined;
        message.stockGraduationTransferSuccess =
            (object.stockGraduationTransferSuccess !== undefined &&
                object.stockGraduationTransferSuccess !== null)
                ? exports.StockGraduationTransferSuccess.fromPartial(object.stockGraduationTransferSuccess)
                : undefined;
        message.stockOrderCancelled =
            (object.stockOrderCancelled !== undefined && object.stockOrderCancelled !== null)
                ? exports.StockOrderCancelled.fromPartial(object.stockOrderCancelled)
                : undefined;
        message.stockOrderFilled =
            (object.stockOrderFilled !== undefined && object.stockOrderFilled !== null)
                ? exports.StockOrderFilled.fromPartial(object.stockOrderFilled)
                : undefined;
        message.stockOrderRejected =
            (object.stockOrderRejected !== undefined && object.stockOrderRejected !== null)
                ? exports.StockOrderRejected.fromPartial(object.stockOrderRejected)
                : undefined;
        message.stockRiskLevelUpdate =
            (object.stockRiskLevelUpdate !== undefined && object.stockRiskLevelUpdate !== null)
                ? exports.StockRiskLevelUpdate.fromPartial(object.stockRiskLevelUpdate)
                : undefined;
        message.stockSponseeApproved =
            (object.stockSponseeApproved !== undefined && object.stockSponseeApproved !== null)
                ? exports.StockSponseeApproved.fromPartial(object.stockSponseeApproved)
                : undefined;
        message.subscriptionMerchantCardUpdated =
            (object.subscriptionMerchantCardUpdated !== undefined &&
                object.subscriptionMerchantCardUpdated !== null)
                ? exports.SubscriptionMerchantCardUpdated.fromPartial(object.subscriptionMerchantCardUpdated)
                : undefined;
        message.subscriptionRenewalFailed =
            (object.subscriptionRenewalFailed !== undefined && object.subscriptionRenewalFailed !== null)
                ? exports.SubscriptionRenewalFailed.fromPartial(object.subscriptionRenewalFailed)
                : undefined;
        message.unlockCard = (object.unlockCard !== undefined && object.unlockCard !== null)
            ? exports.UnlockCard.fromPartial(object.unlockCard)
            : undefined;
        message.unrecognizedDeviceLogin =
            (object.unrecognizedDeviceLogin !== undefined && object.unrecognizedDeviceLogin !== null)
                ? exports.UnrecognizedDeviceLogin.fromPartial(object.unrecognizedDeviceLogin)
                : undefined;
        message.withdrawReturn = (object.withdrawReturn !== undefined && object.withdrawReturn !== null)
            ? exports.WithdrawReturn.fromPartial(object.withdrawReturn)
            : undefined;
        message.testMessage = (object.testMessage !== undefined && object.testMessage !== null)
            ? exports.TestMessage.fromPartial(object.testMessage)
            : undefined;
        return message;
    },
};
function purchaseTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID':
            return PurchaseType.INVALID;
        case 1:
        case 'CASH':
            return PurchaseType.CASH;
        case 2:
        case 'CREDIT':
            return PurchaseType.CREDIT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PurchaseType.UNRECOGNIZED;
    }
}
exports.purchaseTypeFromJSON = purchaseTypeFromJSON;
function purchaseTypeToJSON(object) {
    switch (object) {
        case PurchaseType.INVALID:
            return 'INVALID';
        case PurchaseType.CASH:
            return 'CASH';
        case PurchaseType.CREDIT:
            return 'CREDIT';
        case PurchaseType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.purchaseTypeToJSON = purchaseTypeToJSON;
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1_000).toString();
    const nanos = (date.getTime() % 1_000) * 1_000_000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
    millis += (t.nanos || 0) / 1_000_000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return toTimestamp(o);
    }
    else if (typeof o === 'string') {
        return toTimestamp(new globalThis.Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=notification-messages.js.map